export const customerSupportJson = {

  "uid": "5f8cbbf4-2220-4f42-aacd-d6d903b33535",
  "componentName": "CustomerSupport",
  "dataSource": "{1F32C85B-B434-4975-B44C-EC1F949DAE71}",
  "params": {
    "buttonAlignment": "left",
    "variant": "base",
    "numberOfColumns": "three",
    "backgroundColor": "orange",
    "paddingTop": "Large",
    "paddingBottom": "Large"
  },
  "fields": {
    "supportIcon": {
      "id": "0853a008-9b3c-4a10-98b9-1e96a3cdc253",
      "fieldType": "Droplink",
      "fieldName": "supportIcon",
      "url": "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/call",
      "fields": {
        "value": {
          "value": "call"
        },
        "key": {
          "value": "Call"
        }
      }
    },
    "title": {
      "value": "Find out more"
    },
    "description": {
      "value": "Can’t decide which product is right for you? Want to get more information? Select one of the options below."
    },
    "supportOptions": [
      {
        "id": "3dad79cb-74da-4857-a6ef-15ba26659dx31",
        "fields": {
          "contactNumber": {
            "value": "1300137988"
          },
          "subTitle": {
            "value": "You can call us Mon – Fri, 9am – 6pm (excluding weekends and public holidays)."
          },
          "icon": {
            "value": {
              "src": "https://www.fwd.com.my/-/media/global/images/supports/call.svg?rev=130ad9d603204553871b4a784aa45e98",
              "alt": "call"
            }
          },
          "title": {
            "value": "Call 1300 13 7988"
          },
          "supportIcon": {
            "id": "0853a008-9b3c-4a10-98b9-1e96a3cdc253",
            "fieldType": "CustomDroplink",
            "fieldName": "supportIcon",
            "url": "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/call",
            "fields": {
              "value": {
                "value": "call"
              },
              "key": {
                "value": "Call"
              }
            }
          },
          "buttonIcon": {
            "id": "0853a008-9b3c-4a10-98b9-1e96a3cdc253",
            "fieldType": "CustomDroplink",
            "fieldName": "buttonIcon",
            "url": "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/call",
            "fields": {
              "value": {
                "value": "call"
              },
              "key": {
                "value": "Call"
              }
            }
          },
          "link": {
            "value": {
              "href": "http://tel:1300137988",
              "text": "Call 1300 13 7988",
              "linktype": "external",
              "url": "http://tel:1300137988",
              "anchor": "",
              "target": ""
            }
          },
          "buttonMode": {
            "id": "02a5a5c7-c318-4919-b773-86a65ba98969",
            "fieldType": "Droplink",
            "fieldName": "buttonMode",
            "url": "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/button-mode/simple-link",
            "fields": {
              "value": {
                "value": "SimpleLink"
              },
              "key": {
                "value": "SimpleLink"
              }
            }
          },
          "linkGALabelName": {
            "value": ""
          },
          "listType": {
            "id": "a5bee68c-8e43-4f78-8d15-d42982fd053a",
            "fieldType": "Droplink",
            "fieldName": "listType",
            "url": "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linklisttype/call",
            "fields": {
              "value": {
                "value": "Call"
              },
              "key": {
                "value": "call"
              }
            }
          }
        }
      },
      {
        "id": "fa474e72-7f95-4e39-9042-6faf72a01f69",
        "fields": {
          "medalliaForm": {
            "value": ""
          },
          "title": {
            "value": "Leave us a message"
          },
          "icon": {
            "value": {}
          },
          "subTitle": {
            "value": "Send us your enquiries. We'll get back to you shortly."
          },
          "supportIcon": {
            "id": "f35ed9fd-ad24-494a-8fb6-33be8955a85d",
            "fieldType": "CustomDroplink",
            "fieldName": "supportIcon",
            "url": "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/call-email",
            "fields": {
              "value": {
                "value": "call-email"
              },
              "key": {
                "value": "callEmail"
              }
            }
          },
          "listType": {
            "id": "f281af72-fa4b-4f87-98f1-4b9d77180e60",
            "fieldType": "Droplink",
            "fieldName": "listType",
            "url": "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linklisttype/generic_link",
            "fields": {
              "value": {
                "value": "Generic Link"
              },
              "key": {
                "value": "generic_link"
              }
            }
          },
          "buttonIcon": {
            "id": "f35ed9fd-ad24-494a-8fb6-33be8955a85d",
            "fieldType": "CustomDroplink",
            "fieldName": "buttonIcon",
            "url": "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/call-email",
            "fields": {
              "value": {
                "value": "call-email"
              },
              "key": {
                "value": "callEmail"
              }
            }
          },
          "link": {
            "value": {
              "text": "Open contact form",
              "linktype": "form",
              "title": "enquiry",
              "querystring": "enquiry",
              "target": "",
              "id": "{D048F950-F6F5-401D-8FD4-6825D1B4413E}",
              "href": "https://www.fwd.com.my/formslist/general-enquiry-form"
            }
          },
          "buttonMode": {
            "id": "02a5a5c7-c318-4919-b773-86a65ba98969",
            "fieldType": "Droplink",
            "fieldName": "buttonMode",
            "url": "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/button-mode/simple-link",
            "fields": {
              "value": {
                "value": "SimpleLink"
              },
              "key": {
                "value": "SimpleLink"
              }
            }
          },
          "linkGALabelName": {
            "value": ""
          }
        }
      }
    ],
    "buttonIcon": {
      "id": "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
      "fieldType": "CustomDroplink",
      "fieldName": "buttonIcon",
      "url": "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/link",
      "fields": {
        "value": {
          "value": "arrow-right"
        },
        "key": {
          "value": "Link"
        }
      }
    },
    "link": {
      "value": {
        "href": "https://www.fwd.com.my/support/#customer-support",
        "text": "Show me all support options",
        "anchor": "customer-support",
        "linktype": "internal",
        "class": "",
        "title": "",
        "target": "",
        "querystring": "",
        "id": "{7D817917-32F5-4221-9CD4-88CFE7E7C4C0}"
      }
    },
    "buttonMode": {
      "id": "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
      "fieldType": "Droplink",
      "fieldName": "buttonMode",
      "url": "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/button-mode/primary",
      "fields": {
        "value": {
          "value": "Primary"
        },
        "key": {
          "value": "Primary"
        }
      }
    },
    "linkGALabelName": {
      "value": ""
    },
    "gaLabelName": {
      "value": ""
    },
    "gaCategoryName": {
      "value": ""
    }
  }
  ,
  callbackForm: {
    sitecoreContext: {
      context: {
        pageEditing: false,
        site: { name: "fwd-my" },
        pageState: "normal",
        language: "en",
        languageCode: "en",
        defaultLanguage: "en",
        siteSettings: {
          productListPage: "https://www.fwd.com.my/products/",
          splashPage: "",
          articleTagLink: "",
          articleTypeDesign: [],
          articleOverlineText: false,
          globalMetaText: "FWD Malaysia",
          globalMetaTag: "",
          cookieMessage:
            '<p>We use cookies to give the best possible web experience. By continuing to use our website we assume you accept how we use cookies and your data.</p>\n<p>This in keeping with our&nbsp;<a href="https://www.fwd.com.my/tkfl-privacy-policy/">Privacy Policy</a>&nbsp;and <a href="https://www.fwd.com.my/cookie-policy">Cookie Policy</a></p>\n<p>&nbsp;</p>',
          cookieTimeStamp: "10",
          currencyPlacement: "BeforeNumericals",
          currencyWhitespace: true,
          currencySeparator: { value: {} },
          currencyLabel: { value: {} },
          splashPageUpdatedDuration: "10",
          splashPageUpdatedDate: "",
          faviconImageUrl:
            "https://www.fwd.com.my/-/media/global/images/icons/favicon.ico?rev=51cce1bfcfb347b3b2fc7d304180401d",
          productErrorPictogramUrl: "",
          dateFormat: "D MMMM YYYY",
          enablePlanCardSharePostCalc: "",
          sessionTimeout: "20",
          loaderTimeout: "",
          gAID: "GTM-55K4V3S",
          gTMID: "GTM-55K4V3S",
          gtmParamters: [],
          optimize360: true,
          hostName: "https://web.fwd.com.my",
          enableBackToTopButton: 1,
          dialogSessionTimeout: "",
          productFallbackCTA: {
            value: {
              href: "https://www.fwd.com.my/formslist/product-enquiry-form",
              text: "Enquire",
              anchor: "",
              linkType: "form",
              title: "",
              queryString: "enquiry",
              id: "{D048F950-F6F5-401D-8FD4-6825D1B4413E}",
              gaLabel: "",
            },
          },
          brightcoveAccountID: "5650355171001",
          languageIcon: {},
          enableMultipleNotifications: true,
          hidePrimaryLanguage: true,
          currencyGALabelName: "",
          showArticleSubtitle: false,
          hasArticleSubtitleFallback: false,
        },
        share: {
          socialApps: [
            {
              facebook: {
                header: { value: "Share on Facebook" },
                toolTip: { value: "" },
                url: {
                  value: {
                    href: "https://www.facebook.com/sharer.php?u=",
                    text: "Facebook Url",
                    linktype: "external",
                    url: "https://www.facebook.com/sharer.php?u=",
                    anchor: "",
                    target: "",
                  },
                },
              },
            },
            {
              twitter: {
                header: { value: "Share on Twitter" },
                toolTip: { value: "" },
                url: {
                  value: {
                    href: "https://twitter.com/intent/tweet?text=",
                    text: "Twitter Url",
                    linktype: "external",
                    url: "https://twitter.com/intent/tweet?text=",
                    anchor: "",
                    target: "",
                  },
                },
              },
            },
            {
              whatsapp: {
                header: { value: "Share on WhatsApp" },
                toolTip: { value: "" },
                url: {
                  value: {
                    href: "https://whatsapp://send?text=",
                    text: "WhatsApp Url",
                    linktype: "external",
                    url: "https://whatsapp://send?text=",
                    anchor: "",
                    target: "",
                  },
                },
              },
            },
          ],
        },
        siteNotifications: { notifications: [] },
        dialogModals: { modalList: [] },
        disclosurePopups: { popupList: [] },
        localizedPages: [
          { en: "https://www.fwd.com.my/products/investments/invest-first-education" },
        ],
        isRequestFromExternalSource: true,
        availableLanguages: ["en"],
      },
      route: {
        name: "invest-first-education",
        displayName: "invest first education",
        fields: {
          parameters: { value: {} },
          productTitle: { value: "FWD Invest First – Education Plan" },
          isFeatured: { value: false },
          productDescription: {
            value:
              "FWD Invest First’s education plan grows your savings and protects your wealth, so you can invest more in your kid's education without debt burdens. Learn more.",
          },
          productCode: { value: "" },
          maxAge: { value: "" },
          minAge: { value: "" },
          eCommerce: { value: false },
          ctaLink: { value: {} },
          ctaLinkGALabelName: { value: "" },
          promotionLabel: null,
          purchaseMethod: [
            {
              id: "bb6a7ff4-ea00-4e9f-bf7a-eb3b382af1a8",
              fields: {
                searchName: { value: "FWD agent" },
                name: { value: "FWD agents" },
                articlePillarPage: { value: "" },
                image: { value: {} },
                mobileImage: { value: {} },
                filterBy: null,
              },
            },
          ],
          secondaryNeedTags: [
            {
              id: "a290e5d9-6059-4f33-b7cb-39cf1b157c23",
              fields: {
                searchName: { value: "family" },
                name: { value: "family" },
                articlePillarPage: { value: "" },
                image: { value: {} },
                mobileImage: { value: {} },
                filterBy: null,
              },
            },
            {
              id: "bece94cd-7a46-464c-8c9c-baacb875260d",
              fields: {
                searchName: { value: "flexible contributions" },
                name: { value: "flexible contributions" },
                articlePillarPage: { value: "" },
                image: { value: {} },
                mobileImage: { value: {} },
                filterBy: null,
              },
            },
            {
              id: "8b4a8c53-e71c-4162-afdf-8ddb211560a3",
              fields: {
                searchName: { value: "contributions waived" },
                name: { value: "contributions waived" },
                articlePillarPage: { value: "" },
                image: { value: {} },
                mobileImage: { value: {} },
                filterBy: null,
              },
            },
            {
              id: "30937fd7-3d80-4e6d-880f-d352da01bd2e",
              fields: {
                searchName: { value: "legacy" },
                name: { value: "legacy" },
                articlePillarPage: { value: "" },
                image: { value: {} },
                mobileImage: { value: {} },
                filterBy: null,
              },
            },
            {
              id: "8d597bc0-8202-4881-af02-5af9a08e2537",
              fields: {
                searchName: { value: "dividends" },
                name: { value: "dividends" },
                articlePillarPage: { value: "" },
                image: { value: {} },
                mobileImage: { value: {} },
                filterBy: null,
              },
            },
            {
              id: "81190fef-9d0b-46c5-94bf-d27412741c05",
              fields: {
                searchName: { value: "total & permanent disability" },
                name: { value: "total & permanent disability" },
                articlePillarPage: { value: "" },
                image: { value: {} },
                mobileImage: { value: {} },
                filterBy: null,
              },
            },
          ],
          promotionLabelIcon: null,
          contentType: {
            id: "93a3d5bf-3a4a-4e7d-89f6-6e43e5493663",
            fieldType: "Droplink",
            fieldName: "contentType",
            url: "https://www.fwd.com.my/content/tags/commontags/contenttype/product",
            fields: {
              searchName: { value: "Product" },
              name: { value: "Product" },
              articlePillarPage: { value: "" },
              image: { value: {} },
              mobileImage: { value: {} },
              filterBy: null,
            },
          },
          expectedInsuranceType: null,
          featuredTags: [
            {
              id: "9390ea7c-f580-4b54-aeeb-41ce7a03dc65",
              fields: {
                searchName: { value: "investments" },
                name: { value: "investments" },
                articlePillarPage: { value: "" },
                image: { value: {} },
                mobileImage: { value: {} },
                filterBy: null,
              },
            },
            {
              id: "a290e5d9-6059-4f33-b7cb-39cf1b157c23",
              fields: {
                searchName: { value: "family" },
                name: { value: "family" },
                articlePillarPage: { value: "" },
                image: { value: {} },
                mobileImage: { value: {} },
                filterBy: null,
              },
            },
            {
              id: "bece94cd-7a46-464c-8c9c-baacb875260d",
              fields: {
                searchName: { value: "flexible contributions" },
                name: { value: "flexible contributions" },
                articlePillarPage: { value: "" },
                image: { value: {} },
                mobileImage: { value: {} },
                filterBy: null,
              },
            },
          ],
          planComponent: {
            id: "da0b32b3-cca5-4ab3-84d8-ff7ca016e23c",
            fieldType: "Droplink",
            fieldName: "planComponent",
            url: "https://www.fwd.com.my/content/tags/productstags/plancomponent/product",
            fields: {
              searchName: { value: "Product" },
              name: { value: "Product" },
              articlePillarPage: { value: "" },
              image: { value: {} },
              mobileImage: { value: {} },
              filterBy: null,
            },
          },
          primaryNeedTags: [
            {
              id: "9390ea7c-f580-4b54-aeeb-41ce7a03dc65",
              fields: {
                searchName: { value: "investments" },
                name: { value: "investments" },
                articlePillarPage: { value: "" },
                image: { value: {} },
                mobileImage: { value: {} },
                filterBy: null,
              },
            },
          ],
          userType: [
            {
              id: "c79e5778-bcea-438e-b891-90d085bfc22f",
              fields: {
                searchName: { value: "Family" },
                name: { value: "Family" },
                articlePillarPage: { value: "" },
                image: { value: {} },
                mobileImage: { value: {} },
                filterBy: null,
              },
            },
            {
              id: "8589363d-d81c-4200-adf6-19ff1297bc15",
              fields: {
                searchName: { value: "Individual" },
                name: { value: "Individual" },
                articlePillarPage: { value: "" },
                image: { value: {} },
                mobileImage: { value: {} },
                filterBy: null,
              },
            },
          ],
          mobileImage: {
            value: {
              src: "https://www.fwd.com.my/-/media/images/new/product/invest-first-education-banner.jpg?rev=997ef915ab8a45db919fafff47648d98",
              x1: "https://www.fwd.com.my/-/media/images/new/product/invest-first-education-banner.jpg?rev=997ef915ab8a45db919fafff47648d98&cx=0.63&cy=0.23&cw=296&ch=99&hash=8709B5636BBE81B62B250D8FE00F7041",
              x2: "https://www.fwd.com.my/-/media/images/new/product/invest-first-education-banner.jpg?rev=997ef915ab8a45db919fafff47648d98&cx=0.63&cy=0.23&cw=592&ch=197&hash=0B87BF3751F2E56CF479385AB46706E6",
            },
          },
          calculationOptions: [],
          image: {
            value: {
              src: "https://www.fwd.com.my/-/media/images/new/product/invest-first-education-banner.jpg?rev=997ef915ab8a45db919fafff47648d98",
              x1: "https://www.fwd.com.my/-/media/images/new/product/invest-first-education-banner.jpg?rev=997ef915ab8a45db919fafff47648d98&cx=0.63&cy=0.34&cw=344&ch=115&hash=0BB3EB8E9EC745F1A3122B4FF71DD3A9",
              x2: "https://www.fwd.com.my/-/media/images/new/product/invest-first-education-banner.jpg?rev=997ef915ab8a45db919fafff47648d98&cx=0.63&cy=0.34&cw=688&ch=229&hash=B32C9C7AB904C2D18C3B553E7F5A0BFD",
            },
          },
          sumAssuredRange: { value: {} },
          maximumSumAssured: { value: "" },
          minimumSumAssured: { value: "" },
          premiumRange: { value: {} },
          maximumPremiumYearly: { value: "" },
          minimumPremiumYearly: { value: "" },
          exploreRiders: { value: false },
          associatedRiders: [],
          enableEnquiryForRiders: { value: false },
          scoreValue: { value: "" },
          Priority: { value: "1" },
          globalMetaTextSetting: null,
          pageType: {
            id: "4aedd376-1a25-4196-a978-72eb7b93d5db",
            fieldType: "Droplink",
            fieldName: "pageType",
            url: "https://www.fwd.com.my/components/pagetype/individual",
            fields: {
              value: { value: "Individual" },
              key: { value: "individual" },
            },
          },
          localizedPages: { value: {} },
          metadataTitle: { value: "FWD Invest First – Education Plan" },
          metadataDescription: {
            value:
              "FWD Invest First’s education plan grows your savings and protects your wealth, so you can invest more in your kid's education without debt burdens. Learn more.",
          },
          metadataKeywords: { value: "" },
          overwriteGlobalMetaTag: { value: false },
          additionalMetaTag: { value: "" },
          disableHTMLCache: { value: false },
          accrediationValue: null,
          accreditationMode: null,
          accreditationDescription: { value: "" },
          disableCompliance: { value: false },
          openGraphType: { value: "" },
          openGraphDescription: { value: "" },
          openGraphURL: { value: {} },
          openGraphImage: { value: {} },
          openGraphTitle: { value: "" },
          canonicalUrl: { value: "" },
          isPageSearchable: { value: true },
          hideInSitemap: { value: false },
          hideLocalizedVersion: { value: false },
          seoScript: { value: "" },
          excludedPlans: [],
          comparableProducts: [],
          compareLabel: { value: "Compare" },
          gaLabelName: { value: "" },
          gaCategoryName: { value: "" },
          riskDisclosure: null,
          isPageSearchableWithoutDisclosureAcceptance: { value: false },
          nonRiskDisclosure: null,
          sumAssuredPaymentMode: [],
          sumAssuredSelectionType: null,
          defaultSumAssuredPaymentMode: null,
          premiumSelectionType: {
            id: "5aafb9b3-c726-43c7-b42b-3d7cb583ef7a",
            fieldType: "Droplink",
            fieldName: "premiumSelectionType",
            url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/selection-types/stepper",
            fields: { value: { value: "Stepper" }, key: { value: "stepper" } },
          },
        },
        databaseName: "web",
        deviceId: "fe5d7fdf-89c0-4d99-9aa3-b5fbd009c9f3",
        itemId: "7913cbff-9d53-4442-bedf-750c01c9e146",
        itemLanguage: "en",
        itemVersion: 1,
        layoutId: "e60605a5-f4f9-479a-b992-741bce767b1d",
        templateId: "0ba5819e-97b4-4ed8-8f4c-2363603b4faf",
        templateName: "Product Page",
        placeholders: {
          "jss-metadata": [],
          "jss-header": [
            {
              uid: "f4401e93-3c44-4861-ae73-ae8f72a5c86f",
              componentName: "Header",
              dataSource: "{8903F482-BBC8-4A1D-B453-4372D0362FE7}",
              params: {
                backgroundColor: "white-orange",
                paddingTop: "None",
                paddingBottom: "None",
              },
              fields: {
                iconNavigationLinks: [
                  {
                    id: "81836702-d156-47bf-aaed-469966e67a67",
                    name: "Login",
                    displayName: "Login",
                    fields: {
                      enableDropdown: { value: true },
                      buttonIcon: null,
                      title: { value: "Login" },
                      link: { value: {} },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                    Children: [
                      {
                        id: "a780b20c-d043-4ca4-85bd-b269db8e03fb",
                        name: "Customer",
                        displayName: "Customer",
                        fields: {
                          buttonIcon: {
                            id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                            fieldType: "CustomDroplink",
                            fieldName: "buttonIcon",
                            url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/link",
                            fields: {
                              value: { value: "arrow-right" },
                              key: { value: "Link" },
                            },
                          },
                          title: { value: "Customer" },
                          link: {
                            value: {
                              href: "https://www.fwd.com.my/myPortal/ ",
                              text: "Customer",
                              linktype: "external",
                              url: "https://www.fwd.com.my/myPortal/ ",
                              anchor: "",
                              title: "Customer",
                              target: "",
                            },
                          },
                          listType: {
                            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                            fieldType: "Droplink",
                            fieldName: "listType",
                            url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                            fields: {
                              value: { value: "Generic Link" },
                              key: { value: "generic_link" },
                            },
                          },
                          gaLabelName: { value: "" },
                          gaCategoryName: { value: "" },
                        },
                      },
                      {
                        id: "cf4ad6f1-b0a5-4991-ba3d-a65f656137c1",
                        name: "Agent",
                        displayName: "Agent",
                        fields: {
                          buttonIcon: {
                            id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                            fieldType: "CustomDroplink",
                            fieldName: "buttonIcon",
                            url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/link",
                            fields: {
                              value: { value: "arrow-right" },
                              key: { value: "Link" },
                            },
                          },
                          title: { value: "Agent" },
                          link: {
                            value: {
                              href: "https://www.fwd.com.my/fwdeiris/ ",
                              text: "Agent",
                              linktype: "external",
                              url: "https://www.fwd.com.my/fwdeiris/ ",
                              anchor: "",
                              title: "Agent",
                              target: "",
                            },
                          },
                          listType: {
                            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                            fieldType: "Droplink",
                            fieldName: "listType",
                            url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                            fields: {
                              value: { value: "Generic Link" },
                              key: { value: "generic_link" },
                            },
                          },
                          gaLabelName: { value: "" },
                          gaCategoryName: { value: "" },
                        },
                      },
                    ],
                  },
                  {
                    id: "f86a2012-d428-42c1-9b94-5c398a017b25",
                    name: "Call",
                    displayName: "Call",
                    fields: {
                      enableDropdown: { value: true },
                      buttonIcon: {
                        id: "0853a008-9b3c-4a10-98b9-1e96a3cdc253",
                        fieldType: "CustomDroplink",
                        fieldName: "buttonIcon",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/call",
                        fields: {
                          value: { value: "call" },
                          key: { value: "Call" },
                        },
                      },
                      title: { value: "" },
                      link: {
                        value: {
                          href: "http://tel:1300 13 7988",
                          linktype: "external",
                          url: "http://tel:1300 13 7988",
                          anchor: "",
                          target: "",
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "d39231cb-938a-4195-8747-a8f060976202",
                    name: "Search",
                    displayName: "Search",
                    fields: {
                      enableDropdown: { value: true },
                      buttonIcon: {
                        id: "8e6f2179-2d7b-420d-9d47-d13c408bb3c5",
                        fieldType: "CustomDroplink",
                        fieldName: "buttonIcon",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/search",
                        fields: {
                          value: { value: "search" },
                          key: { value: "Search" },
                        },
                      },
                      title: { value: "" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.my/search/",
                          text: "",
                          anchor: "",
                          linktype: "internal",
                          class: "",
                          title: "",
                          querystring: "",
                          id: "{0C2BF8C6-DD1F-4D4E-A985-8F10AF3C2873}",
                        },
                      },
                      listType: {
                        id: "b91e87f2-99cc-4a93-a0ba-3ee8c14f36a4",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/search",
                        fields: {
                          value: { value: "Search" },
                          key: { value: "search" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                ],
                headerNavigationLinks: [
                  {
                    id: "524bccb5-0257-4bc2-b789-d7cbafd46d5b",
                    name: "personal-insurance",
                    displayName: "Personal Insurance",
                    fields: {
                      buttonIcon: null,
                      title: { value: "Personal Insurance" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.my/products/",
                          id: "{A47026B3-7337-419C-A5CE-15D85CF877EB}",
                          querystring: "",
                          target: "",
                          text: "",
                          anchor: "",
                          title: "",
                          class: "",
                          linktype: "internal",
                        },
                      },
                      pageType: {
                        id: "4fded742-177c-4850-9853-fa31cc47d63e",
                        fieldType: "Droptree",
                        fieldName: "pageType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/fwd-hk/components/pagetype/individual",
                        fields: {
                          value: { value: "Individual" },
                          key: { value: "individual" },
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                    Children: [
                      {
                        id: "28df52b4-d626-4789-9391-d90e8aaa4835",
                        name: "Products",
                        displayName: "Products",
                        fields: {
                          buttonIcon: {
                            id: "19fcb2e6-0897-424f-9d15-b35209e646ed",
                            fieldType: "CustomDroplink",
                            fieldName: "buttonIcon",
                            url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/products",
                            fields: {
                              value: { value: "products" },
                              key: { value: "products" },
                            },
                          },
                          title: { value: "Products" },
                          link: {
                            value: {
                              href: "https://www.fwd.com/mys/products",
                              linktype: "external",
                              url: "https://www.fwd.com/mys/products",
                              anchor: "",
                              target: "",
                            },
                          },
                          pageType: null,
                          listType: {
                            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                            fieldType: "Droplink",
                            fieldName: "listType",
                            url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                            fields: {
                              value: { value: "Generic Link" },
                              key: { value: "generic_link" },
                            },
                          },
                          gaLabelName: { value: "" },
                          gaCategoryName: { value: "" },
                        },
                      },
                      {
                        id: "dcc3dea9-7d89-40c0-a516-bc8a3e35eb10",
                        name: "Claims",
                        displayName: "Claims",
                        fields: {
                          buttonIcon: {
                            id: "8ba0c144-7d03-426d-84a8-3329cca6784a",
                            fieldType: "CustomDroplink",
                            fieldName: "buttonIcon",
                            url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/claims",
                            fields: {
                              value: { value: "claims" },
                              key: { value: "claims" },
                            },
                          },
                          title: { value: "Claims" },
                          link: {
                            value: {
                              href: "https://www.fwd.com.my/claims/",
                              text: "",
                              anchor: "",
                              linktype: "internal",
                              class: "",
                              title: "",
                              target: "",
                              querystring: "",
                              id: "{176F0964-27C7-40B6-9DA5-54DA1C6CB59E}",
                            },
                          },
                          pageType: {
                            id: "4fded742-177c-4850-9853-fa31cc47d63e",
                            fieldType: "Droptree",
                            fieldName: "pageType",
                            url: "https://www.fwd.com.my/sitecore/content/fwd/fwd-hk/components/pagetype/individual",
                            fields: {
                              value: { value: "Individual" },
                              key: { value: "individual" },
                            },
                          },
                          listType: {
                            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                            fieldType: "Droplink",
                            fieldName: "listType",
                            url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                            fields: {
                              value: { value: "Generic Link" },
                              key: { value: "generic_link" },
                            },
                          },
                          gaLabelName: { value: "" },
                          gaCategoryName: { value: "" },
                        },
                      },
                      {
                        id: "a91417a7-7baa-4891-93da-478c31d2c3f3",
                        name: "Support",
                        displayName: "Support",
                        fields: {
                          buttonIcon: {
                            id: "79cc843a-2212-40b5-b09f-2018d04c72a9",
                            fieldType: "CustomDroplink",
                            fieldName: "buttonIcon",
                            url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/contact",
                            fields: {
                              value: { value: "contact" },
                              key: { value: "Contact" },
                            },
                          },
                          title: { value: "Support" },
                          link: {
                            value: {
                              href: "https://www.fwd.com.my/support/",
                              text: "Support",
                              anchor: "",
                              linktype: "internal",
                              class: "",
                              title: "Support",
                              querystring: "",
                              id: "{7D817917-32F5-4221-9CD4-88CFE7E7C4C0}",
                            },
                          },
                          pageType: {
                            id: "4fded742-177c-4850-9853-fa31cc47d63e",
                            fieldType: "Droptree",
                            fieldName: "pageType",
                            url: "https://www.fwd.com.my/sitecore/content/fwd/fwd-hk/components/pagetype/individual",
                            fields: {
                              value: { value: "Individual" },
                              key: { value: "individual" },
                            },
                          },
                          listType: {
                            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                            fieldType: "Droplink",
                            fieldName: "listType",
                            url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                            fields: {
                              value: { value: "Generic Link" },
                              key: { value: "generic_link" },
                            },
                          },
                          gaLabelName: { value: "" },
                          gaCategoryName: { value: "" },
                        },
                      },
                    ],
                  },
                  {
                    id: "0f4f24e0-81ca-4fc3-aed5-fbe527d2cbdd",
                    name: "about-us",
                    displayName: "About Us",
                    fields: {
                      buttonIcon: {
                        id: "a12ce2e2-a53a-455b-8c36-2050fedba642",
                        fieldType: "CustomDroplink",
                        fieldName: "buttonIcon",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/team",
                        fields: {
                          value: { value: "team" },
                          key: { value: "Team" },
                        },
                      },
                      title: { value: "About us" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.my/about-us/",
                          id: "{E29AE3B4-0EF7-4A19-94D0-5A773DA078BF}",
                          querystring: "",
                          target: "",
                          text: "",
                          anchor: "",
                          title: "",
                          class: "",
                          linktype: "internal",
                        },
                      },
                      pageType: {
                        id: "fb2c4a8a-0593-44b7-b7c4-ae07af4f8bb2",
                        fieldType: "Droptree",
                        fieldName: "pageType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/fwd-th/components/pagetype/individual",
                        fields: {
                          value: { value: "Individual" },
                          key: { value: "individual" },
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "6bf9bac4-e923-4d2e-aa9c-60abfddf35b9",
                    name: "Elite studio",
                    displayName: "Elite studio",
                    fields: {
                      buttonIcon: {
                        id: "625786bf-68f1-459d-ab9f-ce3c883e7af2",
                        fieldType: "CustomDroplink",
                        fieldName: "buttonIcon",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/career",
                        fields: {
                          value: { value: "career" },
                          key: { value: "career" },
                        },
                      },
                      title: { value: "Find an agent" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.my/elite-studio/",
                          linktype: "external",
                          url: "https://www.fwd.com.my/elite-studio/",
                          anchor: "",
                          target: "_blank",
                        },
                      },
                      pageType: {
                        id: "4aedd376-1a25-4196-a978-72eb7b93d5db",
                        fieldType: "Droptree",
                        fieldName: "pageType",
                        url: "https://www.fwd.com.my/components/pagetype/individual",
                        fields: {
                          value: { value: "Individual" },
                          key: { value: "individual" },
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                ],
                mobileLogo: {
                  value: {
                    src: "https://www.fwd.com.my/-/media/global/images/fwd-logo_colour.svg?rev=77f0e92219254f9caea8bbe5bba16478",
                    alt: "FWD logo svg",
                    x1: "https://www.fwd.com.my/-/media/global/images/fwd-logo_colour.svg?rev=77f0e92219254f9caea8bbe5bba16478&cx=0&cy=0&cw=160&ch=55&hash=3AF3D29B3D5E2EAFA3BE3C37BE360961",
                    x2: "https://www.fwd.com.my/-/media/global/images/fwd-logo_colour.svg?rev=77f0e92219254f9caea8bbe5bba16478&cx=0&cy=0&cw=320&ch=110&hash=D2514977A717BE6D04560201E1E90784",
                  },
                },
                logo: { value: {} },
                logoLink: {
                  value: {
                    href: "https://www.fwd.com/mys/home/",
                    linktype: "external",
                    url: "https://www.fwd.com/mys/home/",
                    anchor: "",
                    target: "",
                  },
                },
                headerLogo: { value: {} },
                countrySelector: [
                  {
                    id: "fc1eb478-c5ad-47a7-8aea-864133ac63db",
                    name: "FWD Group",
                    displayName: "FWD Group",
                    fields: {
                      isDefault: { value: false },
                      buttonIcon: null,
                      title: { value: "FWD Group" },
                      link: {
                        value: {
                          href: "https://www.fwd.com/",
                          text: "FWD Group",
                          linktype: "external",
                          url: "https://www.fwd.com/",
                          anchor: "",
                          target: "_blank",
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "2a8c3247-1efb-4c5c-9188-46aff2bc4af2",
                    name: "Cambodia",
                    displayName: "Cambodia",
                    fields: {
                      isDefault: { value: false },
                      buttonIcon: null,
                      title: { value: "Cambodia" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.kh/",
                          text: "Cambodia",
                          linktype: "external",
                          url: "https://www.fwd.com.kh/",
                          anchor: "",
                          target: "_blank",
                        },
                      },
                      listType: {
                        id: "f281af72-fa4b-4f87-98f1-4b9d77180e60",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "6155fb51-0c83-4f83-81a0-d3cc4c6915c1",
                    name: "Hong Kong",
                    displayName: "Hong Kong",
                    fields: {
                      isDefault: { value: false },
                      buttonIcon: null,
                      title: { value: "Hong Kong" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.hk/en/",
                          text: "Hong Kong",
                          linktype: "external",
                          url: "https://www.fwd.com.hk/en/",
                          anchor: "",
                          target: "_blank",
                        },
                      },
                      listType: {
                        id: "f281af72-fa4b-4f87-98f1-4b9d77180e60",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "b9a14c94-20c4-47c8-96da-d4ef066f66ec",
                    name: "Indonesia",
                    displayName: "Indonesia",
                    fields: {
                      isDefault: { value: false },
                      buttonIcon: null,
                      title: { value: "Indonesia" },
                      link: {
                        value: {
                          href: "https://www.fwd.co.id/",
                          text: "Indonesia",
                          linktype: "external",
                          url: "https://www.fwd.co.id/",
                          anchor: "",
                          target: "_blank",
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "c6a85dde-9c2e-40a0-b81a-b772285b262f",
                    name: "Japan",
                    displayName: "Japan",
                    fields: {
                      isDefault: { value: false },
                      buttonIcon: null,
                      title: { value: "Japan" },
                      link: {
                        value: {
                          href: "http://www.fwdlife.co.jp",
                          linktype: "external",
                          url: "http://www.fwdlife.co.jp",
                          anchor: "",
                          target: "",
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "68fb5672-9cfe-4c6e-b047-8837286a4d16",
                    name: "Macau",
                    displayName: "Macau",
                    fields: {
                      isDefault: { value: false },
                      buttonIcon: null,
                      title: { value: "Macau" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.vn/en/",
                          text: "Macau",
                          linktype: "external",
                          url: "https://www.fwd.com.vn/en/",
                          anchor: "",
                          target: "_blank",
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "6f4be9dc-4cfa-4ec3-bbe2-1f690c2342cc",
                    name: "Malaysia",
                    displayName: "Malaysia",
                    fields: {
                      isDefault: { value: true },
                      buttonIcon: null,
                      title: { value: "Malaysia" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.my/",
                          text: "",
                          anchor: "",
                          linktype: "internal",
                          class: "",
                          title: "",
                          querystring: "",
                          id: "{ED1C1C9C-BAFE-45EF-ABDD-C1BDE7D278BF}",
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "2efe1c70-1706-48dd-a7b6-13185fde4ecc",
                    name: "Philipines",
                    displayName: "Philipines",
                    fields: {
                      isDefault: { value: false },
                      buttonIcon: null,
                      title: { value: "Philipines" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.ph/",
                          text: "Philipines",
                          linktype: "external",
                          url: "https://www.fwd.com.ph/",
                          anchor: "",
                          target: "_blank",
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "875e163c-ffe8-4f80-be37-48221f095a82",
                    name: "Singapore",
                    displayName: "Singapore",
                    fields: {
                      isDefault: { value: false },
                      buttonIcon: null,
                      title: { value: "Singapore" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.sg/",
                          text: "Singapore",
                          linktype: "external",
                          url: "https://www.fwd.com.sg/",
                          anchor: "",
                          target: "_blank",
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "28ff0713-bc7c-49b1-b59b-dc5bd28e3c3c",
                    name: "Thailand",
                    displayName: "Thailand",
                    fields: {
                      isDefault: { value: false },
                      buttonIcon: null,
                      title: { value: "Thailand" },
                      link: {
                        value: {
                          href: "https://www.fwd.co.th/",
                          text: "Thailand",
                          linktype: "external",
                          url: "https://www.fwd.co.th/",
                          anchor: "",
                          target: "_blank",
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "44505fa1-98a3-4bf8-bfc3-d14ac8b51a48",
                    name: "Vietnam",
                    displayName: "Vietnam",
                    fields: {
                      isDefault: { value: false },
                      buttonIcon: null,
                      title: { value: "Vietnam" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.vn/en/",
                          text: "Vietnam",
                          linktype: "external",
                          url: "https://www.fwd.com.vn/en/",
                          anchor: "",
                          target: "_blank",
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                ],
                displayMode: {
                  id: "2c61b2e1-e1c4-4622-b814-1e458cf094b6",
                  fieldType: "Droplink",
                  fieldName: "displayMode",
                  url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/carouselmode/both",
                  fields: { value: { value: "Both" }, key: { value: "Both" } },
                },
                searchPageLink: {
                  value: {
                    href: "https://www.fwd.com.my/search/",
                    linktype: "internal",
                    id: "{0C2BF8C6-DD1F-4D4E-A985-8F10AF3C2873}",
                  },
                },
                pastSearchRecordsCount: { value: "8" },
                title: { value: "I'm looking for..." },
                placeholderText: { value: "Please enter a keyword or phrase" },
                enableLanguageToggle: { value: true },
                languageList: [
                  {
                    id: "440955d7-719b-4fe5-9d42-37fd2c4a9083",
                    fields: {
                      languageName: { value: "EN" },
                      defaultLanguage: { value: "Bm" },
                      languageCode: { value: "en" },
                    },
                  },
                ],
                languageModalDescription: {
                  value:
                    "We currently working to have this content in your language. You can choose to stay on this page, or proceed to explore other relevant content.",
                },
                languageModalLink: {
                  value: {
                    href: "https://www.fwd.com.my/",
                    linktype: "external",
                    url: "https://www.fwd.com.my/",
                    anchor: "",
                    target: "",
                  },
                },
                languageModalSecondaryLink: { value: "Stay on page" },
                languageModalTitle: {
                  value: "This content might not be in your language.",
                },
              },
            },
          ],
          "jss-main": [
            {
              uid: "28a80286-34da-4452-828e-3f83b1c89e57",
              componentName: "HeroBanner",
              dataSource: "{AA77F5F0-C5F4-428B-96FD-04B1051C3B14}",
              params: {
                backgroundColor: "white-orange",
                paddingTop: "Medium",
                paddingBottom: "Medium",
              },
              fields: {
                mobileImage: {
                  value: {
                    src: "https://www.fwd.com.my/-/media/images/new/product/invest-first-education-banner.jpg?rev=997ef915ab8a45db919fafff47648d98",
                    x1: "https://www.fwd.com.my/-/media/images/new/product/invest-first-education-banner.jpg?rev=997ef915ab8a45db919fafff47648d98&cx=0&cy=0&cw=360&ch=360&hash=8D3A16A5B888E1A8E7DA515C1871E858",
                    x2: "https://www.fwd.com.my/-/media/images/new/product/invest-first-education-banner.jpg?rev=997ef915ab8a45db919fafff47648d98&cx=0&cy=0&cw=720&ch=720&hash=9B9E9A6BB4DAF6BDC6D12D5418DE41A0",
                  },
                },
                image: {
                  value: {
                    src: "https://www.fwd.com.my/-/media/images/new/product/invest-first-education-banner.jpg?rev=997ef915ab8a45db919fafff47648d98",
                    x1: "https://www.fwd.com.my/-/media/images/new/product/invest-first-education-banner.jpg?rev=997ef915ab8a45db919fafff47648d98&cx=0&cy=0&cw=1366&ch=456&hash=A145EB8870126A0E92B87FCE415A364F",
                    x2: "https://www.fwd.com.my/-/media/images/new/product/invest-first-education-banner.jpg?rev=997ef915ab8a45db919fafff47648d98&cx=0&cy=0&cw=2732&ch=912&hash=F1355F4447E209AAD47FCC9555D15647",
                    x3: "https://www.fwd.com.my/-/media/images/new/product/invest-first-education-banner.jpg?rev=997ef915ab8a45db919fafff47648d98&cx=0&cy=0&cw=1200&ch=630&hash=C5B84473D54FBB41BCFFBA5A2B88B620",
                  },
                },
                enableHeading: { value: true },
                label: { value: "Investment-linked takaful plans" },
                subTitle: { value: "" },
                share: { value: false },
                title: { value: "FWD Invest First – Education Plan" },
                mediaType: {
                  id: "a537f571-3e6f-4cdd-a9f9-5093569c9c19",
                  fieldType: "Droplink",
                  fieldName: "mediaType",
                  url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/media-type/image",
                  fields: {
                    value: { value: "Image" },
                    key: { value: "Image" },
                  },
                },
                videoYouTubeID: { value: "" },
                videoLink: { value: null },
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: { value: {} },
                buttonMode: {
                  id: "02a5a5c7-c318-4919-b773-86a65ba98969",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/button-mode/simple-link",
                  fields: {
                    value: { value: "SimpleLink" },
                    key: { value: "SimpleLink" },
                  },
                },
                linkGALabelName: { value: "" },
                brightcoveVideo: null,
                gaLabelName: { value: "" },
                gaCategoryName: { value: "" },
              },
            },
            {
              uid: "2ba58923-288f-4dc1-8ceb-e582378e0df1",
              componentName: "ContentBlock",
              dataSource: "{2B97308C-D00C-4189-BFB2-5301084F379C}",
              params: {
                imageAlignment: "Right",
                showMediaOnMobile: "1",
                contentBlockType: "ls",
                contentBlockVariant: "default",
                backgroundColor: "white",
                paddingTop: "Medium",
                paddingBottom: "Medium",
              },
              fields: {
                mediaType: {
                  id: "a537f571-3e6f-4cdd-a9f9-5093569c9c19",
                  fieldType: "Droplink",
                  fieldName: "mediaType",
                  url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/media-type/image",
                  fields: {
                    value: { value: "Image" },
                    key: { value: "Image" },
                  },
                },
                enableFeaturedTags: { value: true },
                enablePurchaseChannels: { value: true },
                description: {
                  value:
                    "In a highly-competitive job market, we know that you want your child to be exceptional by giving them the best possible education. So we designed the FWD Invest First Education Plan to ensure that quality education doesn&rsquo;t equal debt and goes hand-in-hand with financial flexibility.",
                },
                subTitle: { value: "" },
                enableHeading: { value: false },
                title: { value: "Invest in knowledge for the best returns" },
                mobileImage: { value: {} },
                image: { value: {} },
                videoYouTubeID: { value: "" },
                videoLink: { value: null },
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: { value: {} },
                buttonMode: {
                  id: "02a5a5c7-c318-4919-b773-86a65ba98969",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/button-mode/simple-link",
                  fields: {
                    value: { value: "SimpleLink" },
                    key: { value: "SimpleLink" },
                  },
                },
                linkGALabelName: { value: "" },
                secondaryLinkButtonMode: {
                  id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                  fields: {
                    value: { value: "Secondary" },
                    key: { value: "Secondary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: { value: {} },
                secondaryLinkButtonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "secondaryLinkButtonIcon",
                  url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                gaLabelName: { value: "" },
                gaCategoryName: { value: "" },
                brightcoveVideo: null,
                featuredTags: [
                  {
                    id: "9390ea7c-f580-4b54-aeeb-41ce7a03dc65",
                    name: "investments",
                    displayName: "investments",
                    fields: {
                      searchName: { value: "investments" },
                      name: { value: "investments" },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      mobileImage: { value: {} },
                      filterBy: null,
                      link: {
                        value: {
                          href: "https://www.fwd.com.my/products/",
                          text: "investments",
                          anchor: "",
                          linktype: "internal",
                          title: "",
                          querystring: "?primaryNeed=investments",
                          id: "{A47026B3-7337-419C-A5CE-15D85CF877EB}",
                        },
                      },
                    },
                  },
                  {
                    id: "a290e5d9-6059-4f33-b7cb-39cf1b157c23",
                    name: "family",
                    displayName: "family",
                    fields: {
                      searchName: { value: "family" },
                      name: { value: "family" },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      mobileImage: { value: {} },
                      filterBy: null,
                      link: {
                        value: {
                          href: "https://www.fwd.com.my/products/",
                          text: "family",
                          anchor: "",
                          linktype: "internal",
                          title: "",
                          querystring: "?secondaryNeed=family",
                          id: "{A47026B3-7337-419C-A5CE-15D85CF877EB}",
                        },
                      },
                    },
                  },
                  {
                    id: "bece94cd-7a46-464c-8c9c-baacb875260d",
                    name: "flexible contributions",
                    displayName: "flexible contributions",
                    fields: {
                      searchName: { value: "flexible contributions" },
                      name: { value: "flexible contributions" },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      mobileImage: { value: {} },
                      filterBy: null,
                      link: {
                        value: {
                          href: "https://www.fwd.com.my/products/",
                          text: "flexible contributions",
                          anchor: "",
                          linktype: "internal",
                          title: "",
                          querystring: "?secondaryNeed=flexible contributions",
                          id: "{A47026B3-7337-419C-A5CE-15D85CF877EB}",
                        },
                      },
                    },
                  },
                ],
                purchaseMethod: [
                  {
                    id: "bb6a7ff4-ea00-4e9f-bf7a-eb3b382af1a8",
                    name: "fwd-agent",
                    displayName: "FWD agent",
                    fields: {
                      searchName: { value: "FWD agent" },
                      name: { value: "FWD agents" },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      mobileImage: { value: {} },
                      filterBy: null,
                      link: {
                        value: {
                          href: "https://www.fwd.com.my/products/",
                          text: "FWD agents",
                          anchor: "",
                          linktype: "internal",
                          title: "",
                          querystring: "?purchaseMethods=FWD agents",
                          id: "{A47026B3-7337-419C-A5CE-15D85CF877EB}",
                        },
                      },
                    },
                  },
                ],
              },
            },
            {
              uid: "308cb94e-75d0-4c08-91b2-46fed0cf5dcc",
              componentName: "ProductBenefits",
              dataSource: "{FEA9645F-87EC-4951-82BF-D1321E367490}",
              params: {
                paddingBottom: "Medium",
                paddingTop: "Medium",
                backgroundColor: "white",
              },
              fields: {
                benefitList: [
                  {
                    id: "7199adbc-695b-4663-8f52-ceaf57da062b",
                    fields: {
                      mobileImage: {
                        value: {
                          src: "https://www.fwd.com.my/-/media/images/pictograms-my/seed-financing.png?rev=7236465b2653498ebe415d319c0af0dc",
                          Large: {
                            x1: "https://www.fwd.com.my/-/media/images/pictograms-my/seed-financing.png?rev=7236465b2653498ebe415d319c0af0dc&cx=0&cy=0&cw=120&ch=120&hash=01315FC068E487D502EF5006AA754B1B",
                            x2: "https://www.fwd.com.my/-/media/images/pictograms-my/seed-financing.png?rev=7236465b2653498ebe415d319c0af0dc&cx=0&cy=0&cw=240&ch=240&hash=2749A80B29EFD8789388771EC70ECB84",
                          },
                          Small: {
                            x1: "https://www.fwd.com.my/-/media/images/pictograms-my/seed-financing.png?rev=7236465b2653498ebe415d319c0af0dc&cx=0&cy=0&cw=62&ch=62&hash=D9152A87AB2D219AE06D2526BF1016C4",
                            x2: "https://www.fwd.com.my/-/media/images/pictograms-my/seed-financing.png?rev=7236465b2653498ebe415d319c0af0dc&cx=0&cy=0&cw=124&ch=124&hash=558483952E26D0C5614696E1C9C804E4",
                          },
                        },
                      },
                      benefitTitle: { value: "Flexible access to your money" },
                      benefitDescription: {
                        value:
                          '<p class="p1" style="color: #000000; margin-right: 0px; margin-left: 0px;">Enjoy the flexibility to withdraw money from any fund either partially or on a regular basis - with no extra charges.</p>',
                      },
                      benefitImage: {
                        value: {
                          src: "https://www.fwd.com.my/-/media/images/pictograms-my/seed-financing.png?rev=7236465b2653498ebe415d319c0af0dc",
                          Large: {
                            x1: "https://www.fwd.com.my/-/media/images/pictograms-my/seed-financing.png?rev=7236465b2653498ebe415d319c0af0dc&cx=0&cy=0&cw=120&ch=120&hash=01315FC068E487D502EF5006AA754B1B",
                            x2: "https://www.fwd.com.my/-/media/images/pictograms-my/seed-financing.png?rev=7236465b2653498ebe415d319c0af0dc&cx=0&cy=0&cw=240&ch=240&hash=2749A80B29EFD8789388771EC70ECB84",
                          },
                          Small: {
                            x2: "https://www.fwd.com.my/-/media/images/pictograms-my/seed-financing.png?rev=7236465b2653498ebe415d319c0af0dc&cx=0&cy=0&cw=124&ch=124&hash=558483952E26D0C5614696E1C9C804E4",
                            x1: "https://www.fwd.com.my/-/media/images/pictograms-my/seed-financing.png?rev=7236465b2653498ebe415d319c0af0dc&cx=0&cy=0&cw=62&ch=62&hash=D9152A87AB2D219AE06D2526BF1016C4",
                          },
                        },
                      },
                      image: { value: {} },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "4fc0339a-00df-4781-bac8-fda70b3e3f8f",
                    fields: {
                      mobileImage: {
                        value: {
                          src: "https://www.fwd.com.my/-/media/images/pictograms-my/guaranteed-protection.png?rev=9f407dfe0a364013849b8ef0731847e7",
                          Large: {
                            x1: "https://www.fwd.com.my/-/media/images/pictograms-my/guaranteed-protection.png?rev=9f407dfe0a364013849b8ef0731847e7&cx=0&cy=0&cw=120&ch=120&hash=8986C2724C12CA9419992A0049C7CE3E",
                            x2: "https://www.fwd.com.my/-/media/images/pictograms-my/guaranteed-protection.png?rev=9f407dfe0a364013849b8ef0731847e7&cx=0&cy=0&cw=240&ch=240&hash=C029D844CDC7E5C2AC37088EB5A5510D",
                          },
                          Small: {
                            x1: "https://www.fwd.com.my/-/media/images/pictograms-my/guaranteed-protection.png?rev=9f407dfe0a364013849b8ef0731847e7&cx=0&cy=0&cw=62&ch=62&hash=3D81AD021A7AE7719DC2E27ABC1E4A24",
                            x2: "https://www.fwd.com.my/-/media/images/pictograms-my/guaranteed-protection.png?rev=9f407dfe0a364013849b8ef0731847e7&cx=0&cy=0&cw=124&ch=124&hash=1B8B4E37A06247AA1BBD069D69C08888",
                          },
                        },
                      },
                      benefitTitle: {
                        value: "Cover that automatically increases",
                      },
                      benefitDescription: {
                        value:
                          '<p class="p1" style="color: #000000; margin-right: 0px; margin-left: 0px;">We ensure that your plan keeps up with the times by offering coverage that automatically rises in line with inflation &ndash; meaning instant, extra cover.</p>',
                      },
                      benefitImage: {
                        value: {
                          src: "https://www.fwd.com.my/-/media/images/pictograms-my/guaranteed-protection.png?rev=9f407dfe0a364013849b8ef0731847e7",
                          Large: {
                            x1: "https://www.fwd.com.my/-/media/images/pictograms-my/guaranteed-protection.png?rev=9f407dfe0a364013849b8ef0731847e7&cx=0&cy=0&cw=120&ch=120&hash=8986C2724C12CA9419992A0049C7CE3E",
                            x2: "https://www.fwd.com.my/-/media/images/pictograms-my/guaranteed-protection.png?rev=9f407dfe0a364013849b8ef0731847e7&cx=0&cy=0&cw=240&ch=240&hash=C029D844CDC7E5C2AC37088EB5A5510D",
                          },
                          Small: {
                            x2: "https://www.fwd.com.my/-/media/images/pictograms-my/guaranteed-protection.png?rev=9f407dfe0a364013849b8ef0731847e7&cx=0&cy=0&cw=124&ch=124&hash=1B8B4E37A06247AA1BBD069D69C08888",
                            x1: "https://www.fwd.com.my/-/media/images/pictograms-my/guaranteed-protection.png?rev=9f407dfe0a364013849b8ef0731847e7&cx=0&cy=0&cw=62&ch=62&hash=3D81AD021A7AE7719DC2E27ABC1E4A24",
                          },
                        },
                      },
                      image: { value: {} },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "a3f01ba1-1ee8-4f09-90c5-a5284a9088e2",
                    fields: {
                      mobileImage: {
                        value: {
                          src: "https://www.fwd.com.my/-/media/images/pictograms-my/archievement-milestone.png?rev=4d7d58b66be440b59b7bac4194a92540",
                          Large: {
                            x1: "https://www.fwd.com.my/-/media/images/pictograms-my/archievement-milestone.png?rev=4d7d58b66be440b59b7bac4194a92540&cx=0&cy=0&cw=120&ch=120&hash=B264F014D76694ACA4BEB1CD370AE09B",
                            x2: "https://www.fwd.com.my/-/media/images/pictograms-my/archievement-milestone.png?rev=4d7d58b66be440b59b7bac4194a92540&cx=0&cy=0&cw=240&ch=240&hash=8A8E7A19219AE034768012B3AC4A2FD9",
                          },
                          Small: {
                            x1: "https://www.fwd.com.my/-/media/images/pictograms-my/archievement-milestone.png?rev=4d7d58b66be440b59b7bac4194a92540&cx=0&cy=0&cw=62&ch=62&hash=279B023E51C454808192662609DABAF0",
                            x2: "https://www.fwd.com.my/-/media/images/pictograms-my/archievement-milestone.png?rev=4d7d58b66be440b59b7bac4194a92540&cx=0&cy=0&cw=124&ch=124&hash=791D74531C40721E2D23C8FC32C7DD9F",
                          },
                        },
                      },
                      benefitTitle: {
                        value:
                          "A plan that celebrates the important milestones",
                      },
                      benefitDescription: {
                        value:
                          '<p class="p1" style="color: #000000; margin-right: 0px; margin-left: 0px;">Celebrating a marriage or having your first child? FWD Invest First offers event-based cover that increases throughout your life&rsquo;s journey.</p>',
                      },
                      benefitImage: {
                        value: {
                          src: "https://www.fwd.com.my/-/media/images/pictograms-my/archievement-milestone.png?rev=4d7d58b66be440b59b7bac4194a92540",
                          Large: {
                            x1: "https://www.fwd.com.my/-/media/images/pictograms-my/archievement-milestone.png?rev=4d7d58b66be440b59b7bac4194a92540&cx=0&cy=0&cw=120&ch=120&hash=B264F014D76694ACA4BEB1CD370AE09B",
                            x2: "https://www.fwd.com.my/-/media/images/pictograms-my/archievement-milestone.png?rev=4d7d58b66be440b59b7bac4194a92540&cx=0&cy=0&cw=240&ch=240&hash=8A8E7A19219AE034768012B3AC4A2FD9",
                          },
                          Small: {
                            x2: "https://www.fwd.com.my/-/media/images/pictograms-my/archievement-milestone.png?rev=4d7d58b66be440b59b7bac4194a92540&cx=0&cy=0&cw=124&ch=124&hash=791D74531C40721E2D23C8FC32C7DD9F",
                            x1: "https://www.fwd.com.my/-/media/images/pictograms-my/archievement-milestone.png?rev=4d7d58b66be440b59b7bac4194a92540&cx=0&cy=0&cw=62&ch=62&hash=279B023E51C454808192662609DABAF0",
                          },
                        },
                      },
                      image: { value: {} },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "011a36c6-094b-4839-8045-5bd78ca70c8d",
                    fields: {
                      mobileImage: {
                        value: {
                          src: "https://www.fwd.com.my/-/media/images/pictograms-my/open.png?rev=5a635997870e4e0693fa8eda5225f504",
                          Large: {
                            x1: "https://www.fwd.com.my/-/media/images/pictograms-my/open.png?rev=5a635997870e4e0693fa8eda5225f504&cx=0&cy=0&cw=120&ch=120&hash=04064C3A44997C08F47F3F0BB14D9337",
                            x2: "https://www.fwd.com.my/-/media/images/pictograms-my/open.png?rev=5a635997870e4e0693fa8eda5225f504&cx=0&cy=0&cw=240&ch=240&hash=2207D45B39524C9BF38C9ACCCE6FE302",
                          },
                          Small: {
                            x1: "https://www.fwd.com.my/-/media/images/pictograms-my/open.png?rev=5a635997870e4e0693fa8eda5225f504&cx=0&cy=0&cw=62&ch=62&hash=23DEEAEFA3782AC0DE5FB07B7A967F13",
                            x2: "https://www.fwd.com.my/-/media/images/pictograms-my/open.png?rev=5a635997870e4e0693fa8eda5225f504&cx=0&cy=0&cw=124&ch=124&hash=06F6B99C4708A72290F3E4CB1EF0731C",
                          },
                        },
                      },
                      benefitTitle: {
                        value: "Giving extra support when you need it",
                      },
                      benefitDescription: {
                        value:
                          '<p class="p1" style="color: #000000; margin-right: 0px; margin-left: 0px;">Our grief counsellors and experts provide support and legal advice to help you not just financially but emotionally as well.</p>',
                      },
                      benefitImage: {
                        value: {
                          src: "https://www.fwd.com.my/-/media/images/pictograms-my/open.png?rev=5a635997870e4e0693fa8eda5225f504",
                          Large: {
                            x1: "https://www.fwd.com.my/-/media/images/pictograms-my/open.png?rev=5a635997870e4e0693fa8eda5225f504&cx=0&cy=0&cw=120&ch=120&hash=04064C3A44997C08F47F3F0BB14D9337",
                            x2: "https://www.fwd.com.my/-/media/images/pictograms-my/open.png?rev=5a635997870e4e0693fa8eda5225f504&cx=0&cy=0&cw=240&ch=240&hash=2207D45B39524C9BF38C9ACCCE6FE302",
                          },
                          Small: {
                            x2: "https://www.fwd.com.my/-/media/images/pictograms-my/open.png?rev=5a635997870e4e0693fa8eda5225f504&cx=0&cy=0&cw=124&ch=124&hash=06F6B99C4708A72290F3E4CB1EF0731C",
                            x1: "https://www.fwd.com.my/-/media/images/pictograms-my/open.png?rev=5a635997870e4e0693fa8eda5225f504&cx=0&cy=0&cw=62&ch=62&hash=23DEEAEFA3782AC0DE5FB07B7A967F13",
                          },
                        },
                      },
                      image: { value: {} },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "e4585f99-4ca6-4299-891a-a4c7109731c5",
                    fields: {
                      mobileImage: {
                        value: {
                          src: "https://www.fwd.com.my/-/media/images/pictograms-my/claim-document.png?rev=fcad63f70c52413f95d307133a07ba3d",
                          Large: {
                            x1: "https://www.fwd.com.my/-/media/images/pictograms-my/claim-document.png?rev=fcad63f70c52413f95d307133a07ba3d&cx=0&cy=0&cw=120&ch=120&hash=37E1B053A9F092D2873BA2A3B99FC49C",
                            x2: "https://www.fwd.com.my/-/media/images/pictograms-my/claim-document.png?rev=fcad63f70c52413f95d307133a07ba3d&cx=0&cy=0&cw=240&ch=240&hash=9E5A05218807122BE2B9C5217086F6E7",
                          },
                          Small: {
                            x1: "https://www.fwd.com.my/-/media/images/pictograms-my/claim-document.png?rev=fcad63f70c52413f95d307133a07ba3d&cx=0&cy=0&cw=62&ch=62&hash=21CFF83394D89696C7228F4950145869",
                            x2: "https://www.fwd.com.my/-/media/images/pictograms-my/claim-document.png?rev=fcad63f70c52413f95d307133a07ba3d&cx=0&cy=0&cw=124&ch=124&hash=7FE71E09A83E2CB0CA8981D28FB011DB",
                          },
                        },
                      },
                      benefitTitle: {
                        value: "Transparent and no hidden clauses",
                      },
                      benefitDescription: {
                        value:
                          '<p class="p1" style="color: #000000; margin-right: 0px; margin-left: 0px;">We give you back what is due without hidden clauses or lien on child coverage.</p>',
                      },
                      benefitImage: {
                        value: {
                          src: "https://www.fwd.com.my/-/media/images/pictograms-my/claim-document.png?rev=fcad63f70c52413f95d307133a07ba3d",
                          Large: {
                            x1: "https://www.fwd.com.my/-/media/images/pictograms-my/claim-document.png?rev=fcad63f70c52413f95d307133a07ba3d&cx=0&cy=0&cw=120&ch=120&hash=37E1B053A9F092D2873BA2A3B99FC49C",
                            x2: "https://www.fwd.com.my/-/media/images/pictograms-my/claim-document.png?rev=fcad63f70c52413f95d307133a07ba3d&cx=0&cy=0&cw=240&ch=240&hash=9E5A05218807122BE2B9C5217086F6E7",
                          },
                          Small: {
                            x2: "https://www.fwd.com.my/-/media/images/pictograms-my/claim-document.png?rev=fcad63f70c52413f95d307133a07ba3d&cx=0&cy=0&cw=124&ch=124&hash=7FE71E09A83E2CB0CA8981D28FB011DB",
                            x1: "https://www.fwd.com.my/-/media/images/pictograms-my/claim-document.png?rev=fcad63f70c52413f95d307133a07ba3d&cx=0&cy=0&cw=62&ch=62&hash=21CFF83394D89696C7228F4950145869",
                          },
                        },
                      },
                      image: { value: {} },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "56245afa-151d-4b21-a709-3e34cf8875c5",
                    fields: {
                      mobileImage: {
                        value: {
                          src: "https://www.fwd.com.my/-/media/images/pictograms-my/cash.png?rev=dadbbd9c21624b52bcfea34e88ccb746",
                          Large: {
                            x1: "https://www.fwd.com.my/-/media/images/pictograms-my/cash.png?rev=dadbbd9c21624b52bcfea34e88ccb746&cx=0&cy=0&cw=120&ch=120&hash=459677CB96FA3124559B2EE0FADD9C45",
                            x2: "https://www.fwd.com.my/-/media/images/pictograms-my/cash.png?rev=dadbbd9c21624b52bcfea34e88ccb746&cx=0&cy=0&cw=240&ch=240&hash=93BA78815C77CDA8E2C0E42A6BA06681",
                          },
                          Small: {
                            x1: "https://www.fwd.com.my/-/media/images/pictograms-my/cash.png?rev=dadbbd9c21624b52bcfea34e88ccb746&cx=0&cy=0&cw=62&ch=62&hash=2E2B07B51742C13ED00091BB697D1EB1",
                            x2: "https://www.fwd.com.my/-/media/images/pictograms-my/cash.png?rev=dadbbd9c21624b52bcfea34e88ccb746&cx=0&cy=0&cw=124&ch=124&hash=3918E4C1257A2AB2ABF3ED5522F367CB",
                          },
                        },
                      },
                      benefitTitle: {
                        value: "Lump sum for non-Muslim customers",
                      },
                      benefitDescription: {
                        value:
                          '<p class="p1" style="color: #000000; margin-right: 0px; margin-left: 0px;">For our non-Muslim customers, we will pay a lump sum benefit of RM2,000 in lieu of Badal Hajj services.</p>',
                      },
                      benefitImage: {
                        value: {
                          src: "https://www.fwd.com.my/-/media/images/pictograms-my/cash.png?rev=dadbbd9c21624b52bcfea34e88ccb746",
                          Large: {
                            x1: "https://www.fwd.com.my/-/media/images/pictograms-my/cash.png?rev=dadbbd9c21624b52bcfea34e88ccb746&cx=0&cy=0&cw=120&ch=120&hash=459677CB96FA3124559B2EE0FADD9C45",
                            x2: "https://www.fwd.com.my/-/media/images/pictograms-my/cash.png?rev=dadbbd9c21624b52bcfea34e88ccb746&cx=0&cy=0&cw=240&ch=240&hash=93BA78815C77CDA8E2C0E42A6BA06681",
                          },
                          Small: {
                            x2: "https://www.fwd.com.my/-/media/images/pictograms-my/cash.png?rev=dadbbd9c21624b52bcfea34e88ccb746&cx=0&cy=0&cw=124&ch=124&hash=3918E4C1257A2AB2ABF3ED5522F367CB",
                            x1: "https://www.fwd.com.my/-/media/images/pictograms-my/cash.png?rev=dadbbd9c21624b52bcfea34e88ccb746&cx=0&cy=0&cw=62&ch=62&hash=2E2B07B51742C13ED00091BB697D1EB1",
                          },
                        },
                      },
                      image: { value: {} },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                ],
                gaLabelName: { value: "" },
                gaCategoryName: { value: "" },
              },
            },
            {
              uid: "d8d4220b-377a-4eef-b081-dec1469be5a7",
              componentName: "ProductPlanList",
              dataSource: "{7FA72DEF-F33C-4826-81CB-ED2698FFC114}",
              params: {
                backgroundColor: "orangeLight-white",
                paddingTop: "Large",
                paddingBottom: "Large",
              },
              fields: {
                calculateLinkGALabelName: { value: "" },
                subTitle: {
                  value:
                    "Take a closer look at the details - and compare with some of our other plans and products.",
                },
                planCards: [
                  {
                    id: "37470eb8-e976-4d64-9495-db32468c9269",
                    fields: {
                      productPlanOptionCd: { value: "" },
                      planCode: { value: "" },
                      cardAttributes: {
                        value: {
                          "Issue age":
                            "Certificate owner: 17 to 65 years old. Person covered: One month to 65 years old",
                          "Minimum monthly contribution": "RM100",
                          "Coverage term":
                            "Certificate owner: - . Person covered: ends at 25 years old",
                        },
                      },
                      cardTitle: {
                        value: "FWD Invest First – Education Plan (Option 1)",
                      },
                      key: { value: "" },
                      value: { value: "" },
                      minAge: { value: "" },
                      maxAge: { value: "" },
                      enableEnquiry: { value: true },
                      channel: { value: "E-Commerce" },
                      eCommerceSecondary: { value: false },
                      share: { value: true },
                      cardLabel: { value: "Product" },
                      title: {
                        value: "FWD Invest First – Education Plan (Option 1)",
                      },
                      description: { value: "" },
                      isFeatured: { value: false },
                      eCommercePrimary: { value: false },
                      link: {
                        value: {
                          text: "Enquire",
                          linktype: "form",
                          querystring: "enquiry",
                          target: "",
                          id: "{D048F950-F6F5-401D-8FD4-6825D1B4413E}",
                          href: "https://www.fwd.com.my/formslist/product-enquiry-form",
                        },
                      },
                      buttonIcon: null,
                      linkGALabelName: { value: "" },
                      buttonMode: {
                        id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                        fieldType: "Droplink",
                        fieldName: "buttonMode",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/button-mode/primary",
                        fields: {
                          value: { value: "Primary" },
                          key: { value: "Primary" },
                        },
                      },
                      minimumSumAssuredRule: [],
                      maximumSumAssured: { value: "" },
                      minimumSumAssured: { value: "" },
                      minimumPremiumYearly: { value: "" },
                      maximumPremiumYearly: { value: "" },
                      sumAssuredIndicativePrice: { value: "" },
                      isComparable: { value: false },
                      premiumIndicativePrice: { value: "" },
                      frequency: {
                        id: "a90aed14-a023-4680-b2be-a1999121d860",
                        fieldType: "Droplink",
                        fieldName: "frequency",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/premim-frequency/monthly",
                        fields: {
                          value: { value: "monthly" },
                          key: { value: "monthly|1" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                      secondaryLinkButtonMode: {
                        id: "02a5a5c7-c318-4919-b773-86a65ba98969",
                        fieldType: "Droplink",
                        fieldName: "secondaryLinkButtonMode",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/button-mode/simple-link",
                        fields: {
                          value: { value: "SimpleLink" },
                          key: { value: "SimpleLink" },
                        },
                      },
                      secondaryLinkGALabelName: { value: "" },
                      secondaryLink: { value: {} },
                      secondaryLinkButtonIcon: null,
                      uniqueId: "37470eb8e9764d649495db32468c9269",
                    },
                  },
                  {
                    id: "4be9e722-6911-422b-a021-98779f68bc7b",
                    fields: {
                      productPlanOptionCd: { value: "" },
                      planCode: { value: "" },
                      cardAttributes: {
                        value: {
                          "Issue age":
                            "Certificate owner: 17 to 65 years old. Person covered: One month to 65 years old",
                          "Minimum monthly contribution": "RM200",
                          "Coverage term":
                            "Certificate owner: - . Person covered: ends at 25 years old",
                        },
                      },
                      cardTitle: {
                        value: "FWD Invest First – Education Plan (Option 2)",
                      },
                      key: { value: "" },
                      value: { value: "" },
                      minAge: { value: "" },
                      maxAge: { value: "" },
                      enableEnquiry: { value: true },
                      channel: { value: "E-Commerce" },
                      eCommerceSecondary: { value: false },
                      share: { value: true },
                      cardLabel: { value: "Product" },
                      title: {
                        value: "FWD Invest First – Education Plan (Option 2)",
                      },
                      description: { value: "" },
                      isFeatured: { value: false },
                      eCommercePrimary: { value: false },
                      link: {
                        value: {
                          text: "Enquire",
                          linktype: "form",
                          querystring: "enquiry",
                          target: "",
                          id: "{D048F950-F6F5-401D-8FD4-6825D1B4413E}",
                          href: "https://www.fwd.com.my/formslist/product-enquiry-form",
                        },
                      },
                      buttonIcon: null,
                      linkGALabelName: { value: "" },
                      buttonMode: {
                        id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                        fieldType: "Droplink",
                        fieldName: "buttonMode",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/button-mode/primary",
                        fields: {
                          value: { value: "Primary" },
                          key: { value: "Primary" },
                        },
                      },
                      minimumSumAssuredRule: [],
                      maximumSumAssured: { value: "" },
                      minimumSumAssured: { value: "" },
                      minimumPremiumYearly: { value: "" },
                      maximumPremiumYearly: { value: "" },
                      sumAssuredIndicativePrice: { value: "" },
                      isComparable: { value: false },
                      premiumIndicativePrice: { value: "" },
                      frequency: null,
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                      secondaryLinkButtonMode: {
                        id: "02a5a5c7-c318-4919-b773-86a65ba98969",
                        fieldType: "Droplink",
                        fieldName: "secondaryLinkButtonMode",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/button-mode/simple-link",
                        fields: {
                          value: { value: "SimpleLink" },
                          key: { value: "SimpleLink" },
                        },
                      },
                      secondaryLinkGALabelName: { value: "" },
                      secondaryLink: { value: {} },
                      secondaryLinkButtonIcon: null,
                      uniqueId: "4be9e7226911422ba02198779f68bc7b",
                    },
                  },
                  {
                    id: "e0664b5f-e9c3-4b25-b44c-fcf7c03f990a",
                    fields: {
                      productPlanOptionCd: { value: "" },
                      planCode: { value: "" },
                      cardAttributes: {
                        value: {
                          "Issue age":
                            "Certificate owner: 17 to 65 years old. Person covered: One month to 65 years old",
                          "Minimum monthly contribution": "RM250",
                          "Coverage term":
                            "Certificate owner: - . Person covered: ends at age 25",
                        },
                      },
                      cardTitle: {
                        value: "FWD Invest First – Education Plan (Option 3)",
                      },
                      key: { value: "" },
                      value: { value: "" },
                      minAge: { value: "" },
                      maxAge: { value: "" },
                      enableEnquiry: { value: true },
                      channel: { value: "E-Commerce" },
                      eCommerceSecondary: { value: false },
                      share: { value: true },
                      cardLabel: { value: "Product" },
                      title: {
                        value: "FWD Invest First – Education Plan (Option 3)",
                      },
                      description: { value: "" },
                      isFeatured: { value: false },
                      eCommercePrimary: { value: false },
                      link: {
                        value: {
                          text: "Enquire",
                          linktype: "form",
                          querystring: "enquiry",
                          target: "",
                          id: "{D048F950-F6F5-401D-8FD4-6825D1B4413E}",
                          href: "https://www.fwd.com.my/formslist/product-enquiry-form",
                        },
                      },
                      buttonIcon: null,
                      linkGALabelName: { value: "" },
                      buttonMode: {
                        id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                        fieldType: "Droplink",
                        fieldName: "buttonMode",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/button-mode/primary",
                        fields: {
                          value: { value: "Primary" },
                          key: { value: "Primary" },
                        },
                      },
                      minimumSumAssuredRule: [],
                      maximumSumAssured: { value: "" },
                      minimumSumAssured: { value: "" },
                      minimumPremiumYearly: { value: "" },
                      maximumPremiumYearly: { value: "" },
                      sumAssuredIndicativePrice: { value: "" },
                      isComparable: { value: false },
                      premiumIndicativePrice: { value: "" },
                      frequency: null,
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                      secondaryLinkButtonMode: {
                        id: "02a5a5c7-c318-4919-b773-86a65ba98969",
                        fieldType: "Droplink",
                        fieldName: "secondaryLinkButtonMode",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/button-mode/simple-link",
                        fields: {
                          value: { value: "SimpleLink" },
                          key: { value: "SimpleLink" },
                        },
                      },
                      secondaryLinkGALabelName: { value: "" },
                      secondaryLink: { value: {} },
                      secondaryLinkButtonIcon: null,
                      uniqueId: "e0664b5fe9c34b25b44cfcf7c03f990a",
                    },
                  },
                  {
                    id: "1e094da5-c22b-404b-bc80-3c7f09fdf85e",
                    fields: {
                      productPlanOptionCd: { value: "" },
                      planCode: { value: "" },
                      cardAttributes: {
                        value: {
                          "Issue age":
                            "Certificate owner: 17 to 65 years old. Person covered: One month to 65 years old",
                          "Minimum monthly contribution": "RM500",
                          "Coverage term":
                            "Certificate owner: - . Person covered: ends at 25 years old",
                        },
                      },
                      cardTitle: {
                        value: "FWD Invest First – Education Plan (Option 4)",
                      },
                      key: { value: "" },
                      value: { value: "" },
                      minAge: { value: "" },
                      maxAge: { value: "" },
                      enableEnquiry: { value: true },
                      channel: { value: "E-Commerce" },
                      eCommerceSecondary: { value: false },
                      share: { value: true },
                      cardLabel: { value: "Product" },
                      title: {
                        value: "FWD Invest First – Education Plan (Option 4)",
                      },
                      description: { value: "" },
                      isFeatured: { value: false },
                      eCommercePrimary: { value: false },
                      link: {
                        value: {
                          text: "Enquire",
                          linktype: "form",
                          querystring: "enquiry",
                          target: "",
                          id: "{D048F950-F6F5-401D-8FD4-6825D1B4413E}",
                          href: "https://www.fwd.com.my/formslist/product-enquiry-form",
                        },
                      },
                      buttonIcon: null,
                      linkGALabelName: { value: "" },
                      buttonMode: {
                        id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                        fieldType: "Droplink",
                        fieldName: "buttonMode",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/button-mode/primary",
                        fields: {
                          value: { value: "Primary" },
                          key: { value: "Primary" },
                        },
                      },
                      minimumSumAssuredRule: [],
                      maximumSumAssured: { value: "" },
                      minimumSumAssured: { value: "" },
                      minimumPremiumYearly: { value: "" },
                      maximumPremiumYearly: { value: "" },
                      sumAssuredIndicativePrice: { value: "" },
                      isComparable: { value: false },
                      premiumIndicativePrice: { value: "" },
                      frequency: null,
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                      secondaryLinkButtonMode: {
                        id: "02a5a5c7-c318-4919-b773-86a65ba98969",
                        fieldType: "Droplink",
                        fieldName: "secondaryLinkButtonMode",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/button-mode/simple-link",
                        fields: {
                          value: { value: "SimpleLink" },
                          key: { value: "SimpleLink" },
                        },
                      },
                      secondaryLinkGALabelName: { value: "" },
                      secondaryLink: { value: {} },
                      secondaryLinkButtonIcon: null,
                      uniqueId: "1e094da5c22b404bbc803c7f09fdf85e",
                    },
                  },
                ],
                title: { value: "Interested?" },
                calculateLink: { value: {} },
                buttonIcon: {
                  id: "96bc3a53-ab72-49ef-ba31-37d901b59263",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/download",
                  fields: {
                    value: { value: "download" },
                    key: { value: "Download" },
                  },
                },
                link: {
                  value: {
                    href: "https://web.fwd.com.my/-/media/images/documents/product/fwd-invest-first-education/fwdinvestfirsteducationplan_en.pdf?rev=9ffb24f4391b45cf8f34504cd45a548a",
                    text: "Download product brochure",
                    linktype: "media",
                    target: "_blank",
                    id: "{213770CC-67F1-4138-B2A1-57B9144CE432}",
                  },
                },
                buttonMode: {
                  id: "02a5a5c7-c318-4919-b773-86a65ba98969",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/button-mode/simple-link",
                  fields: {
                    value: { value: "SimpleLink" },
                    key: { value: "SimpleLink" },
                  },
                },
                linkGALabelName: { value: "" },
                secondaryLinkButtonMode: {
                  id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                  fields: {
                    value: { value: "Secondary" },
                    key: { value: "Secondary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: {
                  value: {
                    text: "Terms & conditions",
                    linktype: "modelpopup",
                    querystring: "",
                    target: "",
                    id: "{65CAAEA8-CFCC-4DC7-A781-09F1B2CEC1D0}",
                    modelpopupcontent: {
                      title: { value: "Terms & conditions" },
                      subTitle: { value: "Note:" },
                      description: {
                        value:
                          "<p>We give you back what is due without hidden clauses, and simplified our exclusions list to just 3.<br />\n<br />\n<strong>Suicide or self-inflicted act</strong>: We will not pay any benefit under this certicate if the claim arises:</p>\n<ol>\n    <li>from suicide, attempted suicide or a self-inflicted act by a person covered;</li>\n    <li>and within one year of the start of your certificate, or the date we last reinstated your certificate. This applies regardless of the mental state of the person covered. If this happens, the certificate will continue. The contribution waiver benet will not apply.</li>\n</ol>\n<p><strong>Unlawful acts</strong>:<strong> </strong>We will not pay any benefit under this certificate if the claim arises because you or a person covered wilfully participated in an unlawful act, or unlawful failure to act.<br />\n<br />\n<strong>War</strong>: We will not pay any benefit under this certificate if the claim is a result of an act of war (whether declared or not), coup, revolution, riot, or any similar event.</p>\n<div>&nbsp;</div>",
                      },
                    },
                  },
                },
                secondaryLinkButtonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "secondaryLinkButtonIcon",
                  url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                gaLabelName: { value: "" },
                gaCategoryName: { value: "" },
                sumAssuredStepperInterval: "1000",
                premiumStepperInterval: "5000",
                talkToAgent: {},
                associatedItems: [],
                brochure: {
                  contentType: {
                    id: "93a3d5bf-3a4a-4e7d-89f6-6e43e5493663",
                    fieldType: "Droplink",
                    fieldName: "contentType",
                    url: "https://www.fwd.com.my/content/tags/commontags/contenttype/product",
                    fields: {
                      searchName: { value: "Product" },
                      name: { value: "Product" },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      mobileImage: { value: {} },
                      filterBy: null,
                    },
                  },
                  title: { value: "Brochure" },
                  description: { value: "" },
                  link: {
                    value: {
                      href: "https://web.fwd.com.my/-/media/documents/about-us/fwd-code-of-ethics-and-business-conduct.pdf?rev=bad3daa91ebc4d9fa43919d68b072137",
                      text: "Download brochure",
                      linktype: "media",
                      target: "",
                      id: "{141109D8-D6C5-4801-A777-C7B89507302D}",
                    },
                  },
                  buttonIcon: {
                    id: "a03e086c-a7fd-4fd0-8d38-aa313d696179",
                    fieldType: "Droplink",
                    fieldName: "buttonIcon",
                    url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/document",
                    fields: {
                      value: { value: "document" },
                      key: { value: "document" },
                    },
                  },
                  isPageSearchable: { value: true },
                  gaLabelName: { value: "" },
                  gaCategoryName: { value: "" },
                  riskDisclosure: null,
                  isPageSearchableWithoutDisclosureAcceptance: { value: false },
                  nonRiskDisclosure: null,
                },
                otherComparablePlans: [],
                comparisonPageLink: {
                  value: {
                    href: "https://www.fwd.com.my/products/investments/invest-first-education/plancomparison/",
                    text: "PlanComparison",
                    anchor: "",
                    linktype: "internal",
                    title: "PlanComparison",
                    querystring: "",
                    id: "{763393A0-3181-4D0F-B6FE-18E0F374FA10}",
                  },
                },
              },
            },
            {
              uid: "193443b3-1ad7-42da-9d8a-b9acb5d4f4c8",
              componentName: "Infographic",
              dataSource: "{A505B9BF-3DE9-47E4-89F0-A889C617D838}",
              params: {
                backgroundColor: "white",
                paddingTop: "Large",
                paddingBottom: "Large",
              },
              fields: {
                imageAlignment: {
                  id: "13658b9f-b1c0-4c0f-9abf-a2763594d04a",
                  fieldType: "Droplink",
                  fieldName: "imageAlignment",
                  url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/alignment/left",
                  fields: { value: { value: "Left" }, key: { value: "left" } },
                },
                description: { value: "Grow your savings and secure it" },
                title: { value: "How this plan works" },
                image: {
                  value: {
                    src: "https://www.fwd.com.my/-/media/images/infographic/my/educationplanmobile02-new.png?rev=441517ff5e0e494ba55f44e7858ad78f",
                    Article: {
                      x2: "https://www.fwd.com.my/-/media/images/infographic/my/educationplanmobile02-new.png?rev=441517ff5e0e494ba55f44e7858ad78f&cx=0&cy=0&cw=1616&ch=914&hash=16754516533335F87227D1E4E37C4DC3",
                      x1: "https://www.fwd.com.my/-/media/images/infographic/my/educationplanmobile02-new.png?rev=441517ff5e0e494ba55f44e7858ad78f&cx=0&cy=0&cw=808&ch=457&hash=606760C7A2E0670F0CF11DECE8D4ECD8",
                    },
                    Default: {
                      x1: "https://www.fwd.com.my/-/media/images/infographic/my/educationplanmobile02-new.png?rev=441517ff5e0e494ba55f44e7858ad78f&cx=0&cy=0&cw=600&ch=339&hash=BB04BF52FD2BB6C4862FA470D84D6A8E",
                      x2: "https://www.fwd.com.my/-/media/images/infographic/my/educationplanmobile02-new.png?rev=441517ff5e0e494ba55f44e7858ad78f&cx=0&cy=0&cw=1200&ch=675&hash=33999A12F306114B8AB0324FB17BCC42",
                    },
                  },
                },
                infographicImage: {
                  value: {
                    src: "https://www.fwd.com.my/-/media/images/infographic/my/educationplanmobile02-new.png?rev=441517ff5e0e494ba55f44e7858ad78f",
                  },
                },
                mobileImage: {
                  value: {
                    src: "https://www.fwd.com.my/-/media/images/infographic/my/educationplanmobile02-new.png?rev=441517ff5e0e494ba55f44e7858ad78f",
                    Article: {
                      x2: "https://www.fwd.com.my/-/media/images/infographic/my/educationplanmobile02-new.png?rev=441517ff5e0e494ba55f44e7858ad78f&cx=0&cy=0&cw=1616&ch=914&hash=16754516533335F87227D1E4E37C4DC3",
                      x1: "https://www.fwd.com.my/-/media/images/infographic/my/educationplanmobile02-new.png?rev=441517ff5e0e494ba55f44e7858ad78f&cx=0&cy=0&cw=808&ch=457&hash=606760C7A2E0670F0CF11DECE8D4ECD8",
                    },
                    Default: {
                      x1: "https://www.fwd.com.my/-/media/images/infographic/my/educationplanmobile02-new.png?rev=441517ff5e0e494ba55f44e7858ad78f&cx=0&cy=0&cw=600&ch=339&hash=BB04BF52FD2BB6C4862FA470D84D6A8E",
                      x2: "https://www.fwd.com.my/-/media/images/infographic/my/educationplanmobile02-new.png?rev=441517ff5e0e494ba55f44e7858ad78f&cx=0&cy=0&cw=1200&ch=675&hash=33999A12F306114B8AB0324FB17BCC42",
                    },
                  },
                },
                buttonText: { value: "Expand" },
                buttonIcon: {
                  id: "3acff43e-86ee-476d-bd90-2cff627c50d7",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/zoom-in",
                  fields: {
                    value: { value: "zoom-in" },
                    key: { value: "Zoom In" },
                  },
                },
                gaLabelName: { value: "" },
                gaCategoryName: { value: "" },
              },
            },
            {
              uid: "16feb1e1-9751-4d9c-8868-de0849608685",
              componentName: "Infographic",
              dataSource: "{3EC19DDD-035F-440E-B8B4-9EAB11F9D80F}",
              params: {
                backgroundColor: "white",
                paddingTop: "Medium",
                paddingBottom: "Medium",
              },
              fields: {
                imageAlignment: {
                  id: "2c69cf5e-4d54-4ba2-967a-ef22e91a63b1",
                  fieldType: "Droplink",
                  fieldName: "imageAlignment",
                  url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/alignment/right",
                  fields: {
                    value: { value: "Right" },
                    key: { value: "right" },
                  },
                },
                description: {
                  value:
                    "A chart that details the changes in the amount of sum covered",
                },
                title: { value: "Flexibility to increase your sum covered" },
                image: {
                  value: {
                    src: "https://www.fwd.com.my/-/media/images/infographic/my/educationplanmobile02-new/fwd-invest-first-education-infographic-2.jpg?rev=12ddff5ba85b482381b23e3a7595a47a",
                    Article: {
                      x2: "https://www.fwd.com.my/-/media/images/infographic/my/educationplanmobile02-new/fwd-invest-first-education-infographic-2.jpg?rev=12ddff5ba85b482381b23e3a7595a47a&cx=0&cy=0&cw=1616&ch=914&hash=B94AE220750B7B07DADC37EB934D1615",
                      x1: "https://www.fwd.com.my/-/media/images/infographic/my/educationplanmobile02-new/fwd-invest-first-education-infographic-2.jpg?rev=12ddff5ba85b482381b23e3a7595a47a&cx=0&cy=0&cw=808&ch=457&hash=553A91F8870236AC7F1BFF3CD53A60E8",
                    },
                    Default: {
                      x1: "https://www.fwd.com.my/-/media/images/infographic/my/educationplanmobile02-new/fwd-invest-first-education-infographic-2.jpg?rev=12ddff5ba85b482381b23e3a7595a47a&cx=0&cy=0&cw=600&ch=339&hash=9005B8B10B353A6A18230802134EF5A4",
                      x2: "https://www.fwd.com.my/-/media/images/infographic/my/educationplanmobile02-new/fwd-invest-first-education-infographic-2.jpg?rev=12ddff5ba85b482381b23e3a7595a47a&cx=0&cy=0&cw=1200&ch=675&hash=02F784363F18A38D6BC1C627D27D7F12",
                    },
                  },
                },
                infographicImage: {
                  value: {
                    src: "https://www.fwd.com.my/-/media/images/infographic/my/educationplanmobile02-new/fwd-invest-first-education-infographic-2.jpg?rev=12ddff5ba85b482381b23e3a7595a47a",
                  },
                },
                mobileImage: {
                  value: {
                    src: "https://www.fwd.com.my/-/media/images/infographic/my/educationplanmobile02-new/fwd-invest-first-education-infographic-2.jpg?rev=12ddff5ba85b482381b23e3a7595a47a",
                    Article: {
                      x2: "https://www.fwd.com.my/-/media/images/infographic/my/educationplanmobile02-new/fwd-invest-first-education-infographic-2.jpg?rev=12ddff5ba85b482381b23e3a7595a47a&cx=0&cy=0&cw=1616&ch=914&hash=B94AE220750B7B07DADC37EB934D1615",
                      x1: "https://www.fwd.com.my/-/media/images/infographic/my/educationplanmobile02-new/fwd-invest-first-education-infographic-2.jpg?rev=12ddff5ba85b482381b23e3a7595a47a&cx=0&cy=0&cw=808&ch=457&hash=553A91F8870236AC7F1BFF3CD53A60E8",
                    },
                    Default: {
                      x1: "https://www.fwd.com.my/-/media/images/infographic/my/educationplanmobile02-new/fwd-invest-first-education-infographic-2.jpg?rev=12ddff5ba85b482381b23e3a7595a47a&cx=0&cy=0&cw=600&ch=339&hash=9005B8B10B353A6A18230802134EF5A4",
                      x2: "https://www.fwd.com.my/-/media/images/infographic/my/educationplanmobile02-new/fwd-invest-first-education-infographic-2.jpg?rev=12ddff5ba85b482381b23e3a7595a47a&cx=0&cy=0&cw=1200&ch=675&hash=02F784363F18A38D6BC1C627D27D7F12",
                    },
                  },
                },
                buttonText: { value: "Expand" },
                buttonIcon: {
                  id: "3acff43e-86ee-476d-bd90-2cff627c50d7",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/zoom-in",
                  fields: {
                    value: { value: "zoom-in" },
                    key: { value: "Zoom In" },
                  },
                },
                gaLabelName: { value: "" },
                gaCategoryName: { value: "" },
              },
            },
            {
              uid: "363233b4-b85e-4e40-88e4-442b7f13a4d7",
              componentName: "RelatedProducts",
              dataSource: "{7C165C93-BD5F-4439-A06F-CFCDB7D63794}",
              params: {
                hideCardImage: "1",
                backgroundColor: "grey-white",
                paddingTop: "Large",
                paddingBottom: "Large",
              },
              fields: {
                linkItems: [],
                primaryNeedTags: [
                  {
                    id: "9390ea7c-f580-4b54-aeeb-41ce7a03dc65",
                    fields: {
                      searchName: { value: "investments" },
                      name: { value: "investments" },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      mobileImage: { value: {} },
                      filterBy: null,
                    },
                  },
                ],
                secondaryNeedTags: [
                  {
                    id: "8b4a8c53-e71c-4162-afdf-8ddb211560a3",
                    fields: {
                      searchName: { value: "contributions waived" },
                      name: { value: "contributions waived" },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      mobileImage: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "8d597bc0-8202-4881-af02-5af9a08e2537",
                    fields: {
                      searchName: { value: "dividends" },
                      name: { value: "dividends" },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      mobileImage: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "aaa92113-adb7-4e62-90a6-c1ba888009c9",
                    fields: {
                      searchName: { value: "education" },
                      name: { value: "education" },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      mobileImage: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "a290e5d9-6059-4f33-b7cb-39cf1b157c23",
                    fields: {
                      searchName: { value: "family" },
                      name: { value: "family" },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      mobileImage: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "bece94cd-7a46-464c-8c9c-baacb875260d",
                    fields: {
                      searchName: { value: "flexible contributions" },
                      name: { value: "flexible contributions" },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      mobileImage: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "30937fd7-3d80-4e6d-880f-d352da01bd2e",
                    fields: {
                      searchName: { value: "legacy" },
                      name: { value: "legacy" },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      mobileImage: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "81190fef-9d0b-46c5-94bf-d27412741c05",
                    fields: {
                      searchName: { value: "total & permanent disability" },
                      name: { value: "total & permanent disability" },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      mobileImage: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "08d35897-4371-4052-9a99-00d66242f020",
                    fields: {
                      searchName: { value: "retirement" },
                      name: { value: "retirement" },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      mobileImage: { value: {} },
                      filterBy: null,
                    },
                  },
                ],
                gaLabelName: { value: "" },
                gaCategoryName: { value: "" },
                title: { value: "Other recommended products" },
                description: {
                  value:
                    '<span id="docs-internal-guid-43e81c8c-7fff-2380-68d8-9b4c4330adee" style="color: #000000;">Browse our range of riders that can be matched with your plan for increased protection.</span>',
                },
                subTitle: {
                  value:
                    "Browse our range of riders that can be matched with your plan for increased protection.",
                },
                apiMobilePageSize: { value: "" },
                apiSubType: null,
                apiAllowPagination: { value: true },
                apiPageSize: { value: "" },
                apiContentType: {
                  id: "3b19d2b5-aaa3-4fb7-a107-4cec5f9110f1",
                  fieldType: "Droplink",
                  fieldName: "apiContentType",
                  url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/api-query/search-api/products",
                  fields: {
                    apiName: { value: "Products" },
                    value: {
                      value:
                        "https://prd-api-www.fwd.com/search/{language}/GetProductList",
                    },
                    key: {
                      value:
                        "C9VX6X34b56tC2n2b67hlL5N97VoHguVy1mVnH65KgCm0MWVATlgx9Z453Zb0gE0HXpOzo0Z6ery6oRiNN28z34mBk",
                    },
                  },
                },
                apiSortBy: null,
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: { value: {} },
                buttonMode: {
                  id: "02a5a5c7-c318-4919-b773-86a65ba98969",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/button-mode/simple-link",
                  fields: {
                    value: { value: "SimpleLink" },
                    key: { value: "SimpleLink" },
                  },
                },
                linkGALabelName: { value: "" },
              },
            },
            {
              uid: "34667a65-ad02-4702-883e-12b767c82a88",
              componentName: "FlexiContainer",
              dataSource: "",
              params: {
                numberOfColumns: "7-5",
                backgroundColor: "white|orange",
                carouselMode: "None",
                paddingTop: "Large",
                paddingBottom: "Large",
              },
              placeholders: {
                "jss-col-1": [
                  {
                    uid: "771c85e1-648b-496e-b980-0fc5a3500dd0",
                    componentName: "FAQsAccordion",
                    dataSource: "{9509BDF6-6788-45F3-AB61-32B27371A84A}",
                    params: {
                      backgroundColor: "white-orange",
                      paddingTop: "None",
                      paddingBottom: "None",
                    },
                    fields: {
                      title: { value: "Frequently asked questions" },
                      description: {
                        value:
                          "Want to know more about our products? Here's a few of our most commonly asked questions, and the answers that may help.",
                      },
                      faqItems: [
                        {
                          id: "1880c639-b88c-4bef-826a-25e7b9e36673",
                          fields: {
                            answer: {
                              value:
                                '<span id="docs-internal-guid-d0e237ed-7fff-7d5b-b976-db125d667e34"></span>\n<p dir="ltr" style="margin-top: 0pt; margin-bottom: 0pt;"><span style="color: #000000;">We manage your contribution and our takaful operations based on the Shariah contract of wakalah, and guided by our Shariah committee.&nbsp;</span></p>\n<ul style="margin-top: 0px; margin-bottom: 0px;">\n    <li dir="ltr" aria-level="1" style="color: #000000; list-style-type: disc;">\n    <p dir="ltr" role="presentation" style="margin-top: 0pt; margin-bottom: 0pt;"><span>Takaful is a mutual assistance scheme based on the spirit of brotherhood and solidarity where you and others agree to assist each other financially if any one of you suffers a specific loss.&nbsp;</span></p>\n    </li>\n</ul>\n<span id="docs-internal-guid-d0e237ed-7fff-7d5b-b976-db125d667e34"><br />\n</span>\n<p dir="ltr" style="margin-top: 0pt; margin-bottom: 0pt;"><span style="color: #000000;">The contributions you pay for cover under your certificate is subject to a wakalah fee.&nbsp;</span></p>\n<ul style="margin-top: 0px; margin-bottom: 0px;">\n    <li dir="ltr" aria-level="1" style="color: #000000; list-style-type: disc;">\n    <p dir="ltr" role="presentation" style="margin-top: 0pt; margin-bottom: 0pt;"><span>Wakalah is the appointment by one party of another to act on his/her behalf.&nbsp;</span></p>\n    </li>\n</ul>\n<span id="docs-internal-guid-d0e237ed-7fff-7d5b-b976-db125d667e34"><br />\n</span>\n<p dir="ltr" style="margin-top: 0pt; margin-bottom: 0pt;"><span style="color: #000000;">We pay your contributions, less the wakalah fee, into our Participants&rsquo; Risk Fund (PRF) as tabarru&rsquo;. Funds in PRF are used to pay the benefits to claimants who are entitled to it based on: the solidarity of brotherhood and cooperation among the participants; and subject to terms &amp; conditions.&nbsp;</span></p>\n<ul style="margin-top: 0px; margin-bottom: 0px;">\n    <li dir="ltr" aria-level="1" style="color: #000000; list-style-type: disc;">\n    <p dir="ltr" role="presentation" style="margin-top: 0pt; margin-bottom: 0pt;"><span>Tabarru&rsquo; is a donation for the purpose of takaful. If the value of PRF is insufficient to pay the claims, then we will pay Qard which is an interest-free loan to PRF.&nbsp;</span></p>\n    </li>\n</ul>\n<span id="docs-internal-guid-d0e237ed-7fff-7d5b-b976-db125d667e34"><br />\n</span>\n<p dir="ltr" style="margin-top: 0pt; margin-bottom: 0pt;"><span style="color: #000000;">In case of the good performance of the PRF, we will be rewarded 50% of the surplus as Ju&rsquo;alah and the remaining 50% will be distributed to participants.</span></p>\n<div><span style="color: #000000;"><br />\n</span></div>',
                            },
                            question: {
                              value:
                                '<span id="docs-internal-guid-68782751-7fff-fb17-34ed-e73d2d824e07" style="color: #000000;">How do we ensure that the plan is Shariah compliant?</span>',
                            },
                            gaLabelName: { value: "" },
                            gaCategoryName: { value: "" },
                          },
                        },
                        {
                          id: "07f3c6c0-a823-4048-b8eb-22d41eb735fe",
                          fields: {
                            answer: {
                              value:
                                '<span id="docs-internal-guid-966f5d9e-7fff-8ffe-ab90-dd1ad27cbdd2"></span>\n<p dir="ltr" style="margin-top: 0pt; margin-bottom: 0pt;"><span style="color: #000000;">First step:&nbsp;</span></p>\n<p dir="ltr" style="margin-top: 0pt; margin-bottom: 0pt;"><span style="color: #000000;">Assess how much savings you will need. Funding an education is hard enough even today, with costs increasing more than salary inflation it will be even tougher. Select a few courses and study pathways, then compare and evaluate the expected average costs by factoring the inflation rate (assumed at 10% per annum).</span></p>\n<span id="docs-internal-guid-966f5d9e-7fff-8ffe-ab90-dd1ad27cbdd2"><br />\n</span>\n<p dir="ltr" style="margin-top: 0pt; margin-bottom: 0pt;"><span style="color: #000000;">Second step:&nbsp;</span></p>\n<p dir="ltr" style="margin-top: 0pt; margin-bottom: 0pt;"><span style="color: #000000;">Balance your objectives and principal considerations When it comes to investing for a goal, you should clearly assess your financial capacity and weigh it with your willingness to take risk as well as type of risk(s). It&rsquo;s important as investing in an Investment-Linked Takaful plan is a long term commitment.</span></p>\n<span id="docs-internal-guid-966f5d9e-7fff-8ffe-ab90-dd1ad27cbdd2"><br />\n</span>\n<p dir="ltr" style="margin-top: 0pt; margin-bottom: 0pt;"><span style="color: #000000;">Capacity: Time horizon, financial situation</span></p>\n<p dir="ltr" style="margin-top: 0pt; margin-bottom: 0pt;"><span style="color: #000000;">Willingness: Investment objective, risk tolerance, attitude to risk</span></p>\n<div><span style="color: #000000;"><br />\n</span></div>',
                            },
                            question: {
                              value:
                                '<span id="docs-internal-guid-57586589-7fff-29cd-2bce-e7d6cff649e0" style="color: #000000;">What are the decisions that I have to make?</span>',
                            },
                            gaLabelName: { value: "" },
                            gaCategoryName: { value: "" },
                          },
                        },
                        {
                          id: "b348de1a-e6a5-49bb-a5b2-c8f8bd953e09",
                          fields: {
                            answer: {
                              value:
                                '<span id="docs-internal-guid-1e76e498-7fff-bf83-a749-f9324b2487e7"></span>\n<p dir="ltr" style="margin-top: 0pt; margin-bottom: 0pt;"><span style="color: #000000;">Here are 4 key personality traits which help you to evaluate which fund choices you can choose, and assess what kind of investor you are.</span></p>\n<span id="docs-internal-guid-1e76e498-7fff-bf83-a749-f9324b2487e7"><br />\n</span>\n<p dir="ltr" style="margin-top: 0pt; margin-bottom: 0pt;"><span style="color: #000000;">Accumulators:&nbsp;</span></p>\n<ol style="margin-top: 0px; margin-bottom: 0px;">\n    <li dir="ltr" aria-level="1" style="color: #000000; list-style-type: decimal;">\n    <p dir="ltr" role="presentation" style="margin-top: 0pt; margin-bottom: 0pt;"><span>Keenly interested in accumulating wealth.</span></p>\n    </li>\n    <li dir="ltr" aria-level="1" style="color: #000000; list-style-type: decimal;">\n    <p dir="ltr" role="presentation" style="margin-top: 0pt; margin-bottom: 0pt;"><span>What to steer investment decisions.</span></p>\n    </li>\n    <li dir="ltr" aria-level="1" style="color: #000000; list-style-type: decimal;">\n    <p dir="ltr" role="presentation" style="margin-top: 0pt; margin-bottom: 0pt;"><span>Confident of the investment decisions they take.</span></p>\n    </li>\n</ol>\n<span id="docs-internal-guid-1e76e498-7fff-bf83-a749-f9324b2487e7"><br />\n</span>\n<p dir="ltr" style="margin-top: 0pt; margin-bottom: 0pt;"><span style="color: #000000;">Followers</span></p>\n<ol style="margin-top: 0px; margin-bottom: 0px;">\n    <li dir="ltr" aria-level="1" style="color: #000000; list-style-type: decimal;">\n    <p dir="ltr" role="presentation" style="margin-top: 0pt; margin-bottom: 0pt;"><span>Likes to follow friends or new investment fad.</span></p>\n    </li>\n    <li dir="ltr" aria-level="1" style="color: #000000; list-style-type: decimal;">\n    <p dir="ltr" role="presentation" style="margin-top: 0pt; margin-bottom: 0pt;"><span>May lack interest or knowledge in investing.</span></p>\n    </li>\n    <li dir="ltr" aria-level="1" style="color: #000000; list-style-type: decimal;">\n    <p dir="ltr" role="presentation" style="margin-top: 0pt; margin-bottom: 0pt;"><span>Decision making process often lacks long term planning.</span></p>\n    </li>\n</ol>\n<span id="docs-internal-guid-1e76e498-7fff-bf83-a749-f9324b2487e7"><br />\n</span>\n<p dir="ltr" style="margin-top: 0pt; margin-bottom: 0pt;"><span style="color: #000000;">Preservers</span></p>\n<ol style="margin-top: 0px; margin-bottom: 0px;">\n    <li dir="ltr" aria-level="1" style="color: #000000; list-style-type: decimal;">\n    <p dir="ltr" role="presentation" style="margin-top: 0pt; margin-bottom: 0pt;"><span>Emphasise financial security.</span></p>\n    </li>\n    <li dir="ltr" aria-level="1" style="color: #000000; list-style-type: decimal;">\n    <p dir="ltr" role="presentation" style="margin-top: 0pt; margin-bottom: 0pt;"><span>Anxious about losses and short term performance.</span></p>\n    </li>\n    <li dir="ltr" aria-level="1" style="color: #000000; list-style-type: decimal;">\n    <p dir="ltr" role="presentation" style="margin-top: 0pt; margin-bottom: 0pt;"><span>Fear of making wrong investment decisions.</span></p>\n    </li>\n</ol>\n<span id="docs-internal-guid-1e76e498-7fff-bf83-a749-f9324b2487e7"><br />\n</span>\n<p dir="ltr" style="margin-top: 0pt; margin-bottom: 0pt;"><span style="color: #000000;">Independents</span></p>\n<ol style="margin-top: 0px; margin-bottom: 0px;">\n    <li dir="ltr" aria-level="1" style="color: #000000; list-style-type: decimal;">\n    <p dir="ltr" role="presentation" style="margin-top: 0pt; margin-bottom: 0pt;"><span>Hold original ideas and like to be involved in the investment process.</span></p>\n    </li>\n    <li dir="ltr" aria-level="1" style="color: #000000; list-style-type: decimal;">\n    <p dir="ltr" role="presentation" style="margin-top: 0pt; margin-bottom: 0pt;"><span>Often very analytical and critical thinkers.</span></p>\n    </li>\n    <li dir="ltr" aria-level="1" style="color: #000000; list-style-type: decimal;">\n    <p dir="ltr" role="presentation" style="margin-top: 0pt; margin-bottom: 0pt;"><span>May exhibit bias in decisions due to own research.</span></p>\n    </li>\n</ol>',
                            },
                            question: {
                              value:
                                '<span id="docs-internal-guid-e2d5d83c-7fff-2626-8d27-2d5db9fd52ff" style="color: #000000;">How do I decide which type of funds to invest in?</span>',
                            },
                            gaLabelName: { value: "" },
                            gaCategoryName: { value: "" },
                          },
                        },
                        {
                          id: "3f393118-9cd6-48c0-9ab4-2c35c75d52d4",
                          fields: {
                            answer: {
                              value:
                                '<span id="docs-internal-guid-18b5828d-7fff-ac5e-ef05-17bf6e6d3491"></span>\n<p dir="ltr" style="margin-top: 0pt; margin-bottom: 0pt;"><span style="color: #000000;">Your contribution depends on the following criteria regarding the family members covered under the certificate:&nbsp;</span></p>\n<span id="docs-internal-guid-18b5828d-7fff-ac5e-ef05-17bf6e6d3491"><br />\n</span>\n<ul style="margin-top: 0px; margin-bottom: 0px;">\n    <li dir="ltr" aria-level="1" style="color: #000000; list-style-type: disc;">\n    <p dir="ltr" role="presentation" style="margin-top: 0pt; margin-bottom: 0pt;"><span>Age&nbsp;</span></p>\n    </li>\n    <li dir="ltr" aria-level="1" style="color: #000000; list-style-type: disc;">\n    <p dir="ltr" role="presentation" style="margin-top: 0pt; margin-bottom: 0pt;"><span>Health status&nbsp;</span></p>\n    </li>\n    <li dir="ltr" aria-level="1" style="color: #000000; list-style-type: disc;">\n    <p dir="ltr" role="presentation" style="margin-top: 0pt; margin-bottom: 0pt;"><span>Smoker status&nbsp;</span></p>\n    </li>\n    <li dir="ltr" aria-level="1" style="color: #000000; list-style-type: disc;">\n    <p dir="ltr" role="presentation" style="margin-top: 0pt; margin-bottom: 0pt;"><span>Gender&nbsp;</span></p>\n    </li>\n    <li dir="ltr" aria-level="1" style="color: #000000; list-style-type: disc;">\n    <p dir="ltr" role="presentation" style="margin-top: 0pt; margin-bottom: 0pt;"><span>Amount of coverage&nbsp;</span></p>\n    </li>\n    <li dir="ltr" aria-level="1" style="color: #000000; list-style-type: disc;">\n    <p dir="ltr" role="presentation" style="margin-top: 0pt; margin-bottom: 0pt;"><span>Term of coverage</span></p>\n    </li>\n    <li dir="ltr" aria-level="1" style="color: #000000; list-style-type: disc;">\n    <p dir="ltr" role="presentation" style="margin-top: 0pt; margin-bottom: 0pt;"><span>Occupation</span></p>\n    </li>\n    <li dir="ltr" aria-level="1" style="color: #000000; list-style-type: disc;">\n    <p dir="ltr" role="presentation" style="margin-top: 0pt; margin-bottom: 0pt;"><span>Payment frequency</span></p>\n    </li>\n</ul>\n<span id="docs-internal-guid-18b5828d-7fff-ac5e-ef05-17bf6e6d3491"><br />\n</span>\n<p dir="ltr" style="margin-top: 0pt; margin-bottom: 0pt;"><span style="color: #000000;">Based on these personal information, we&rsquo;ll be able to provide you with a quotation.</span></p>\n<div><span style="color: #000000;"><br />\n</span></div>',
                            },
                            question: {
                              value:
                                '<span id="docs-internal-guid-1a0e4a9c-7fff-4b66-8b6b-9d5f9469ae9d" style="color: #000000;">How much do I contribute?</span>',
                            },
                            gaLabelName: { value: "" },
                            gaCategoryName: { value: "" },
                          },
                        },
                      ],
                      buttonIcon: {
                        id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                        fieldType: "CustomDroplink",
                        fieldName: "buttonIcon",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/link",
                        fields: {
                          value: { value: "arrow-right" },
                          key: { value: "Link" },
                        },
                      },
                      link: {
                        value: {
                          href: "https://www.fwd.com.my/support/faq/",
                          text: "See all FAQs",
                          anchor: "",
                          linktype: "internal",
                          class: "",
                          title: "",
                          target: "",
                          querystring: "",
                          id: "{BDF0BAEC-3CFA-4A33-B63C-E241EF0661DA}",
                        },
                      },
                      buttonMode: {
                        id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                        fieldType: "Droplink",
                        fieldName: "buttonMode",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/button-mode/primary",
                        fields: {
                          value: { value: "Primary" },
                          key: { value: "Primary" },
                        },
                      },
                      linkGALabelName: { value: "" },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                ],
                "jss-col-2": [
                  {
                    uid: "a77b8bd7-3ba2-4517-8254-1c8511efa457",
                    componentName: "CustomerSupport",
                    dataSource: "{9ACCA6C4-B29A-474E-8306-8AD88CC296FC}",
                    params: {
                      buttonAlignment: "left",
                      variant: "base",
                      numberOfColumns: "three",
                      backgroundColor: "orange",
                      paddingTop: "None",
                      paddingBottom: "None",
                    },
                    fields: {
                      supportIcon: {
                        id: "0853a008-9b3c-4a10-98b9-1e96a3cdc253",
                        fieldType: "Droplink",
                        fieldName: "supportIcon",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/call",
                        fields: {
                          value: { value: "call" },
                          key: { value: "Call" },
                        },
                      },
                      title: { value: "Find out more" },
                      description: {
                        value:
                          "Can&rsquo;t decide which product is right for you? Want to get more information? Select one of the options below.",
                      },
                      supportOptions: [
                        {
                          id: "3dad79cb-74da-4857-a6ef-15ba26659d31",
                          fields: {
                            contactNumber: { value: "1300137988" },
                            subTitle: {
                              value:
                                "You can call us Mon – Fri, 9am – 6pm (excluding weekends and public holidays).",
                            },
                            icon: {
                              value: {
                                src: "https://www.fwd.com.my/-/media/global/images/supports/call.svg?rev=130ad9d603204553871b4a784aa45e98",
                                alt: "call",
                              },
                            },
                            title: { value: "Call 1300 13 7988" },
                            supportIcon: {
                              id: "0853a008-9b3c-4a10-98b9-1e96a3cdc253",
                              fieldType: "CustomDroplink",
                              fieldName: "supportIcon",
                              url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/call",
                              fields: {
                                value: { value: "call" },
                                key: { value: "Call" },
                              },
                            },
                            buttonIcon: {
                              id: "0853a008-9b3c-4a10-98b9-1e96a3cdc253",
                              fieldType: "CustomDroplink",
                              fieldName: "buttonIcon",
                              url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/call",
                              fields: {
                                value: { value: "call" },
                                key: { value: "Call" },
                              },
                            },
                            link: {
                              value: {
                                href: "http://tel:1300137988",
                                text: "Call 1300 13 7988",
                                linktype: "external",
                                url: "http://tel:1300137988",
                                anchor: "",
                                target: "",
                              },
                            },
                            buttonMode: {
                              id: "02a5a5c7-c318-4919-b773-86a65ba98969",
                              fieldType: "Droplink",
                              fieldName: "buttonMode",
                              url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/button-mode/simple-link",
                              fields: {
                                value: { value: "SimpleLink" },
                                key: { value: "SimpleLink" },
                              },
                            },
                            linkGALabelName: { value: "" },
                            listType: {
                              id: "a5bee68c-8e43-4f78-8d15-d42982fd053a",
                              fieldType: "Droplink",
                              fieldName: "listType",
                              url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linklisttype/call",
                              fields: {
                                value: { value: "Call" },
                                key: { value: "call" },
                              },
                            },
                          },
                        },
                        // {
                        //   id: "193cfb70-7e92-45f9-8b5e-fd77f61a603e",
                        //   fields: {
                        //     title: { value: "Start a chat" },
                        //     icon: {
                        //       value: {
                        //         src: "https://www.fwd.com.my/-/media/global/images/supports/chat.svg?rev=4c3ed691bb1b4772b48cc75cf95d36cc",
                        //         alt: "chat",
                        //       },
                        //     },
                        //     subTitle: {
                        //       value: "Fi, our chatbot, is available 24/7.",
                        //     },
                        //     supportIcon: {
                        //       id: "631bc306-c30e-4d10-afe5-670237118479",
                        //       fieldType: "CustomDroplink",
                        //       fieldName: "supportIcon",
                        //       url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chat",
                        //       fields: {
                        //         value: { value: "chat" },
                        //         key: { value: "chat" },
                        //       },
                        //     },
                        //     buttonIcon: {
                        //       id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                        //       fieldType: "CustomDroplink",
                        //       fieldName: "buttonIcon",
                        //       url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/link",
                        //       fields: {
                        //         value: { value: "arrow-right" },
                        //         key: { value: "Link" },
                        //       },
                        //     },
                        //     link: { value: { linktype: "internal" } },
                        //     buttonMode: {
                        //       id: "02a5a5c7-c318-4919-b773-86a65ba98969",
                        //       fieldType: "Droplink",
                        //       fieldName: "buttonMode",
                        //       url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/button-mode/simple-link",
                        //       fields: {
                        //         value: { value: "SimpleLink" },
                        //         key: { value: "SimpleLink" },
                        //       },
                        //     },
                        //     linkGALabelName: { value: "" },
                        //     listType: {
                        //       id: "dda5c48b-3a8a-4afe-9b24-eaba5cda8c77",
                        //       fieldType: "Droplink",
                        //       fieldName: "listType",
                        //       url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linklisttype/chat",
                        //       fields: {
                        //         value: { value: "Chat" },
                        //         key: { value: "chat" },
                        //       },
                        //     },
                        //   },
                        // },
                        {
                          id: "fa474e72-7f95-4e39-9042-6faf72a01f69",
                          fields: {
                            medalliaForm: { value: "" },
                            title: { value: "Arrange a call" },
                            icon: { value: {} },
                            subTitle: {
                              value:
                                "Send us a few details and we'll get back to you shortly.",
                            },
                            supportIcon: {
                              id: "f35ed9fd-ad24-494a-8fb6-33be8955a85d",
                              fieldType: "CustomDroplink",
                              fieldName: "supportIcon",
                              url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/call-email",
                              fields: {
                                value: { value: "call-email" },
                                key: { value: "callEmail" },
                              },
                            },
                            listType: {
                              id: "f281af72-fa4b-4f87-98f1-4b9d77180e60",
                              fieldType: "Droplink",
                              fieldName: "listType",
                              url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linklisttype/generic_link",
                              fields: {
                                value: { value: "Generic Link" },
                                key: { value: "generic_link" },
                              },
                            },
                            buttonIcon: {
                              id: "f35ed9fd-ad24-494a-8fb6-33be8955a85d",
                              fieldType: "CustomDroplink",
                              fieldName: "buttonIcon",
                              url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/call-email",
                              fields: {
                                value: { value: "call-email" },
                                key: { value: "callEmail" },
                              },
                            },
                            link: {
                              value: {
                                text: "Open contact form",
                                linktype: "form",
                                querystring: "bookAnAgent",
                                target: "",
                                id: "{D048F950-F6F5-401D-8FD4-6825D1B4413E}",
                                href: "https://www.fwd.com.my/formslist/product-enquiry-form",
                              },
                            },
                            buttonMode: {
                              id: "02a5a5c7-c318-4919-b773-86a65ba98969",
                              fieldType: "Droplink",
                              fieldName: "buttonMode",
                              url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/button-mode/simple-link",
                              fields: {
                                value: { value: "SimpleLink" },
                                key: { value: "SimpleLink" },
                              },
                            },
                            linkGALabelName: { value: "" },
                          },
                        },
                      ],
                      buttonIcon: {
                        id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                        fieldType: "CustomDroplink",
                        fieldName: "buttonIcon",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/link",
                        fields: {
                          value: { value: "arrow-right" },
                          key: { value: "Link" },
                        },
                      },
                      link: {
                        value: {
                          href: "https://www.fwd.com.my/support/#customer-support",
                          text: "Show me all support options",
                          anchor: "customer-support",
                          linktype: "internal",
                          class: "",
                          title: "",
                          target: "",
                          querystring: "",
                          id: "{7D817917-32F5-4221-9CD4-88CFE7E7C4C0}",
                        },
                      },
                      buttonMode: {
                        id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                        fieldType: "Droplink",
                        fieldName: "buttonMode",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/button-mode/primary",
                        fields: {
                          value: { value: "Primary" },
                          key: { value: "Primary" },
                        },
                      },
                      linkGALabelName: { value: "" },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                ],
                "jss-col-3": [],
                "jss-col-4": [],
              },
            },
          ],
          "jss-footer": [
            {
              uid: "dcefbe9a-cb6f-4ea1-b123-c1db121b4108",
              componentName: "Footer",
              dataSource: "{84A1FFCB-5E06-4FEB-A796-6715B00B1320}",
              params: {
                backgroundColor: "orangeLighter",
                paddingTop: "Medium",
                paddingBottom: "None",
              },
              fields: {
                siteNavigationLinks: [
                  {
                    id: "d2a01e53-2a01-487a-a08a-7af417401ed8",
                    name: "column-1",
                    displayName: "Column 1",
                    fields: {},
                    Children: [
                      {
                        id: "b0948026-924c-431a-94c0-cf8117a48fed",
                        name: "Products",
                        displayName: "Products",
                        fields: {
                          buttonIcon: {
                            id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                            fieldType: "CustomDroplink",
                            fieldName: "buttonIcon",
                            url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                            fields: {
                              value: { value: "chevron-right" },
                              key: { value: "chevronRight" },
                            },
                          },
                          title: { value: "Products" },
                          link: {
                            value: {
                              href: "https://www.fwd.com/mys/products",
                              linktype: "external",
                              url: "https://www.fwd.com/mys/products",
                              anchor: "",
                              target: "",
                            },
                          },
                          listType: {
                            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                            fieldType: "Droplink",
                            fieldName: "listType",
                            url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                            fields: {
                              value: { value: "Generic Link" },
                              key: { value: "generic_link" },
                            },
                          },
                          gaLabelName: { value: "" },
                          gaCategoryName: { value: "" },
                        },
                        Children: [
                          {
                            id: "f7a3be45-7210-46de-9c90-67905bce0345",
                            name: "Health Protection",
                            displayName: "Health Protection",
                            fields: {
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              title: { value: "Health protection" },
                              link: {
                                value: {
                                  href: "https://www.fwd.com.my/products/health-protection/",
                                  text: "Health Protection",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "",
                                  querystring: "",
                                  id: "{26AFBCBE-83A6-4251-8420-7A297BBCB680}",
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaLabelName: { value: "" },
                              gaCategoryName: { value: "" },
                            },
                          },
                          {
                            id: "1cb83034-9403-4687-b0a0-136b1d5ab3e6",
                            name: "Loss of life",
                            displayName: "Loss of life",
                            fields: {
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              title: { value: "Loss of life" },
                              link: {
                                value: {
                                  href: "https://www.fwd.com.my/products/loss-of-life/",
                                  text: "Life Protection",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "",
                                  querystring: "",
                                  id: "{9C8ABF60-7F14-480C-8302-2881B06F0263}",
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaLabelName: { value: "" },
                              gaCategoryName: { value: "" },
                            },
                          },
                          {
                            id: "7db1bc42-b6d9-4d0e-ab24-904195499792",
                            name: "Investments",
                            displayName: "Investments",
                            fields: {
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              title: { value: "Investments" },
                              link: {
                                value: {
                                  href: "https://www.fwd.com.my/products/investments/",
                                  text: "Invest",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "",
                                  querystring: "",
                                  id: "{F45CA4C1-CC7F-4D6A-8A27-3BE0EAC87298}",
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaLabelName: { value: "" },
                              gaCategoryName: { value: "" },
                            },
                          },
                          {
                            id: "6b05a68f-993b-4100-a906-9f3948475a6b",
                            name: "Savings",
                            displayName: "Savings",
                            fields: {
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              title: { value: "Savings" },
                              link: {
                                value: {
                                  href: "https://www.fwd.com.my/products/savings/",
                                  text: "Savings",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "",
                                  querystring: "",
                                  id: "{80749FD6-67FC-4974-9D4F-614B8307DA7B}",
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaLabelName: { value: "" },
                              gaCategoryName: { value: "" },
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    id: "fb39b3dc-9a41-413b-8756-cf6127c7eea8",
                    name: "column-2",
                    displayName: "Column 2",
                    fields: {},
                    Children: [
                      {
                        id: "5f48c1ac-06cd-4da5-a38e-48d980ed225d",
                        name: "Claims",
                        displayName: "Claims",
                        fields: {
                          buttonIcon: {
                            id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                            fieldType: "CustomDroplink",
                            fieldName: "buttonIcon",
                            url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                            fields: {
                              value: { value: "chevron-right" },
                              key: { value: "chevronRight" },
                            },
                          },
                          title: { value: "Claims" },
                          link: {
                            value: {
                              href: "https://www.fwd.com.my/claims/",
                              linktype: "internal",
                              id: "{176F0964-27C7-40B6-9DA5-54DA1C6CB59E}",
                            },
                          },
                          listType: {
                            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                            fieldType: "Droplink",
                            fieldName: "listType",
                            url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                            fields: {
                              value: { value: "Generic Link" },
                              key: { value: "generic_link" },
                            },
                          },
                          gaLabelName: { value: "" },
                          gaCategoryName: { value: "" },
                        },
                        Children: [
                          {
                            id: "030204f5-0c86-4387-afbe-5eb378c409a5",
                            name: "Find a form",
                            displayName: "Find a form",
                            fields: {
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              title: { value: "Find a form" },
                              link: {
                                value: {
                                  href: "https://www.fwd.com.my/support/forms/",
                                  text: "",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "",
                                  target: "",
                                  querystring: "",
                                  id: "{D4F47ADA-BF79-497F-BBDF-2B269CF6001D}",
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaLabelName: { value: "" },
                              gaCategoryName: { value: "" },
                            },
                          },
                          {
                            id: "a5b17d4c-5900-48f4-85a9-c3a1f7e8422e",
                            name: "Critical illness claims",
                            displayName: "Critical illness claims",
                            fields: {
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              title: { value: "Critical illness claims" },
                              link: {
                                value: {
                                  href: "https://www.fwd.com.my/claims/critical-illness-claims/",
                                  text: "",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "",
                                  target: "",
                                  querystring: "",
                                  id: "{E6CF0878-BFBC-48C5-A62C-F4AB6AD8EB4F}",
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaLabelName: { value: "" },
                              gaCategoryName: { value: "" },
                            },
                          },
                          {
                            id: "96ca9364-61d8-4ab6-b6d9-956f9e16958e",
                            name: "Loss of life claims",
                            displayName: "Loss of life claims",
                            fields: {
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              title: { value: "Loss of life claims" },
                              link: {
                                value: {
                                  href: "https://www.fwd.com.my/claims/loss-of-life-claims/",
                                  text: "",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "",
                                  target: "",
                                  querystring: "",
                                  id: "{EE4A38DD-1F45-4977-A07D-6F4133540E07}",
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaLabelName: { value: "" },
                              gaCategoryName: { value: "" },
                            },
                          },
                          {
                            id: "a5e54b73-6035-4b6c-b0c4-155fb76b8d4f",
                            name: "Medical allowances claims",
                            displayName: "Medical allowances claims",
                            fields: {
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              title: { value: "Medical allowance claims" },
                              link: {
                                value: {
                                  href: "https://www.fwd.com.my/claims/medical-allowance-claims/",
                                  text: "",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "",
                                  target: "",
                                  querystring: "",
                                  id: "{E8BCF460-E374-4B19-BF90-C513C0B41215}",
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaLabelName: { value: "" },
                              gaCategoryName: { value: "" },
                            },
                          },
                          {
                            id: "688a1bac-32ed-44a4-88e5-c853997fa4b9",
                            name: "Medical reimbursement claims",
                            displayName: "Medical reimbursement claims",
                            fields: {
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              title: { value: "Medical reimbursement claims" },
                              link: {
                                value: {
                                  href: "https://www.fwd.com.my/claims/medical-reimbursement-claims/",
                                  text: "",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "",
                                  target: "",
                                  querystring: "",
                                  id: "{DA0BC868-E117-496F-A1A5-90532FA099DA}",
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaLabelName: { value: "" },
                              gaCategoryName: { value: "" },
                            },
                          },
                          {
                            id: "7f4831fd-fcd6-4d98-bcac-8a8acce1b962",
                            name: "Total permanent disability claims",
                            displayName: "Total permanent disability claims",
                            fields: {
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              title: {
                                value: "Total permanent disability claims",
                              },
                              link: {
                                value: {
                                  href: "https://www.fwd.com.my/claims/total-permanent-disability-claims/",
                                  text: "",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "",
                                  target: "",
                                  querystring: "",
                                  id: "{62C2E501-B48D-490F-8786-D050FAB1DB51}",
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaLabelName: { value: "" },
                              gaCategoryName: { value: "" },
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    id: "5cbb10b9-89a9-4b0a-a7c3-26c1fabe0d14",
                    name: "column-3",
                    displayName: "Column 3",
                    fields: {},
                    Children: [
                      {
                        id: "ecf6529e-8462-41f2-92ae-f8aafe6d9843",
                        name: "Support",
                        displayName: "Support",
                        fields: {
                          buttonIcon: {
                            id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                            fieldType: "CustomDroplink",
                            fieldName: "buttonIcon",
                            url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                            fields: {
                              value: { value: "chevron-right" },
                              key: { value: "chevronRight" },
                            },
                          },
                          title: { value: "Support" },
                          link: {
                            value: {
                              href: "https://www.fwd.com.my/support/",
                              text: "",
                              anchor: "",
                              linktype: "internal",
                              class: "",
                              title: "",
                              querystring: "",
                              id: "{7D817917-32F5-4221-9CD4-88CFE7E7C4C0}",
                            },
                          },
                          listType: {
                            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                            fieldType: "Droplink",
                            fieldName: "listType",
                            url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                            fields: {
                              value: { value: "Generic Link" },
                              key: { value: "generic_link" },
                            },
                          },
                          gaLabelName: { value: "" },
                          gaCategoryName: { value: "" },
                        },
                        Children: [
                          {
                            id: "c7196112-394c-42a2-a2ef-c94d01e29edc",
                            name: "FAQs",
                            displayName: "FAQs",
                            fields: {
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              title: { value: "FAQs" },
                              link: {
                                value: {
                                  href: "https://www.fwd.com.my/support/faq/",
                                  text: "",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "",
                                  target: "",
                                  querystring: "",
                                  id: "{BDF0BAEC-3CFA-4A33-B63C-E241EF0661DA}",
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaLabelName: { value: "" },
                              gaCategoryName: { value: "" },
                            },
                          },
                          {
                            id: "a3477909-605d-41a3-8b7a-404e4592e4c8",
                            name: "Call 1300 13 7988",
                            displayName: "Call 1300 13 7988",
                            fields: {
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              title: { value: "Call 1300 13 7988" },
                              link: {
                                value: {
                                  href: "javascript:window.open('tel:1300137988');;return false;",
                                  text: "Call 1300 13 7988",
                                  linktype: "javascript",
                                  url: "javascript:window.open('tel:1300137988');",
                                  anchor: "",
                                },
                              },
                              listType: {
                                id: "fd670504-d972-4fee-9582-656b0d6ba342",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/call",
                                fields: {
                                  value: { value: "Call" },
                                  key: { value: "call" },
                                },
                              },
                              gaLabelName: { value: "" },
                              gaCategoryName: { value: "" },
                            },
                          },
                          {
                            id: "be58e7ca-ae8a-4dad-95dc-a57ca59479ee",
                            name: "Online enquiries",
                            displayName: "Online enquiries",
                            fields: {
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              title: { value: "Online enquiries" },
                              link: {
                                value: {
                                  text: "Online enquiries",
                                  linktype: "form",
                                  querystring: "bookAnAgent",
                                  target: "",
                                  id: "{61A3597B-2BEE-4AD4-9473-92ECD5DBF4D0}",
                                  href: "https://www.fwd.com.my/formslist/general-enquiry-form",
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaLabelName: { value: "" },
                              gaCategoryName: { value: "" },
                            },
                          },
                          {
                            id: "7608d76b-d787-47d9-946b-9c916880ca3b",
                            name: "Feedback",
                            displayName: "Feedback",
                            fields: {
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              title: { value: "Feedback" },
                              link: {
                                value: {
                                  href: "https://www.fwd.com.my/support/feedback/",
                                  text: "",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "",
                                  target: "",
                                  querystring: "",
                                  id: "{80A2A725-D956-4D3D-BBE2-9CB95C2FAAF2}",
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaLabelName: { value: "" },
                              gaCategoryName: { value: "" },
                            },
                          },
                          {
                            id: "dd767d0a-f60a-44e9-abaf-92a0fc23078c",
                            name: "Locate us",
                            displayName: "Locate us",
                            fields: {
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              title: { value: "Locate us" },
                              link: {
                                value: {
                                  href: "https://www.fwd.com.my/about-us/brand-story/#our-offices",
                                  text: "",
                                  anchor: "our-offices",
                                  linktype: "internal",
                                  class: "",
                                  title: "",
                                  target: "",
                                  querystring: "",
                                  id: "{C1ACA1F8-078E-4937-A8DA-B81802375BE7}",
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaLabelName: { value: "" },
                              gaCategoryName: { value: "" },
                            },
                          },
                          {
                            id: "2d8bb492-2394-4dc4-b1f4-8083ff90028f",
                            name: "Our hospital network",
                            displayName: "Our hospital network",
                            fields: {
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              title: { value: "Our hospital network" },
                              link: {
                                value: {
                                  href: "https://www.fwd.com.my/hospital-locator/",
                                  text: "Our hospital network",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "",
                                  target: "",
                                  querystring: "",
                                  id: "{3B8170E0-F577-42A6-875A-C756E83ABF6E}",
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaLabelName: { value: "" },
                              gaCategoryName: { value: "" },
                            },
                          },
                          {
                            id: "a17ba21b-3b9d-490c-b009-9b702d027fcd",
                            name: "Fund information",
                            displayName: "Fund information",
                            fields: {
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              title: { value: "Fund information" },
                              link: {
                                value: {
                                  href: "https://www.fwd.com.my/products/invest/fund-valuation/",
                                  text: "",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "",
                                  target: "",
                                  querystring: "",
                                  id: "{A01A3DBB-E764-4C26-921D-674D39A9019C}",
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaLabelName: { value: "" },
                              gaCategoryName: { value: "" },
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    id: "cfd3aabd-0c83-4120-977e-7e7cd8f854c1",
                    name: "column-4",
                    displayName: "Column 4",
                    fields: {},
                    Children: [
                      {
                        id: "91beb8ff-a15a-40de-a714-4bd517326f45",
                        name: "About us",
                        displayName: "About us",
                        fields: {
                          buttonIcon: {
                            id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                            fieldType: "CustomDroplink",
                            fieldName: "buttonIcon",
                            url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                            fields: {
                              value: { value: "chevron-right" },
                              key: { value: "chevronRight" },
                            },
                          },
                          title: { value: "About us" },
                          link: {
                            value: {
                              href: "https://www.fwd.com.my/about-us/",
                              text: "",
                              anchor: "",
                              linktype: "internal",
                              class: "",
                              title: "",
                              querystring: "",
                              id: "{E29AE3B4-0EF7-4A19-94D0-5A773DA078BF}",
                            },
                          },
                          listType: {
                            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                            fieldType: "Droplink",
                            fieldName: "listType",
                            url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                            fields: {
                              value: { value: "Generic Link" },
                              key: { value: "generic_link" },
                            },
                          },
                          gaLabelName: { value: "" },
                          gaCategoryName: { value: "" },
                        },
                      },
                      {
                        id: "9481e12b-94d9-454a-acd7-2c9f4cdf2a7c",
                        name: "Join us",
                        displayName: "Join us",
                        fields: {
                          buttonIcon: {
                            id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                            fieldType: "CustomDroplink",
                            fieldName: "buttonIcon",
                            url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                            fields: {
                              value: { value: "chevron-right" },
                              key: { value: "chevronRight" },
                            },
                          },
                          title: { value: "Join us" },
                          link: {
                            value: {
                              href: "https://www.fwd.com.my/careers/",
                              text: "",
                              anchor: "",
                              linktype: "internal",
                              class: "",
                              title: "",
                              target: "",
                              querystring: "",
                              id: "{A61D2946-60B9-4D8B-8BDC-003EE572A248}",
                            },
                          },
                          listType: {
                            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                            fieldType: "Droplink",
                            fieldName: "listType",
                            url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                            fields: {
                              value: { value: "Generic Link" },
                              key: { value: "generic_link" },
                            },
                          },
                          gaLabelName: { value: "" },
                          gaCategoryName: { value: "" },
                        },
                      },
                      {
                        id: "7645f830-98e7-47e7-96c3-6d5c79f49d6e",
                        name: "News releases",
                        displayName: "News releases",
                        fields: {
                          buttonIcon: {
                            id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                            fieldType: "CustomDroplink",
                            fieldName: "buttonIcon",
                            url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                            fields: {
                              value: { value: "chevron-right" },
                              key: { value: "chevronRight" },
                            },
                          },
                          title: { value: "News releases" },
                          link: {
                            value: {
                              href: "https://www.fwd.com.my/press/",
                              text: "",
                              anchor: "",
                              linktype: "internal",
                              class: "",
                              title: "",
                              target: "",
                              querystring: "",
                              id: "{9C7F0FF7-348D-4B78-8E7B-88321D26DC76}",
                            },
                          },
                          listType: {
                            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                            fieldType: "Droplink",
                            fieldName: "listType",
                            url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                            fields: {
                              value: { value: "Generic Link" },
                              key: { value: "generic_link" },
                            },
                          },
                          gaLabelName: { value: "" },
                          gaCategoryName: { value: "" },
                        },
                      },
                    ],
                  },
                ],
                countrySelector: [
                  {
                    id: "fc1eb478-c5ad-47a7-8aea-864133ac63db",
                    name: "FWD Group",
                    displayName: "FWD Group",
                    fields: {
                      isDefault: { value: false },
                      buttonIcon: null,
                      title: { value: "FWD Group" },
                      link: {
                        value: {
                          href: "https://www.fwd.com/",
                          text: "FWD Group",
                          linktype: "external",
                          url: "https://www.fwd.com/",
                          anchor: "",
                          target: "_blank",
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "2a8c3247-1efb-4c5c-9188-46aff2bc4af2",
                    name: "Cambodia",
                    displayName: "Cambodia",
                    fields: {
                      isDefault: { value: false },
                      buttonIcon: null,
                      title: { value: "Cambodia" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.kh/",
                          text: "Cambodia",
                          linktype: "external",
                          url: "https://www.fwd.com.kh/",
                          anchor: "",
                          target: "_blank",
                        },
                      },
                      listType: {
                        id: "f281af72-fa4b-4f87-98f1-4b9d77180e60",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "6155fb51-0c83-4f83-81a0-d3cc4c6915c1",
                    name: "Hong Kong",
                    displayName: "Hong Kong",
                    fields: {
                      isDefault: { value: false },
                      buttonIcon: null,
                      title: { value: "Hong Kong" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.hk/en/",
                          text: "Hong Kong",
                          linktype: "external",
                          url: "https://www.fwd.com.hk/en/",
                          anchor: "",
                          target: "_blank",
                        },
                      },
                      listType: {
                        id: "f281af72-fa4b-4f87-98f1-4b9d77180e60",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "b9a14c94-20c4-47c8-96da-d4ef066f66ec",
                    name: "Indonesia",
                    displayName: "Indonesia",
                    fields: {
                      isDefault: { value: false },
                      buttonIcon: null,
                      title: { value: "Indonesia" },
                      link: {
                        value: {
                          href: "https://www.fwd.co.id/",
                          text: "Indonesia",
                          linktype: "external",
                          url: "https://www.fwd.co.id/",
                          anchor: "",
                          target: "_blank",
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "c6a85dde-9c2e-40a0-b81a-b772285b262f",
                    name: "Japan",
                    displayName: "Japan",
                    fields: {
                      isDefault: { value: false },
                      buttonIcon: null,
                      title: { value: "Japan" },
                      link: {
                        value: {
                          href: "http://www.fwdlife.co.jp",
                          linktype: "external",
                          url: "http://www.fwdlife.co.jp",
                          anchor: "",
                          target: "",
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "68fb5672-9cfe-4c6e-b047-8837286a4d16",
                    name: "Macau",
                    displayName: "Macau",
                    fields: {
                      isDefault: { value: false },
                      buttonIcon: null,
                      title: { value: "Macau" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.vn/en/",
                          text: "Macau",
                          linktype: "external",
                          url: "https://www.fwd.com.vn/en/",
                          anchor: "",
                          target: "_blank",
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "6f4be9dc-4cfa-4ec3-bbe2-1f690c2342cc",
                    name: "Malaysia",
                    displayName: "Malaysia",
                    fields: {
                      isDefault: { value: true },
                      buttonIcon: null,
                      title: { value: "Malaysia" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.my/",
                          text: "",
                          anchor: "",
                          linktype: "internal",
                          class: "",
                          title: "",
                          querystring: "",
                          id: "{ED1C1C9C-BAFE-45EF-ABDD-C1BDE7D278BF}",
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "2efe1c70-1706-48dd-a7b6-13185fde4ecc",
                    name: "Philipines",
                    displayName: "Philipines",
                    fields: {
                      isDefault: { value: false },
                      buttonIcon: null,
                      title: { value: "Philipines" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.ph/",
                          text: "Philipines",
                          linktype: "external",
                          url: "https://www.fwd.com.ph/",
                          anchor: "",
                          target: "_blank",
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "875e163c-ffe8-4f80-be37-48221f095a82",
                    name: "Singapore",
                    displayName: "Singapore",
                    fields: {
                      isDefault: { value: false },
                      buttonIcon: null,
                      title: { value: "Singapore" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.sg/",
                          text: "Singapore",
                          linktype: "external",
                          url: "https://www.fwd.com.sg/",
                          anchor: "",
                          target: "_blank",
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "28ff0713-bc7c-49b1-b59b-dc5bd28e3c3c",
                    name: "Thailand",
                    displayName: "Thailand",
                    fields: {
                      isDefault: { value: false },
                      buttonIcon: null,
                      title: { value: "Thailand" },
                      link: {
                        value: {
                          href: "https://www.fwd.co.th/",
                          text: "Thailand",
                          linktype: "external",
                          url: "https://www.fwd.co.th/",
                          anchor: "",
                          target: "_blank",
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "44505fa1-98a3-4bf8-bfc3-d14ac8b51a48",
                    name: "Vietnam",
                    displayName: "Vietnam",
                    fields: {
                      isDefault: { value: false },
                      buttonIcon: null,
                      title: { value: "Vietnam" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.vn/en/",
                          text: "Vietnam",
                          linktype: "external",
                          url: "https://www.fwd.com.vn/en/",
                          anchor: "",
                          target: "_blank",
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                ],
                socialMediaLinks: [
                  {
                    id: "bd521692-b585-4b4c-bd29-356108e1c90e",
                    name: "Facebook",
                    displayName: "Facebook",
                    fields: {
                      buttonIcon: {
                        id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                        fieldType: "CustomDroplink",
                        fieldName: "buttonIcon",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                        fields: {
                          value: { value: "chevron-right" },
                          key: { value: "chevronRight" },
                        },
                      },
                      title: { value: "Facebook" },
                      link: {
                        value: {
                          href: "https://www.facebook.com/fwd.takaful/",
                          text: "facebook",
                          linktype: "external",
                          url: "https://www.facebook.com/fwd.takaful/",
                          anchor: "",
                          target: "",
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "a10aba02-15b6-4c9e-912e-39b75a9dbe2f",
                    name: "Instagram",
                    displayName: "Instagram",
                    fields: {
                      buttonIcon: {
                        id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                        fieldType: "CustomDroplink",
                        fieldName: "buttonIcon",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                        fields: {
                          value: { value: "chevron-right" },
                          key: { value: "chevronRight" },
                        },
                      },
                      title: { value: "Instagram" },
                      link: {
                        value: {
                          href: "https://instagram.com/fwdtakaful",
                          text: "twitter",
                          linktype: "external",
                          url: "https://instagram.com/fwdtakaful",
                          anchor: "",
                          target: "",
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "78da369e-a10e-4521-ae6a-9686e4960995",
                    name: "WhatsApp",
                    displayName: "WhatsApp",
                    fields: {
                      buttonIcon: {
                        id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                        fieldType: "CustomDroplink",
                        fieldName: "buttonIcon",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                        fields: {
                          value: { value: "chevron-right" },
                          key: { value: "chevronRight" },
                        },
                      },
                      title: { value: "WhatsApp" },
                      link: { value: {} },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "626d30ca-e478-4c89-956d-f7726de0f8bb",
                    name: "YouTube",
                    displayName: "YouTube",
                    fields: {
                      buttonIcon: {
                        id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                        fieldType: "CustomDroplink",
                        fieldName: "buttonIcon",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                        fields: {
                          value: { value: "chevron-right" },
                          key: { value: "chevronRight" },
                        },
                      },
                      title: { value: "Youtube" },
                      link: {
                        value: {
                          href: "https://www.youtube.com/channel/UChNt9gRA2f1w49ZZQWjLhjQ?view_as=subscriber",
                          text: "youtube",
                          linktype: "external",
                          url: "https://www.youtube.com/channel/UChNt9gRA2f1w49ZZQWjLhjQ?view_as=subscriber",
                          anchor: "",
                          target: "",
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                ],
                footerQuickLinks: [
                  {
                    id: "2a6ee04f-9d16-4465-98b2-e1e1f585cd43",
                    name: "Sitemap",
                    displayName: "Sitemap",
                    fields: {
                      buttonIcon: {
                        id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                        fieldType: "CustomDroplink",
                        fieldName: "buttonIcon",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                        fields: {
                          value: { value: "chevron-right" },
                          key: { value: "chevronRight" },
                        },
                      },
                      title: { value: "Sitemap" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.my/sitemap/",
                          text: "Sitemap",
                          anchor: "",
                          linktype: "internal",
                          class: "",
                          title: "Sitemap",
                          querystring: "",
                          id: "{2C9306E1-B426-49E2-B2F7-26D552F238A3}",
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "f2923fc8-51f9-48f3-a0ad-088dd71aa431",
                    name: "Online security",
                    displayName: "Online security",
                    fields: {
                      buttonIcon: {
                        id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                        fieldType: "CustomDroplink",
                        fieldName: "buttonIcon",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                        fields: {
                          value: { value: "chevron-right" },
                          key: { value: "chevronRight" },
                        },
                      },
                      title: { value: "Online security" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.my/online-security/",
                          text: "Online security",
                          anchor: "",
                          linktype: "internal",
                          class: "",
                          title: "Data Protection Policy",
                          target: "",
                          querystring: "",
                          id: "{B77B47F5-0206-49EE-A6F2-8D6B609EAA40}",
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "fa98bdca-3a55-406d-9027-c697c3b0f70f",
                    name: "Terms and conditions",
                    displayName: "Terms and conditions",
                    fields: {
                      buttonIcon: {
                        id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                        fieldType: "CustomDroplink",
                        fieldName: "buttonIcon",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                        fields: {
                          value: { value: "chevron-right" },
                          key: { value: "chevronRight" },
                        },
                      },
                      title: { value: "Terms & Conditions" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.my/terms-conditions/",
                          text: "Terms and conditions",
                          anchor: "",
                          linktype: "internal",
                          class: "",
                          title: "Data Protection Policy",
                          target: "",
                          querystring: "",
                          id: "{CDF8D4C9-32B0-48A7-8F48-72A3FA2B679B}",
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "2055cc99-5701-41fc-a1b3-fc278619f0bf",
                    name: "Privacy policy",
                    displayName: "Privacy policy",
                    fields: {
                      buttonIcon: {
                        id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                        fieldType: "CustomDroplink",
                        fieldName: "buttonIcon",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                        fields: {
                          value: { value: "chevron-right" },
                          key: { value: "chevronRight" },
                        },
                      },
                      title: { value: "Privacy policy" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.my/tkfl-privacy-policy/",
                          text: "Privacy policy",
                          anchor: "",
                          linktype: "internal",
                          class: "",
                          title: "Privacy Policy",
                          target: "",
                          querystring: "",
                          id: "{FDFB7B45-FF89-42E7-B0AD-ACBF25D61708}",
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "366b4ecd-4ed2-4a7c-b99b-93967b805582",
                    name: "Cookie policy",
                    displayName: "Cookie policy",
                    fields: {
                      buttonIcon: {
                        id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                        fieldType: "CustomDroplink",
                        fieldName: "buttonIcon",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                        fields: {
                          value: { value: "chevron-right" },
                          key: { value: "chevronRight" },
                        },
                      },
                      title: { value: "Cookie policy" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.my/cookie-policy/",
                          text: "Cookie policy",
                          anchor: "",
                          linktype: "internal",
                          class: "",
                          title: "Cookie Policy",
                          target: "",
                          querystring: "",
                          id: "{BC4C1B52-43D2-4796-A417-ED4BA9FF25CD}",
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "1c030eed-5359-4808-bcaa-b6a8575f634f",
                    name: "Personal data protection policy",
                    displayName: "Personal data protection policy",
                    fields: {
                      buttonIcon: {
                        id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                        fieldType: "CustomDroplink",
                        fieldName: "buttonIcon",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                        fields: {
                          value: { value: "chevron-right" },
                          key: { value: "chevronRight" },
                        },
                      },
                      title: { value: "Personal data protection policy" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.my/tkfl-personal-data-protection-notice/",
                          text: "Personal data protection policy",
                          anchor: "",
                          linktype: "internal",
                          class: "",
                          title: "Personal data protection policy",
                          target: "",
                          querystring: "",
                          id: "{A3889559-EE87-4039-A814-8515D709856F}",
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "948b847d-4e66-45b8-902f-12b779caadcd",
                    name: "Common reporting standard",
                    displayName: "Common reporting standard",
                    fields: {
                      buttonIcon: {
                        id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                        fieldType: "CustomDroplink",
                        fieldName: "buttonIcon",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                        fields: {
                          value: { value: "chevron-right" },
                          key: { value: "chevronRight" },
                        },
                      },
                      title: { value: "Common reporting standard" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.my/important-notice/crs-customer-faq/",
                          text: "Common reporting standard",
                          anchor: "",
                          linktype: "internal",
                          class: "",
                          title: "Common reporting standard",
                          target: "",
                          querystring: "",
                          id: "{3D693352-6607-47A1-AC7C-5655E31670D4}",
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                  {
                    id: "b663fa09-adb0-48e4-a28a-c02ff18ff4dc",
                    name: "Important notice",
                    displayName: "Important notice",
                    fields: {
                      buttonIcon: {
                        id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                        fieldType: "CustomDroplink",
                        fieldName: "buttonIcon",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                        fields: {
                          value: { value: "chevron-right" },
                          key: { value: "chevronRight" },
                        },
                      },
                      title: { value: "Important notice" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.my/important-notice/",
                          text: "",
                          anchor: "",
                          linktype: "internal",
                          class: "",
                          title: "",
                          querystring: "",
                          id: "{BE103AFE-950D-4576-AA2B-5A46A20B8E04}",
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaLabelName: { value: "" },
                      gaCategoryName: { value: "" },
                    },
                  },
                ],
                copyrightLabel: {
                  value:
                    "<p>Copyright 2022 FWD Takaful Berhad. All rights reserved.<br />\nFWD Takaful Berhad, Registration No. 200601011780 (731530-M)</p>",
                },
                logo: {
                  value: {
                    src: "https://www.fwd.com.my/-/media/global/images/fwd-logo_colour.svg?rev=77f0e92219254f9caea8bbe5bba16478",
                    alt: "FWD logo svg",
                  },
                },
                logoLink: {
                  value: {
                    href: "https://www.fwd.com/mys/home",
                    linktype: "external",
                    url: "https://www.fwd.com/mys/home",
                    anchor: "",
                    target: "",
                  },
                },
                icon: {
                  id: "0853a008-9b3c-4a10-98b9-1e96a3cdc253",
                  fieldType: "CustomDroplink",
                  fieldName: "icon",
                  url: "https://www.fwd.com.my/sitecore/content/fwd/global/settings/list/linkvariant/call",
                  fields: { value: { value: "call" }, key: { value: "Call" } },
                },
                call: { value: "1300 13 7988" },
                enableCallingHoursText: { value: false },
                callingHoursTextBeforeTooltip: { value: "" },
                callingHoursTooltip: { value: "" },
                callingHoursTextAfterTooltip: { value: "" },
                defaultComplianceAccreditation: null,
                disableComplianceAccreditation: { value: false },
                gaLabelName: { value: "" },
                gaCategoryName: { value: "" },
                enableLanguageToggle: { value: true },
                languageList: [
                  {
                    id: "440955d7-719b-4fe5-9d42-37fd2c4a9083",
                    fields: {
                      languageName: { value: "EN" },
                      defaultLanguage: { value: "Bm" },
                      languageCode: { value: "en" },
                    },
                  },
                ],
                languageModalDescription: { value: "" },
                languageModalLink: { value: {} },
                languageModalSecondaryLink: { value: "" },
                languageModalTitle: { value: "" },
              },
            },
          ],
        },
      },
    },
    productDetails: {
      initializer: "bookAnAgent",
      enquiryInitializer: "SUPPORT",
      productName: "",
      minAge: "",
      maxAge: "",
      minSumAssured: "",
      maxSumAssured: "",
      calculationOptions: [],
      sumAssuredSelectionType: "",
      premiumSelectionType: "",
      minPremiumYearly: "",
      maxPremiumYearly: "",
      sumAssuredRange: "",
      sumAssuredPaymentMode: [],
      purchaseMethod: [],
      premiumRange: "",
      premiumStepperInterval: "",
      sumAssuredStepperInterval: "",
      plans: [],
      ridersAvailable: null,
      enableEnquiryForRiders: null,
      associatedItems: [],
      filteredAssociatedItems: [],
      allPlanCards: [],
      productType: "",
      talkToAgentLink: null,
      talkToAgentTitle: "",
      expectedInsuranceType: "",
      parameters: null,
      expectedInsuranceTypeProductCard: "",
      parametersProductCard: "",
    },
    formLinks: {
      calculateFormLink: "",
      recommenderFormLink: "",
      enquiryFormLink: "",
      callbackFormLink:
        "https://www.fwd.com.my/sitecore/api/layout/render/jss?item=/formslist/general-enquiry-form&sc_lang=en&sc_apikey={D7333054-1DCE-4B0C-A9A5-AC7372A796AB}",
    },
    finalizer: "",
    apiStatus: {
      loading: false,
      apiStatus: null,
      errorCode: "",
      failCounter: 0,
    },
    form: {
      sitecore: {
        context: {
          pageEditing: false,
          site: {
            name: "fwd-my"
          },
          pageState: "normal",
          language: "en",
          languageCode: "en",
          defaultLanguage: "en",
          siteSettings: {
            productListPage: "/products/",
            splashPage: "",
            articleTagLink: "",
            articleTypeDesign: [],
            articleOverlineText: false,
            globalMetaText: "FWD Malaysia",
            globalMetaTag: "",
            cookieMessage: "<p>We use cookies to give the best possible web experience. By continuing to use our website we assume you accept how we use cookies and your data.</p>\n<p>This in keeping with our&nbsp;<a href=\"/privacy-policy/\">Privacy Policy</a>&nbsp;and <a href=\"/cookie-policy\">Cookie Policy</a></p>\n<p>&nbsp;</p>",
            cookieTimeStamp: "10",
            currencyPlacement: "BeforeNumericals",
            currencyWhitespace: true,
            currencySeparator: {
              value: {}
            },
            currencyLabel: {
              value: {}
            },
            splashPageUpdatedDuration: "10",
            splashPageUpdatedDate: "",
            faviconImageUrl: "/-/media/global/images/icons/favicon.ico?rev=51cce1bfcfb347b3b2fc7d304180401d",
            productErrorPictogramUrl: "",
            dateFormat: "D MMMM YYYY",
            enablePlanCardSharePostCalc: "",
            sessionTimeout: "20",
            loaderTimeout: "",
            gAID: "GTM-WJDCXC5",
            gTMID: "GTM-WJDCXC5",
            gtmParamters: [],
            optimize360: true,
            eurolandTool: false,
            hostName: "https://web.fwd.com.my",
            enableBackToTopButton: 1,
            dialogSessionTimeout: "",
            productFallbackCTA: {
              value: {
                href: "/formslist/product-enquiry-form",
                text: "Enquire",
                anchor: "",
                linkType: "form",
                title: "",
                queryString: "enquiry",
                id: "{D048F950-F6F5-401D-8FD4-6825D1B4413E}",
                gaLabel: ""
              }
            },
            brightcoveAccountID: "5650355171001",
            languageIcon: {},
            enableMultipleNotifications: true,
            hidePrimaryLanguage: true,
            currencyGALabelName: "",
            showArticleSubtitle: false,
            hasArticleSubtitleFallback: false
          },
          share: {
            socialApps: [
              {
                facebook: {
                  header: {
                    value: "Share on Facebook"
                  },
                  toolTip: {
                    value: ""
                  },
                  url: {
                    value: {
                      href: "https://www.facebook.com/sharer.php?u=",
                      text: "Facebook Url",
                      linktype: "external",
                      url: "https://www.facebook.com/sharer.php?u=",
                      anchor: "",
                      target: ""
                    }
                  }
                }
              },
              {
                twitter: {
                  header: {
                    value: "Share on Twitter"
                  },
                  toolTip: {
                    value: ""
                  },
                  url: {
                    value: {
                      href: "https://twitter.com/intent/tweet?text=",
                      text: "Twitter Url",
                      linktype: "external",
                      url: "https://twitter.com/intent/tweet?text=",
                      anchor: "",
                      target: ""
                    }
                  }
                }
              },
              {
                whatsapp: {
                  header: {
                    value: "Share on WhatsApp"
                  },
                  toolTip: {
                    value: ""
                  },
                  url: {
                    value: {
                      href: "https://whatsapp://send?text=",
                      text: "WhatsApp Url",
                      linktype: "external",
                      url: "https://whatsapp://send?text=",
                      anchor: "",
                      target: ""
                    }
                  }
                }
              }
            ]
          },
          siteNotifications: {
            notifications: []
          },
          dialogModals: {
            modalList: []
          },
          disclosurePopups: {
            popupList: []
          },
          localizedPages: [
            {
              en: "/formslist/general-enquiry-form"
            }
          ],
          isRequestFromExternalSource: true,
          availableLanguages: [
            "en"
          ]
        },
        route: {
          name: "general-enquiry-form",
          displayName: "General Enquiry Form",
          fields: {
            apiList: [
              {
                id: "2334a4bf-d431-461f-b313-1dd10100c27e",
                fields: {
                  apiName: {
                    value: "Email"
                  },
                  value: {
                    value: process.env.REACT_APP_LEAD_FORM_API_URL ?? "https://1web-dev.apse1.dgt.np-api.fwd.com/api/enquiry/general-save-lead"
                  },
                  key: {
                    value: "C9VX6X34b56tC2n2b67hlL5N97VoHguVy1mVnH65KgCm0MWVATlgx9Z453Zb0gE0HXpOzo0Z6ery6oRiNN28z34mBk"
                  }
                }
              }
            ],
            formEmailTemplate: {
              value: {
                href: "/formslist/general-enquiry-form/general-enquiry-email-template/",
                text: "",
                anchor: "",
                linktype: "form",
                class: "",
                title: "",
                querystring: "",
                target: "",
                id: "{4C5FCC42-AECC-4D32-A55C-C1D031EF969D}",
                apiKey: "{D7333054-1DCE-4B0C-A9A5-AC7372A796AB}",
                apiHost: 'https://www.fwd.com.my'
              }
            },
            enableProductName: {
              value: true
            },
            gtmEventType: null,
            dynamicFormParams: {
              value: {}
            }
          },
          databaseName: "web",
          deviceId: "fe5d7fdf-89c0-4d99-9aa3-b5fbd009c9f3",
          itemId: "61a3597b-2bee-4ad4-9473-92ecd5dbf4d0",
          itemLanguage: "en",
          itemVersion: 1,
          layoutId: "e60605a5-f4f9-479a-b992-741bce767b1d",
          templateId: "d48ab251-45a3-498a-a8c1-629e33a6b9b4",
          templateName: "Form",
          placeholders: {
            "jss-metadata": [],
            "jss-header": [],
            "jss-main": [
              {
                uid: "da48a850-ee29-44f2-81cb-334204bfb850",
                componentName: "Forms",
                dataSource: "{A05E9C5B-6C30-4AC6-8DB6-698E8E7294F0}",
                params: {
                  formType: "conversational"
                },
                fields: {
                  items: [
                    {
                      id: "d6b88389-f136-4ac0-a3bc-488e151cc9fc",
                      name: "splashScreen",
                      displayName: "splashScreen",
                      parentId: "a05e9c5b-6c30-4ac6-8db6-698e8e7294f0",
                      fields: {
                        gaLabel: {
                          value: ""
                        },
                        backgroundColor: {
                          id: "b47928d6-98fc-4b29-8d0f-586ab477286e",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/orangewhite",
                          fields: {
                            value: {
                              value: "orange-white"
                            },
                            key: {
                              value: "OrangeWhite"
                            }
                          }
                        },
                        "Css Class": {
                          value: "splashScreenPage darkMode"
                        },
                        isHidden: {
                          value: false
                        },
                        HelpText: {
                          value: ""
                        },
                        GeneralError: {
                          value: ""
                        },
                        SpecificError: {
                          value: ""
                        },
                        apiName: null,
                        serverValidationErrorText: {
                          value: ""
                        },
                        serverValidationLoadingText: {
                          value: ""
                        },
                        enableServerValidation: {
                          value: false
                        },
                        serverValidationAPI: null,
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: {
                              value: "Eggplant"
                            },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png"
                            },
                            IsDisabled: {
                              value: false
                            },
                            SpritePosition: {
                              value: ""
                            },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {}
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value: "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms"
                            },
                            "Property Editor": null,
                            "View Path": {
                              value: "FieldTemplates/Page"
                            }
                          }
                        },
                        Conditions: {
                          value: "{\"fieldConditions\":[]}"
                        },
                        "Field Key": {
                          value: "3F83046E6287400389197ECF35DAA74D"
                        },
                        "Collapsed by Default": {
                          value: false
                        }
                      },
                      items: [
                        {
                          id: "dd18cc51-aa4e-4c59-a824-4821916131e3",
                          name: "introText",
                          displayName: "introText",
                          parentId: "d6b88389-f136-4ac0-a3bc-488e151cc9fc",
                          fields: {
                            "Html Tag": {
                              value: "p"
                            },
                            Text: {
                              value: "Help us understand your enquiry"
                            },
                            "Css Class": {
                              value: "intro"
                            },
                            isHidden: {
                              value: false
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: {
                                  value: ""
                                },
                                key: {
                                  value: ""
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: {
                                  value: "Sky"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {}
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Text"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "F0B323C89D9942BFA7DA017E69B864AB"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: []
                        },
                        {
                          id: "80dde673-aee2-44b4-a89b-d50266899677",
                          name: "Text",
                          displayName: "Text",
                          parentId: "d6b88389-f136-4ac0-a3bc-488e151cc9fc",
                          fields: {
                            "Html Tag": {
                              value: "p"
                            },
                            Text: {
                              value: "The information you provide will help us better address your needs."
                            },
                            "Css Class": {
                              value: "splashScreenDisclaimer"
                            },
                            isHidden: {
                              value: false
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: {
                                  value: ""
                                },
                                key: {
                                  value: ""
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: {
                                  value: "Sky"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {}
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Text"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "89B5A6C3C7D84BCEAB2F22A622F968AE"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: []
                        },
                        {
                          id: "c25545d6-c55f-4493-ba72-c57dcdd5fcbc",
                          name: "splashScreenClick",
                          displayName: "splashScreenClick",
                          parentId: "d6b88389-f136-4ac0-a3bc-488e151cc9fc",
                          fields: {
                            "Navigation Step": {
                              value: "1"
                            },
                            emailTemplateLink: {
                              value: ""
                            },
                            "Css Class": {
                              value: ""
                            },
                            isHidden: {
                              value: false
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: {
                                  value: ""
                                },
                                key: {
                                  value: ""
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Label Css Class": {
                              value: ""
                            },
                            Title: {
                              value: "Start"
                            },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: {
                                  value: "Eggplant"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/button.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {}
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Button"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "12A1320BA02240D6A3DAA22D4CD38950"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: []
                        }
                      ]
                    },
                    {
                      id: "c0e4e954-25a3-4d17-856f-178bd97861f4",
                      name: "taskPage",
                      displayName: "taskPage",
                      parentId: "a05e9c5b-6c30-4ac6-8db6-698e8e7294f0",
                      fields: {
                        gaLabel: {
                          value: ""
                        },
                        backgroundColor: {
                          id: "cbdc6265-d09f-4982-981a-bcc8f118f36f",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/whiteorange",
                          fields: {
                            value: {
                              value: "white-orange"
                            },
                            key: {
                              value: "WhiteOrange"
                            }
                          }
                        },
                        "Css Class": {
                          value: "interestedPage"
                        },
                        isHidden: {
                          value: false
                        },
                        HelpText: {
                          value: ""
                        },
                        GeneralError: {
                          value: ""
                        },
                        SpecificError: {
                          value: ""
                        },
                        apiName: null,
                        serverValidationErrorText: {
                          value: ""
                        },
                        serverValidationLoadingText: {
                          value: ""
                        },
                        enableServerValidation: {
                          value: false
                        },
                        serverValidationAPI: null,
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: {
                              value: "Eggplant"
                            },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png"
                            },
                            IsDisabled: {
                              value: false
                            },
                            SpritePosition: {
                              value: ""
                            },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {}
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value: "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms"
                            },
                            "Property Editor": null,
                            "View Path": {
                              value: "FieldTemplates/Page"
                            }
                          }
                        },
                        Conditions: {
                          value: "{\"fieldConditions\":[]}"
                        },
                        "Field Key": {
                          value: "04B6B0BE40774539912EB6E4268008B9"
                        },
                        "Collapsed by Default": {
                          value: false
                        }
                      },
                      items: [
                        {
                          id: "96b64934-0b40-4040-b562-e37ba5007941",
                          name: "Text",
                          displayName: "Text",
                          parentId: "c0e4e954-25a3-4d17-856f-178bd97861f4",
                          fields: {
                            "Html Tag": {
                              value: "p"
                            },
                            Text: {
                              value: "I would like to"
                            },
                            "Css Class": {
                              value: "block"
                            },
                            isHidden: {
                              value: false
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: {
                                  value: ""
                                },
                                key: {
                                  value: ""
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: {
                                  value: "Sky"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {}
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Text"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "B5C635B295AC460DB7A7644CD8A4B416"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: []
                        },
                        {
                          id: "59553efa-309e-4f80-9a71-a58c1f774508",
                          name: "taskOptionsList",
                          displayName: "Call Back Reasons",
                          parentId: "c0e4e954-25a3-4d17-856f-178bd97861f4",
                          fields: {
                            Datasource: {
                              id: "fddc7ff5-e84d-4f73-9828-03d25871a2a2",
                              fieldType: "Droptree",
                              fieldName: "Datasource",
                              url: "/content/forms/tasks",
                              fields: {}
                            },
                            "Default Selection": {
                              value: ""
                            },
                            "Display Field Name": {
                              value: "value"
                            },
                            "Is Dynamic": {
                              value: true
                            },
                            "Value Field Name": {
                              value: "value"
                            },
                            "Css Class": {
                              value: "block"
                            },
                            isHidden: {
                              value: false
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "02e6f52d-421f-4179-b9f6-9cc0863cc4da",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/queryreason",
                              fields: {
                                value: {
                                  value: "queryReason"
                                },
                                key: {
                                  value: "queryReason"
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Label Css Class": {
                              value: ""
                            },
                            Title: {
                              value: ""
                            },
                            Required: {
                              value: true
                            },
                            Validations: [],
                            "Is Tracking Enabled": {
                              value: true
                            },
                            "Allow Save": {
                              value: true
                            },
                            "Value Provider Parameters": {
                              value: ""
                            },
                            "Value Provider": null,
                            "Field Type": {
                              id: "edbd38a8-1ae9-42ec-8ccd-f5b0e2998b4f",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/lists/radio-button-list",
                              fields: {
                                BackgroundColor: {
                                  value: "Grass"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/radio_button_group.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "5b672865-55d2-413e-b699-fdfc7e732ccf",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/list",
                                  fields: {}
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomRadioButtonListViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/RadioButtonList"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "93BF0439473B468BBC93BC561328CA9D"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: [
                            {
                              id: "61ec8b99-b467-4ac2-b37e-aa5ea63ddded",
                              name: "makeAnEnquiry",
                              displayName: "Make a general inquiry",
                              parentId: "fddc7ff5-e84d-4f73-9828-03d25871a2a2",
                              fields: {
                                value: {
                                  value: "make a general inquiry"
                                },
                                key: {
                                  value: "2"
                                }
                              }
                            },
                            {
                              id: "c6471b07-202e-40d3-96b1-759a91548b5e",
                              name: "giveFeedback",
                              displayName: "Give feedback or make a complaint",
                              parentId: "fddc7ff5-e84d-4f73-9828-03d25871a2a2",
                              fields: {
                                value: {
                                  value: "give feedback or submit a complaint"
                                },
                                key: {
                                  value: "3"
                                }
                              }
                            },
                            {
                              id: "cf7f747a-a7f8-487c-a5b5-0a116ca6e12e",
                              name: "meetAnAgent",
                              displayName: "Book time with an agent",
                              parentId: "fddc7ff5-e84d-4f73-9828-03d25871a2a2",
                              fields: {
                                value: {
                                  value: "ask about my current plan"
                                },
                                key: {
                                  value: "1"
                                }
                              }
                            },
                            {
                              id: "704d3cfe-f7a5-4313-93de-13c18b80e41d",
                              name: "others",
                              displayName: "ask something else",
                              parentId: "fddc7ff5-e84d-4f73-9828-03d25871a2a2",
                              fields: {
                                value: {
                                  value: "check the status of my claims"
                                },
                                key: {
                                  value: "4"
                                }
                              }
                            }
                          ]
                        },
                        {
                          id: "eaf4543d-ae3a-4188-9160-3b5ec134b321",
                          name: "tasksNextButtonClick",
                          displayName: "Next Page",
                          parentId: "c0e4e954-25a3-4d17-856f-178bd97861f4",
                          fields: {
                            "Navigation Step": {
                              value: "1"
                            },
                            emailTemplateLink: {
                              value: ""
                            },
                            "Css Class": {
                              value: "next-button"
                            },
                            isHidden: {
                              value: false
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: {
                                  value: ""
                                },
                                key: {
                                  value: ""
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Label Css Class": {
                              value: ""
                            },
                            Title: {
                              value: "Next"
                            },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: {
                                  value: "Eggplant"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/button.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {}
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Button"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "0B059E90D26E41B2B35BE476FB35A168"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: [
                            {
                              id: "e580f1e6-727f-44c5-947f-4a7ace3b0446",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "eaf4543d-ae3a-4188-9160-3b5ec134b321",
                              fields: {
                                Description: {
                                  value: "Name"
                                },
                                Parameters: {
                                  value: "{\"referenceId\":\"{6C8EAA92-EDA4-4624-AD2F-581256D049EA}\"}"
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": {
                                      value: "Redirect to page failed!"
                                    },
                                    "Model Type": {
                                      value: "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage"
                                    }
                                  }
                                }
                              },
                              items: []
                            }
                          ]
                        }
                      ]
                    },
                    {
                      id: "6c8eaa92-eda4-4624-ad2f-581256d049ea",
                      name: "namePage",
                      displayName: "Name",
                      parentId: "a05e9c5b-6c30-4ac6-8db6-698e8e7294f0",
                      fields: {
                        gaLabel: {
                          value: ""
                        },
                        backgroundColor: {
                          id: "cbdc6265-d09f-4982-981a-bcc8f118f36f",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/whiteorange",
                          fields: {
                            value: {
                              value: "white-orange"
                            },
                            key: {
                              value: "WhiteOrange"
                            }
                          }
                        },
                        "Css Class": {
                          value: "namePage"
                        },
                        isHidden: {
                          value: false
                        },
                        HelpText: {
                          value: ""
                        },
                        GeneralError: {
                          value: ""
                        },
                        SpecificError: {
                          value: ""
                        },
                        apiName: null,
                        serverValidationErrorText: {
                          value: ""
                        },
                        serverValidationLoadingText: {
                          value: ""
                        },
                        enableServerValidation: {
                          value: false
                        },
                        serverValidationAPI: null,
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: {
                              value: "Eggplant"
                            },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png"
                            },
                            IsDisabled: {
                              value: false
                            },
                            SpritePosition: {
                              value: ""
                            },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {}
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value: "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms"
                            },
                            "Property Editor": null,
                            "View Path": {
                              value: "FieldTemplates/Page"
                            }
                          }
                        },
                        Conditions: {
                          value: "{\"fieldConditions\":[]}"
                        },
                        "Field Key": {
                          value: "F2B07BE6685F41968F59E8E76ABBC8AD"
                        },
                        "Collapsed by Default": {
                          value: false
                        }
                      },
                      items: [
                        {
                          id: "51240b47-50b5-4674-83c9-52265f78ea79",
                          name: "Text",
                          displayName: "Text",
                          parentId: "6c8eaa92-eda4-4624-ad2f-581256d049ea",
                          fields: {
                            "Html Tag": {
                              value: "h3"
                            },
                            Text: {
                              value: "I'm"
                            },
                            "Css Class": {
                              value: "inline"
                            },
                            isHidden: {
                              value: false
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: {
                                  value: ""
                                },
                                key: {
                                  value: ""
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: {
                                  value: "Sky"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {}
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Text"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "04919D66DA774E6D896DB65E36D0E8D8"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: []
                        },
                        {
                          id: "69b68789-5a95-4181-a11b-625bce47e100",
                          name: "first-name",
                          displayName: "First Name",
                          parentId: "6c8eaa92-eda4-4624-ad2f-581256d049ea",
                          fields: {
                            "Default Value": {
                              value: ""
                            },
                            "Max Length": {
                              value: "122"
                            },
                            "Min Length": {
                              value: "0"
                            },
                            "Placeholder Text": {
                              value: "First name"
                            },
                            dialInCodeLength: {
                              id: "924aee12-9c96-42e0-8548-8378e251a8c7",
                              fieldType: "Droplink",
                              fieldName: "dialInCodeLength",
                              url: "/sitecore/content/fwd/global/settings/list/formdiallingcodelength/zero",
                              fields: {
                                value: {
                                  value: "0"
                                },
                                key: {
                                  value: "zero"
                                }
                              }
                            },
                            "Css Class": {
                              value: "inline firstName"
                            },
                            isHidden: {
                              value: false
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: "Please fill in the blank' for both fields"
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "f20d5651-f7b9-49a8-9e57-0a3c7e0b5cb8",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/firstname",
                              fields: {
                                value: {
                                  value: "firstName"
                                },
                                key: {
                                  value: "firstName"
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Label Css Class": {
                              value: ""
                            },
                            Title: {
                              value: ""
                            },
                            Required: {
                              value: true
                            },
                            Validations: [],
                            "Is Tracking Enabled": {
                              value: true
                            },
                            "Allow Save": {
                              value: true
                            },
                            "Value Provider Parameters": {
                              value: ""
                            },
                            "Value Provider": null,
                            "Field Type": {
                              id: "4ee89ea7-cefe-4c8e-8532-467ef64591fc",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/single-line-text",
                              fields: {
                                BackgroundColor: {
                                  value: "Sky"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/text_field.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "0908030b-4564-42ea-a6fa-c7a5a2d921a8",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/input",
                                  fields: {}
                                },
                                "Allowed Validations": [
                                  {
                                    id: "83e96d09-11c8-4132-8a8a-76d8db8208d6",
                                    fields: {
                                      Message: {
                                        value: "{0} must have at least {1} and no more than {2} characters."
                                      },
                                      Parameters: {
                                        value: ""
                                      },
                                      Type: {
                                        value: "Sitecore.ExperienceForms.Mvc.Models.Validation.StringLengthValidation,Sitecore.ExperienceForms.Mvc"
                                      }
                                    }
                                  }
                                ],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomSingleLineViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/SingleLineText"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "EF0F512D39CE4F759715B4680BF02EF5"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: []
                        },
                        {
                          id: "6fc8bbf7-97be-49f6-ad42-824f3a0357a0",
                          name: "last-name",
                          displayName: "last-name",
                          parentId: "6c8eaa92-eda4-4624-ad2f-581256d049ea",
                          fields: {
                            "Default Value": {
                              value: ""
                            },
                            "Max Length": {
                              value: "122"
                            },
                            "Min Length": {
                              value: "0"
                            },
                            "Placeholder Text": {
                              value: "Last name"
                            },
                            dialInCodeLength: {
                              id: "924aee12-9c96-42e0-8548-8378e251a8c7",
                              fieldType: "Droplink",
                              fieldName: "dialInCodeLength",
                              url: "/sitecore/content/fwd/global/settings/list/formdiallingcodelength/zero",
                              fields: {
                                value: {
                                  value: "0"
                                },
                                key: {
                                  value: "zero"
                                }
                              }
                            },
                            "Css Class": {
                              value: "inline lastName"
                            },
                            isHidden: {
                              value: false
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: "Please fill in the blank' for both fields"
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "ceb2b470-c127-4eda-b777-0d5943f0c90a",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/lastname",
                              fields: {
                                value: {
                                  value: "lastName"
                                },
                                key: {
                                  value: "lastName"
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Label Css Class": {
                              value: ""
                            },
                            Title: {
                              value: ""
                            },
                            Required: {
                              value: true
                            },
                            Validations: [],
                            "Is Tracking Enabled": {
                              value: true
                            },
                            "Allow Save": {
                              value: true
                            },
                            "Value Provider Parameters": {
                              value: ""
                            },
                            "Value Provider": null,
                            "Field Type": {
                              id: "4ee89ea7-cefe-4c8e-8532-467ef64591fc",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/single-line-text",
                              fields: {
                                BackgroundColor: {
                                  value: "Sky"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/text_field.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "0908030b-4564-42ea-a6fa-c7a5a2d921a8",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/input",
                                  fields: {}
                                },
                                "Allowed Validations": [
                                  {
                                    id: "83e96d09-11c8-4132-8a8a-76d8db8208d6",
                                    fields: {
                                      Message: {
                                        value: "{0} must have at least {1} and no more than {2} characters."
                                      },
                                      Parameters: {
                                        value: ""
                                      },
                                      Type: {
                                        value: "Sitecore.ExperienceForms.Mvc.Models.Validation.StringLengthValidation,Sitecore.ExperienceForms.Mvc"
                                      }
                                    }
                                  }
                                ],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomSingleLineViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/SingleLineText"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "D5272275F12F44BBAFA26A99DC0C506C"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: []
                        },
                        {
                          id: "d8186ad5-0981-4eb6-829c-36ba6e311500",
                          name: "nameButtonNextClick",
                          displayName: "Next Page",
                          parentId: "6c8eaa92-eda4-4624-ad2f-581256d049ea",
                          fields: {
                            "Navigation Step": {
                              value: "1"
                            },
                            emailTemplateLink: {
                              value: ""
                            },
                            "Css Class": {
                              value: "next-button"
                            },
                            isHidden: {
                              value: false
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: {
                                  value: ""
                                },
                                key: {
                                  value: ""
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Label Css Class": {
                              value: ""
                            },
                            Title: {
                              value: "Next"
                            },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: {
                                  value: "Eggplant"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/button.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {}
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Button"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "5FBCE57CD34D482097819B7F8557F2E9"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: [
                            {
                              id: "71abce35-22b7-462a-9a59-db3558b54b92",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "d8186ad5-0981-4eb6-829c-36ba6e311500",
                              fields: {
                                Description: {
                                  value: "Email"
                                },
                                Parameters: {
                                  value: "{\"referenceId\":\"{1BA10368-C5B3-41BD-BC20-9964BCFE10FF}\"}"
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": {
                                      value: "Redirect to page failed!"
                                    },
                                    "Model Type": {
                                      value: "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage"
                                    }
                                  }
                                }
                              },
                              items: []
                            }
                          ]
                        }
                      ]
                    },
                    {
                      id: "1ba10368-c5b3-41bd-bc20-9964bcfe10ff",
                      name: "emailPage",
                      displayName: "Email",
                      parentId: "a05e9c5b-6c30-4ac6-8db6-698e8e7294f0",
                      fields: {
                        gaLabel: {
                          value: ""
                        },
                        backgroundColor: {
                          id: "cbdc6265-d09f-4982-981a-bcc8f118f36f",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/whiteorange",
                          fields: {
                            value: {
                              value: "white-orange"
                            },
                            key: {
                              value: "WhiteOrange"
                            }
                          }
                        },
                        "Css Class": {
                          value: "emailPage"
                        },
                        isHidden: {
                          value: false
                        },
                        HelpText: {
                          value: ""
                        },
                        GeneralError: {
                          value: ""
                        },
                        SpecificError: {
                          value: ""
                        },
                        apiName: null,
                        serverValidationErrorText: {
                          value: ""
                        },
                        serverValidationLoadingText: {
                          value: ""
                        },
                        enableServerValidation: {
                          value: false
                        },
                        serverValidationAPI: null,
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: {
                              value: "Eggplant"
                            },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png"
                            },
                            IsDisabled: {
                              value: false
                            },
                            SpritePosition: {
                              value: ""
                            },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {}
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value: "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms"
                            },
                            "Property Editor": null,
                            "View Path": {
                              value: "FieldTemplates/Page"
                            }
                          }
                        },
                        Conditions: {
                          value: "{\"fieldConditions\":[]}"
                        },
                        "Field Key": {
                          value: "9D55C171FC094F128842ACE2B3DDA4A9"
                        },
                        "Collapsed by Default": {
                          value: false
                        }
                      },
                      items: [
                        {
                          id: "0a66a313-ad54-4d9f-8fda-c555e9d5c61f",
                          name: "Text",
                          displayName: "Text",
                          parentId: "1ba10368-c5b3-41bd-bc20-9964bcfe10ff",
                          fields: {
                            "Html Tag": {
                              value: "h3"
                            },
                            Text: {
                              value: "My email is"
                            },
                            "Css Class": {
                              value: "inline"
                            },
                            isHidden: {
                              value: false
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: {
                                  value: ""
                                },
                                key: {
                                  value: ""
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: {
                                  value: "Sky"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {}
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Text"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "97A7E3EA18774D5EBD50D8D73064CD99"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: []
                        },
                        {
                          id: "487572da-9042-4b16-8a36-bebe1025d3dc",
                          name: "Email",
                          displayName: "Email",
                          parentId: "1ba10368-c5b3-41bd-bc20-9964bcfe10ff",
                          fields: {
                            "Default Value": {
                              value: ""
                            },
                            "Max Length": {
                              value: "255"
                            },
                            "Min Length": {
                              value: "0"
                            },
                            "Placeholder Text": {
                              value: "abc@domain.com"
                            },
                            dialInCodeLength: {
                              id: "924aee12-9c96-42e0-8548-8378e251a8c7",
                              fieldType: "Droplink",
                              fieldName: "dialInCodeLength",
                              url: "/sitecore/content/fwd/global/settings/list/formdiallingcodelength/zero",
                              fields: {
                                value: {
                                  value: "0"
                                },
                                key: {
                                  value: "zero"
                                }
                              }
                            },
                            "Css Class": {
                              value: "inline"
                            },
                            isHidden: {
                              value: false
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "fa36b97a-b013-41b6-b33a-b8c3e2843137",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/email",
                              fields: {
                                value: {
                                  value: "email"
                                },
                                key: {
                                  value: "email"
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Label Css Class": {
                              value: ""
                            },
                            Title: {
                              value: ""
                            },
                            Required: {
                              value: true
                            },
                            Validations: [
                              {
                                id: "9bae3e9a-d89f-4f93-9577-68b5e9d44a38",
                                fields: {
                                  Message: {
                                    value: "Invalid email address."
                                  },
                                  Parameters: {
                                    value: "/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]/"
                                  },
                                  Type: {
                                    value: "FWD.Foundation.Forms.Validators.CustomRegularExpressionValidation,FWD.Foundation.Forms"
                                  }
                                }
                              }
                            ],
                            "Is Tracking Enabled": {
                              value: true
                            },
                            "Allow Save": {
                              value: true
                            },
                            "Value Provider Parameters": {
                              value: ""
                            },
                            "Value Provider": null,
                            "Field Type": {
                              id: "04c39cac-8976-4910-be0d-879ed3368429",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/email",
                              fields: {
                                BackgroundColor: {
                                  value: "Sky"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/mail.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "886adec1-abf8-40e1-9926-d9189c4e8e1b",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/email",
                                  fields: {}
                                },
                                "Allowed Validations": [
                                  {
                                    id: "9bae3e9a-d89f-4f93-9577-68b5e9d44a38",
                                    fields: {
                                      Message: {
                                        value: "Invalid email address."
                                      },
                                      Parameters: {
                                        value: "/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]/"
                                      },
                                      Type: {
                                        value: "FWD.Foundation.Forms.Validators.CustomRegularExpressionValidation,FWD.Foundation.Forms"
                                      }
                                    }
                                  },
                                  {
                                    id: "83e96d09-11c8-4132-8a8a-76d8db8208d6",
                                    fields: {
                                      Message: {
                                        value: "{0} must have at least {1} and no more than {2} characters."
                                      },
                                      Parameters: {
                                        value: ""
                                      },
                                      Type: {
                                        value: "Sitecore.ExperienceForms.Mvc.Models.Validation.StringLengthValidation,Sitecore.ExperienceForms.Mvc"
                                      }
                                    }
                                  }
                                ],
                                "Model Type": {
                                  value: " FWD.Foundation.Forms.CustomSingleLineViewModel, FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Email"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "CF485B1F33E5435281D931A3DD5B328B"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: []
                        },
                        {
                          id: "d314f873-c65f-417a-a660-10d3428bd7bc",
                          name: "emailNextClick",
                          displayName: "Next Page",
                          parentId: "1ba10368-c5b3-41bd-bc20-9964bcfe10ff",
                          fields: {
                            "Navigation Step": {
                              value: "1"
                            },
                            emailTemplateLink: {
                              value: ""
                            },
                            "Css Class": {
                              value: "next-button"
                            },
                            isHidden: {
                              value: false
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: {
                                  value: ""
                                },
                                key: {
                                  value: ""
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Label Css Class": {
                              value: ""
                            },
                            Title: {
                              value: "Next"
                            },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: {
                                  value: "Eggplant"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/button.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {}
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Button"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "3AD1E5279740470796028C7203617EB0"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: [
                            {
                              id: "487c45b4-f3a3-4b4e-a2bd-a87bf254e187",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "d314f873-c65f-417a-a660-10d3428bd7bc",
                              fields: {
                                Description: {
                                  value: "Phone Number"
                                },
                                Parameters: {
                                  value: "{\"referenceId\":\"{9C63A598-C7B9-441A-8D9C-45B598D9491E}\"}"
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": {
                                      value: "Redirect to page failed!"
                                    },
                                    "Model Type": {
                                      value: "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage"
                                    }
                                  }
                                }
                              },
                              items: []
                            }
                          ]
                        }
                      ]
                    },
                    {
                      id: "9c63a598-c7b9-441a-8d9c-45b598d9491e",
                      name: "phonePage",
                      displayName: "Phone Number",
                      parentId: "a05e9c5b-6c30-4ac6-8db6-698e8e7294f0",
                      fields: {
                        gaLabel: {
                          value: ""
                        },
                        backgroundColor: {
                          id: "cbdc6265-d09f-4982-981a-bcc8f118f36f",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/whiteorange",
                          fields: {
                            value: {
                              value: "white-orange"
                            },
                            key: {
                              value: "WhiteOrange"
                            }
                          }
                        },
                        "Css Class": {
                          value: "phonePage"
                        },
                        isHidden: {
                          value: false
                        },
                        HelpText: {
                          value: ""
                        },
                        GeneralError: {
                          value: ""
                        },
                        SpecificError: {
                          value: ""
                        },
                        apiName: null,
                        serverValidationErrorText: {
                          value: ""
                        },
                        serverValidationLoadingText: {
                          value: ""
                        },
                        enableServerValidation: {
                          value: false
                        },
                        serverValidationAPI: null,
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: {
                              value: "Eggplant"
                            },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png"
                            },
                            IsDisabled: {
                              value: false
                            },
                            SpritePosition: {
                              value: ""
                            },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {}
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value: "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms"
                            },
                            "Property Editor": null,
                            "View Path": {
                              value: "FieldTemplates/Page"
                            }
                          }
                        },
                        Conditions: {
                          value: "{\"fieldConditions\":[]}"
                        },
                        "Field Key": {
                          value: "A822D936CE184893B07F20E4B97E9B22"
                        },
                        "Collapsed by Default": {
                          value: false
                        }
                      },
                      items: [
                        {
                          id: "7433594d-ccc3-449c-a8ee-be1257c66818",
                          name: "Text",
                          displayName: "Text",
                          parentId: "9c63a598-c7b9-441a-8d9c-45b598d9491e",
                          fields: {
                            "Html Tag": {
                              value: "h3"
                            },
                            Text: {
                              value: "My phone number is"
                            },
                            "Css Class": {
                              value: "inline"
                            },
                            isHidden: {
                              value: false
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: {
                                  value: ""
                                },
                                key: {
                                  value: ""
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: {
                                  value: "Sky"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {}
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Text"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "68525ADA341A44E4A149A8B8DFECA243"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: []
                        },
                        {
                          id: "f45b03b0-e22d-4129-b1d7-4dab323d2da5",
                          name: "CountryCode",
                          displayName: "CountryCode",
                          parentId: "9c63a598-c7b9-441a-8d9c-45b598d9491e",
                          fields: {
                            "Default Value": {
                              value: "+60"
                            },
                            "Max Length": {
                              value: "255"
                            },
                            "Min Length": {
                              value: "0"
                            },
                            "Placeholder Text": {
                              value: ""
                            },
                            dialInCodeLength: {
                              id: "924aee12-9c96-42e0-8548-8378e251a8c7",
                              fieldType: "Droplink",
                              fieldName: "dialInCodeLength",
                              url: "/sitecore/content/fwd/global/settings/list/formdiallingcodelength/zero",
                              fields: {
                                value: {
                                  value: "0"
                                },
                                key: {
                                  value: "zero"
                                }
                              }
                            },
                            "Css Class": {
                              value: "inline disabled countryCodeInput"
                            },
                            isHidden: {
                              value: false
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "01b8756b-4bc7-4534-b990-516943821261",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/countrycode",
                              fields: {
                                value: {
                                  value: "countryCode"
                                },
                                key: {
                                  value: "countryCode"
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Label Css Class": {
                              value: ""
                            },
                            Title: {
                              value: ""
                            },
                            Required: {
                              value: false
                            },
                            Validations: [],
                            "Is Tracking Enabled": {
                              value: true
                            },
                            "Allow Save": {
                              value: true
                            },
                            "Value Provider Parameters": {
                              value: ""
                            },
                            "Value Provider": null,
                            "Field Type": {
                              id: "4ee89ea7-cefe-4c8e-8532-467ef64591fc",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/single-line-text",
                              fields: {
                                BackgroundColor: {
                                  value: "Sky"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/text_field.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "0908030b-4564-42ea-a6fa-c7a5a2d921a8",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/input",
                                  fields: {}
                                },
                                "Allowed Validations": [
                                  {
                                    id: "83e96d09-11c8-4132-8a8a-76d8db8208d6",
                                    fields: {
                                      Message: {
                                        value: "{0} must have at least {1} and no more than {2} characters."
                                      },
                                      Parameters: {
                                        value: ""
                                      },
                                      Type: {
                                        value: "Sitecore.ExperienceForms.Mvc.Models.Validation.StringLengthValidation,Sitecore.ExperienceForms.Mvc"
                                      }
                                    }
                                  }
                                ],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomSingleLineViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/SingleLineText"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "D887995C8B1E4FA18A7BFA76031CFCCE"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: []
                        },
                        {
                          id: "8899651d-bcae-4af6-8d03-7aab59542574",
                          name: "Telephone",
                          displayName: "Telephone",
                          parentId: "9c63a598-c7b9-441a-8d9c-45b598d9491e",
                          fields: {
                            "Default Value": {
                              value: ""
                            },
                            "Max Length": {
                              value: "10"
                            },
                            "Min Length": {
                              value: "9"
                            },
                            "Placeholder Text": {
                              value: "000000000"
                            },
                            dialInCodeLength: {
                              id: "924aee12-9c96-42e0-8548-8378e251a8c7",
                              fieldType: "Droplink",
                              fieldName: "dialInCodeLength",
                              url: "/sitecore/content/fwd/global/settings/list/formdiallingcodelength/zero",
                              fields: {
                                value: {
                                  value: "0"
                                },
                                key: {
                                  value: "zero"
                                }
                              }
                            },
                            "Css Class": {
                              value: "inline telephoneInput"
                            },
                            isHidden: {
                              value: false
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "22259656-b6e9-4f74-993e-4578dbcf0741",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/cellphone",
                              fields: {
                                value: {
                                  value: "cellPhone"
                                },
                                key: {
                                  value: "cellPhone"
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Label Css Class": {
                              value: ""
                            },
                            Title: {
                              value: ""
                            },
                            Required: {
                              value: true
                            },
                            Validations: [
                              {
                                id: "cf16f970-dbfb-40b4-813e-72e94cdcb71d",
                                fields: {
                                  Message: {
                                    value: "Please check that your phone number contains 9 or 10 digits"
                                  },
                                  Parameters: {
                                    value: "/^[0-9]{9,10}$/"
                                  },
                                  Type: {
                                    value: "FWD.Foundation.Forms.Validators.CustomRegularExpressionValidation,FWD.Foundation.Forms"
                                  }
                                }
                              }
                            ],
                            "Is Tracking Enabled": {
                              value: true
                            },
                            "Allow Save": {
                              value: true
                            },
                            "Value Provider Parameters": {
                              value: ""
                            },
                            "Value Provider": null,
                            "Field Type": {
                              id: "df74f55b-47e6-4d1c-92f8-b0d46a7b2704",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/telephone",
                              fields: {
                                BackgroundColor: {
                                  value: "Sky"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/mobile_phone.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "0908030b-4564-42ea-a6fa-c7a5a2d921a8",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/input",
                                  fields: {}
                                },
                                "Allowed Validations": [
                                  {
                                    id: "1aa74652-2177-48c9-88f5-1214445fea34",
                                    fields: {
                                      Message: {
                                        value: "Please input 9 to 10 digits phone number."
                                      },
                                      Parameters: {
                                        value: "//^d +$//"
                                      },
                                      Type: {
                                        value: "FWD.Foundation.Forms.Validators.CustomRegularExpressionValidation,FWD.Foundation.Forms"
                                      }
                                    }
                                  },
                                  {
                                    id: "83e96d09-11c8-4132-8a8a-76d8db8208d6",
                                    fields: {
                                      Message: {
                                        value: "{0} must have at least {1} and no more than {2} characters."
                                      },
                                      Parameters: {
                                        value: ""
                                      },
                                      Type: {
                                        value: "Sitecore.ExperienceForms.Mvc.Models.Validation.StringLengthValidation,Sitecore.ExperienceForms.Mvc"
                                      }
                                    }
                                  }
                                ],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomSingleLineViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Telephone"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "4799D38182DD4823B332E218187C23B0"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: []
                        },
                        {
                          id: "b995a7c6-400b-47ef-a1b2-b663ace227ee",
                          name: "phoneNextClick",
                          displayName: "Next Page",
                          parentId: "9c63a598-c7b9-441a-8d9c-45b598d9491e",
                          fields: {
                            "Navigation Step": {
                              value: "1"
                            },
                            emailTemplateLink: {
                              value: ""
                            },
                            "Css Class": {
                              value: "next-button"
                            },
                            isHidden: {
                              value: false
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: {
                                  value: ""
                                },
                                key: {
                                  value: ""
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Label Css Class": {
                              value: ""
                            },
                            Title: {
                              value: "Next"
                            },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: {
                                  value: "Eggplant"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/button.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {}
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Button"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "7BB73BAD1EEC4F309AB7046C2FFF2ED2"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: [
                            {
                              id: "a0505a3a-5cfe-406d-ba94-39c721583152",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "b995a7c6-400b-47ef-a1b2-b663ace227ee",
                              fields: {
                                Description: {
                                  value: "Preferred Contact Mode"
                                },
                                Parameters: {
                                  value: "{\"referenceId\":\"{CF0FAA1F-4DBF-40A9-91FC-B03E08DE576C}\"}"
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": {
                                      value: "Redirect to page failed!"
                                    },
                                    "Model Type": {
                                      value: "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage"
                                    }
                                  }
                                }
                              },
                              items: []
                            }
                          ]
                        }
                      ]
                    },
                    {
                      id: "cf0faa1f-4dbf-40a9-91fc-b03e08de576c",
                      name: "preferredContactModePage",
                      displayName: "Preferred Contact Mode",
                      parentId: "a05e9c5b-6c30-4ac6-8db6-698e8e7294f0",
                      fields: {
                        gaLabel: {
                          value: ""
                        },
                        backgroundColor: {
                          id: "cbdc6265-d09f-4982-981a-bcc8f118f36f",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/whiteorange",
                          fields: {
                            value: {
                              value: "white-orange"
                            },
                            key: {
                              value: "WhiteOrange"
                            }
                          }
                        },
                        "Css Class": {
                          value: ""
                        },
                        isHidden: {
                          value: false
                        },
                        HelpText: {
                          value: ""
                        },
                        GeneralError: {
                          value: ""
                        },
                        SpecificError: {
                          value: ""
                        },
                        apiName: null,
                        serverValidationErrorText: {
                          value: ""
                        },
                        serverValidationLoadingText: {
                          value: ""
                        },
                        enableServerValidation: {
                          value: false
                        },
                        serverValidationAPI: null,
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: {
                              value: "Eggplant"
                            },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png"
                            },
                            IsDisabled: {
                              value: false
                            },
                            SpritePosition: {
                              value: ""
                            },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {}
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value: "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms"
                            },
                            "Property Editor": null,
                            "View Path": {
                              value: "FieldTemplates/Page"
                            }
                          }
                        },
                        Conditions: {
                          value: "{\"fieldConditions\":[]}"
                        },
                        "Field Key": {
                          value: "4DF8F5E941DF48CC846122E6426D5C47"
                        },
                        "Collapsed by Default": {
                          value: false
                        }
                      },
                      items: [
                        {
                          id: "6fc84f5c-4b50-4d2a-9d58-9ce8cb3b4b98",
                          name: "Text",
                          displayName: "Text",
                          parentId: "cf0faa1f-4dbf-40a9-91fc-b03e08de576c",
                          fields: {
                            "Html Tag": {
                              value: "p"
                            },
                            Text: {
                              value: "I prefer to be contacted by "
                            },
                            "Css Class": {
                              value: "block"
                            },
                            isHidden: {
                              value: false
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: {
                                  value: ""
                                },
                                key: {
                                  value: ""
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: {
                                  value: "Sky"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {}
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Text"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "2CEFA97A507747A183E4DB2D202E0B10"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: []
                        },
                        {
                          id: "be797178-92f7-4919-b4d3-53e291d47fc5",
                          name: "ContactMode",
                          displayName: "ContactMode",
                          parentId: "cf0faa1f-4dbf-40a9-91fc-b03e08de576c",
                          fields: {
                            Datasource: null,
                            "Default Selection": {
                              value: ""
                            },
                            "Display Field Name": {
                              value: "__Display name"
                            },
                            "Is Dynamic": {
                              value: false
                            },
                            "Value Field Name": {
                              value: "Value"
                            },
                            "Css Class": {
                              value: "block"
                            },
                            isHidden: {
                              value: false
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "50d505ca-38f7-420f-8f73-f221ef889e74",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/preferredcontactmethod",
                              fields: {
                                value: {
                                  value: "preferredContactMethod"
                                },
                                key: {
                                  value: "preferredContactMethod"
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Label Css Class": {
                              value: ""
                            },
                            Title: {
                              value: ""
                            },
                            Required: {
                              value: true
                            },
                            Validations: [],
                            "Is Tracking Enabled": {
                              value: true
                            },
                            "Allow Save": {
                              value: true
                            },
                            "Value Provider Parameters": {
                              value: ""
                            },
                            "Value Provider": null,
                            "Field Type": {
                              id: "edbd38a8-1ae9-42ec-8ccd-f5b0e2998b4f",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/lists/radio-button-list",
                              fields: {
                                BackgroundColor: {
                                  value: "Grass"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/radio_button_group.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "5b672865-55d2-413e-b699-fdfc7e732ccf",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/list",
                                  fields: {}
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomRadioButtonListViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/RadioButtonList"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[{\"matchTypeId\":\"{365C94DA-C1CD-4783-A91D-0D17A16C7117}\",\"conditions\":[{\"fieldId\":\"049474A552CA48A58B82690D22292B31\",\"operatorId\":\"{1D38B217-A2EE-4E7B-B6ED-13E751462FEB}\",\"value\":\"Phone\"}],\"actions\":[{\"fieldId\":\"1E22D5F5BFEC418690975C7258187D67\",\"actionTypeId\":\"{AAE07A52-46A4-49EF-98B0-C2595BAC2382}\",\"value\":null}]},{\"matchTypeId\":\"{365C94DA-C1CD-4783-A91D-0D17A16C7117}\",\"conditions\":[{\"fieldId\":\"049474A552CA48A58B82690D22292B31\",\"operatorId\":\"{1D38B217-A2EE-4E7B-B6ED-13E751462FEB}\",\"value\":\"Emel\"}],\"actions\":[{\"fieldId\":\"1BCD51427EDA4A908AD768C2D9CA67CF\",\"actionTypeId\":\"{AAE07A52-46A4-49EF-98B0-C2595BAC2382}\",\"value\":null}]}]}"
                            },
                            "Field Key": {
                              value: "049474A552CA48A58B82690D22292B31"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: [
                            {
                              id: "51cdfc1b-ca14-4cd1-92c1-05497f00c3ed",
                              name: "Phone",
                              displayName: "Phone",
                              parentId: "be797178-92f7-4919-b4d3-53e291d47fc5",
                              fields: {
                                value: {
                                  value: "Phone"
                                }
                              },
                              items: []
                            },
                            {
                              id: "a9c00a09-0bd4-422a-abc1-336e26402171",
                              name: "Email",
                              displayName: "Email",
                              parentId: "be797178-92f7-4919-b4d3-53e291d47fc5",
                              fields: {
                                value: {
                                  value: "Email"
                                }
                              },
                              items: []
                            }
                          ]
                        },
                        {
                          id: "1cd0b626-3241-46c8-8ba2-8d4fc24a0e54",
                          name: "phoneOptionNextClick",
                          displayName: "phoneOptionNextClick",
                          parentId: "cf0faa1f-4dbf-40a9-91fc-b03e08de576c",
                          fields: {
                            "Navigation Step": {
                              value: "1"
                            },
                            emailTemplateLink: {
                              value: ""
                            },
                            "Css Class": {
                              value: "next-button"
                            },
                            isHidden: {
                              value: false
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: {
                                  value: ""
                                },
                                key: {
                                  value: ""
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Label Css Class": {
                              value: ""
                            },
                            Title: {
                              value: "Next"
                            },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: {
                                  value: "Eggplant"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/button.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {}
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Button"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "DFA430F198F44C0DA33CD16E1DB2299E"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: [
                            {
                              id: "0795b477-279c-4eb7-a78c-5b5591cfb7fd",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "1cd0b626-3241-46c8-8ba2-8d4fc24a0e54",
                              fields: {
                                Description: {
                                  value: "existingCustomerPage"
                                },
                                Parameters: {
                                  value: "{\"referenceId\":\"{9E5DD146-685C-4DE2-9BCA-9D06F9FAAC76}\"}"
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": {
                                      value: "Redirect to page failed!"
                                    },
                                    "Model Type": {
                                      value: "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage"
                                    }
                                  }
                                }
                              },
                              items: []
                            }
                          ]
                        }
                      ]
                    },
                    {
                      id: "9e5dd146-685c-4de2-9bca-9d06f9faac76",
                      name: "existingCustomerPage",
                      displayName: "existingCustomerPage",
                      parentId: "a05e9c5b-6c30-4ac6-8db6-698e8e7294f0",
                      fields: {
                        gaLabel: {
                          value: ""
                        },
                        backgroundColor: {
                          id: "cbdc6265-d09f-4982-981a-bcc8f118f36f",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/whiteorange",
                          fields: {
                            value: {
                              value: "white-orange"
                            },
                            key: {
                              value: "WhiteOrange"
                            }
                          }
                        },
                        "Css Class": {
                          value: "interestedPage"
                        },
                        isHidden: {
                          value: false
                        },
                        HelpText: {
                          value: ""
                        },
                        GeneralError: {
                          value: ""
                        },
                        SpecificError: {
                          value: ""
                        },
                        apiName: null,
                        serverValidationErrorText: {
                          value: ""
                        },
                        serverValidationLoadingText: {
                          value: ""
                        },
                        enableServerValidation: {
                          value: false
                        },
                        serverValidationAPI: null,
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: {
                              value: "Eggplant"
                            },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png"
                            },
                            IsDisabled: {
                              value: false
                            },
                            SpritePosition: {
                              value: ""
                            },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {}
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value: "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms"
                            },
                            "Property Editor": null,
                            "View Path": {
                              value: "FieldTemplates/Page"
                            }
                          }
                        },
                        Conditions: {
                          value: "{\"fieldConditions\":[]}"
                        },
                        "Field Key": {
                          value: "A822D936CE184893B07F20E4B97E9B22"
                        },
                        "Collapsed by Default": {
                          value: false
                        }
                      },
                      items: [
                        {
                          id: "d5484e51-333d-44f1-a743-06d1046cf2cf",
                          name: "Text",
                          displayName: "Text",
                          parentId: "9e5dd146-685c-4de2-9bca-9d06f9faac76",
                          fields: {
                            "Html Tag": {
                              value: "h3"
                            },
                            Text: {
                              value: "Are you an existing FWD Takaful customer?"
                            },
                            "Css Class": {
                              value: "inline"
                            },
                            isHidden: {
                              value: false
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: {
                                  value: ""
                                },
                                key: {
                                  value: ""
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: {
                                  value: "Sky"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {}
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Text"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "68525ADA341A44E4A149A8B8DFECA243"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: []
                        },
                        {
                          id: "2d01a63f-58d4-4a85-bfdb-4d15c11dbdb0",
                          name: "Radio Button List",
                          displayName: "Radio Button List",
                          parentId: "9e5dd146-685c-4de2-9bca-9d06f9faac76",
                          fields: {
                            Datasource: {
                              id: "a8f27221-4814-4ec9-82ea-9c4efa51b12c",
                              fieldType: "Droptree",
                              fieldName: "Datasource",
                              url: "/content/forms/radio-lists/existing-customer",
                              fields: {}
                            },
                            "Default Selection": {
                              value: ""
                            },
                            "Display Field Name": {
                              value: "value"
                            },
                            "Is Dynamic": {
                              value: true
                            },
                            "Value Field Name": {
                              value: "key"
                            },
                            "Css Class": {
                              value: ""
                            },
                            isHidden: {
                              value: false
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "b6de015f-5e9b-44a8-a7ad-0bbef4836953",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/existingcustomer",
                              fields: {
                                value: {
                                  value: "existingCustomer"
                                },
                                key: {
                                  value: "existingCustomer"
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Label Css Class": {
                              value: ""
                            },
                            Title: {
                              value: ""
                            },
                            Required: {
                              value: true
                            },
                            Validations: [],
                            "Is Tracking Enabled": {
                              value: true
                            },
                            "Allow Save": {
                              value: true
                            },
                            "Value Provider Parameters": {
                              value: ""
                            },
                            "Value Provider": null,
                            "Field Type": {
                              id: "edbd38a8-1ae9-42ec-8ccd-f5b0e2998b4f",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/lists/radio-button-list",
                              fields: {
                                BackgroundColor: {
                                  value: "Grass"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/radio_button_group.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "5b672865-55d2-413e-b699-fdfc7e732ccf",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/list",
                                  fields: {}
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomRadioButtonListViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/RadioButtonList"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[{\"matchTypeId\":\"{365C94DA-C1CD-4783-A91D-0D17A16C7117}\",\"conditions\":[{\"fieldId\":\"049474A552CA48A58B82690D22292B31\",\"operatorId\":\"{1D38B217-A2EE-4E7B-B6ED-13E751462FEB}\",\"value\":\"Phone\"}],\"actions\":[{\"fieldId\":\"1E22D5F5BFEC418690975C7258187D67\",\"actionTypeId\":\"{AAE07A52-46A4-49EF-98B0-C2595BAC2382}\",\"value\":null}]},{\"matchTypeId\":\"{365C94DA-C1CD-4783-A91D-0D17A16C7117}\",\"conditions\":[{\"fieldId\":\"049474A552CA48A58B82690D22292B31\",\"operatorId\":\"{1D38B217-A2EE-4E7B-B6ED-13E751462FEB}\",\"value\":\"Email\"}],\"actions\":[{\"fieldId\":\"1BCD51427EDA4A908AD768C2D9CA67CF\",\"actionTypeId\":\"{AAE07A52-46A4-49EF-98B0-C2595BAC2382}\",\"value\":null}]}]}"
                            },
                            "Field Key": {
                              value: "7EDF51CA69F34F80806E7A0CA201C4DF"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: [
                            {
                              id: "d436ab53-0bd9-49a6-98e0-ad5fe52c3dba",
                              name: "Yes",
                              displayName: "Yes",
                              parentId: "a8f27221-4814-4ec9-82ea-9c4efa51b12c",
                              fields: {
                                value: {
                                  value: "Yes"
                                },
                                key: {
                                  value: "1"
                                }
                              }
                            },
                            {
                              id: "06781226-9d91-4d10-9501-ca97c1c9858f",
                              name: "NO",
                              displayName: "No",
                              parentId: "a8f27221-4814-4ec9-82ea-9c4efa51b12c",
                              fields: {
                                value: {
                                  value: "No"
                                },
                                key: {
                                  value: "2"
                                }
                              }
                            }
                          ]
                        },
                        {
                          id: "cd42d613-89cb-4590-bebb-1ffa5a1eb7b0",
                          name: "existingCustomerNextClickMessage",
                          displayName: "existingCustomerNextClickMessage",
                          parentId: "9e5dd146-685c-4de2-9bca-9d06f9faac76",
                          fields: {
                            "Navigation Step": {
                              value: "1"
                            },
                            emailTemplateLink: {
                              value: ""
                            },
                            "Css Class": {
                              value: "next-button"
                            },
                            isHidden: {
                              value: false
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: {
                                  value: ""
                                },
                                key: {
                                  value: ""
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Label Css Class": {
                              value: ""
                            },
                            Title: {
                              value: "Next"
                            },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: {
                                  value: "Eggplant"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/button.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {}
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Button"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "172ABD10475D4D829A918792A8F911DD"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: [
                            {
                              id: "e3dce954-b9ec-443e-baf8-f2e8caebb209",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "cd42d613-89cb-4590-bebb-1ffa5a1eb7b0",
                              fields: {
                                Description: {
                                  value: "Message"
                                },
                                Parameters: {
                                  value: "{\"referenceId\":\"{C78B0265-A1AA-412B-87D6-8F692BA8E8B8}\"}"
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": {
                                      value: "Redirect to page failed!"
                                    },
                                    "Model Type": {
                                      value: "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage"
                                    }
                                  }
                                }
                              },
                              items: []
                            }
                          ]
                        }
                      ]
                    },
                    {
                      id: "c78b0265-a1aa-412b-87d6-8f692ba8e8b8",
                      name: "messagePage",
                      displayName: "Message",
                      parentId: "a05e9c5b-6c30-4ac6-8db6-698e8e7294f0",
                      fields: {
                        gaLabel: {
                          value: ""
                        },
                        backgroundColor: {
                          id: "cbdc6265-d09f-4982-981a-bcc8f118f36f",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/whiteorange",
                          fields: {
                            value: {
                              value: "white-orange"
                            },
                            key: {
                              value: "WhiteOrange"
                            }
                          }
                        },
                        "Css Class": {
                          value: "phonePage"
                        },
                        isHidden: {
                          value: false
                        },
                        HelpText: {
                          value: ""
                        },
                        GeneralError: {
                          value: ""
                        },
                        SpecificError: {
                          value: ""
                        },
                        apiName: null,
                        serverValidationErrorText: {
                          value: ""
                        },
                        serverValidationLoadingText: {
                          value: ""
                        },
                        enableServerValidation: {
                          value: false
                        },
                        serverValidationAPI: null,
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: {
                              value: "Eggplant"
                            },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png"
                            },
                            IsDisabled: {
                              value: false
                            },
                            SpritePosition: {
                              value: ""
                            },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {}
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value: "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms"
                            },
                            "Property Editor": null,
                            "View Path": {
                              value: "FieldTemplates/Page"
                            }
                          }
                        },
                        Conditions: {
                          value: "{\"fieldConditions\":[]}"
                        },
                        "Field Key": {
                          value: "A822D936CE184893B07F20E4B97E9B22"
                        },
                        "Collapsed by Default": {
                          value: false
                        }
                      },
                      items: [
                        {
                          id: "60873bf2-5cb4-4979-90c9-06e551836089",
                          name: "Text",
                          displayName: "Text",
                          parentId: "c78b0265-a1aa-412b-87d6-8f692ba8e8b8",
                          fields: {
                            "Html Tag": {
                              value: "h3"
                            },
                            Text: {
                              value: "Leave us a message:"
                            },
                            "Css Class": {
                              value: "inline"
                            },
                            isHidden: {
                              value: false
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: {
                                  value: ""
                                },
                                key: {
                                  value: ""
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: {
                                  value: "Sky"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {}
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Text"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "68525ADA341A44E4A149A8B8DFECA243"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: []
                        },
                        {
                          id: "1f743ca2-36c3-4f33-b2b1-cf2b0e06c679",
                          name: "Message",
                          displayName: "Message",
                          parentId: "c78b0265-a1aa-412b-87d6-8f692ba8e8b8",
                          fields: {
                            Rows: {
                              value: "4"
                            },
                            "Default Value": {
                              value: ""
                            },
                            "Max Length": {
                              value: "512"
                            },
                            "Min Length": {
                              value: "0"
                            },
                            "Placeholder Text": {
                              value: ""
                            },
                            dialInCodeLength: null,
                            "Css Class": {
                              value: ""
                            },
                            isHidden: {
                              value: false
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: "Please enter your query"
                            },
                            apiName: {
                              id: "87827a1f-bbbd-42b2-b966-5fa2a695f102",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/comment",
                              fields: {
                                value: {
                                  value: "comment"
                                },
                                key: {
                                  value: "comment"
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Label Css Class": {
                              value: ""
                            },
                            Title: {
                              value: ""
                            },
                            Required: {
                              value: true
                            },
                            Validations: [],
                            "Is Tracking Enabled": {
                              value: true
                            },
                            "Allow Save": {
                              value: true
                            },
                            "Value Provider Parameters": {
                              value: ""
                            },
                            "Value Provider": null,
                            "Field Type": {
                              id: "a296a1c1-0da0-4493-a92e-b8191f43aec6",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/multiple-line-text",
                              fields: {
                                BackgroundColor: {
                                  value: "Sky"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/text.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "d8386d04-c1e3-4cd3-9227-9e9f86ef3c88",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/multiple-line-text",
                                  fields: {}
                                },
                                "Allowed Validations": [
                                  {
                                    id: "83e96d09-11c8-4132-8a8a-76d8db8208d6",
                                    fields: {
                                      Message: {
                                        value: "{0} must have at least {1} and no more than {2} characters."
                                      },
                                      Parameters: {
                                        value: ""
                                      },
                                      Type: {
                                        value: "Sitecore.ExperienceForms.Mvc.Models.Validation.StringLengthValidation,Sitecore.ExperienceForms.Mvc"
                                      }
                                    }
                                  }
                                ],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomMultipleLineTextViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/MultipleLineText"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "D56945B0A5744A6CB0DE37DDFC251271"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: []
                        },
                        {
                          id: "2339eb0b-eff6-48ad-9912-24145f463510",
                          name: "CheckList-Section",
                          displayName: "CheckList-Section",
                          parentId: "c78b0265-a1aa-412b-87d6-8f692ba8e8b8",
                          fields: {
                            backgroundColor: {
                              id: "cf8cf9a4-0f70-4db2-b298-90e820aca94b",
                              fieldType: "Droplink",
                              fieldName: "backgroundColor",
                              url: "/sitecore/content/fwd/global/settings/list/colors/greywhite",
                              fields: {
                                value: {
                                  value: "grey-white"
                                },
                                key: {
                                  value: "grey-white"
                                }
                              }
                            },
                            "Css Class": {
                              value: "consentSection"
                            },
                            isHidden: {
                              value: false
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: null,
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "447aa745-6d29-4b65-a5a3-8173aa8af548",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/section",
                              fields: {
                                BackgroundColor: {
                                  value: "Eggplant"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_header.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "8cddb194-f456-4a75-89b7-346f8f39f95c",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/section",
                                  fields: {}
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value: "Sitecore.ExperienceForms.Mvc.Models.Fields.FieldViewModel,Sitecore.ExperienceForms.Mvc"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Section"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "27FB7756B08F45EBAD81A50F26E6FBFA"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: [
                            {
                              id: "c427d478-e607-4402-a16c-be9285ac2511",
                              name: "privacyPolicy",
                              displayName: "privacyPolicy",
                              parentId: "2339eb0b-eff6-48ad-9912-24145f463510",
                              fields: {
                                Datasource: {
                                  id: "ff7f1763-ffd8-4ddb-837c-af84860253c3",
                                  fieldType: "Droptree",
                                  fieldName: "Datasource",
                                  url: "/content/forms/privacypolicy/privacypolicy-general-enquiry",
                                  fields: {}
                                },
                                "Default Selection": {
                                  value: ""
                                },
                                "Display Field Name": {
                                  value: "value"
                                },
                                "Is Dynamic": {
                                  value: true
                                },
                                "Value Field Name": {
                                  value: "value"
                                },
                                "Css Class": {
                                  value: "block privacyPolicyCheckbox"
                                },
                                isHidden: {
                                  value: false
                                },
                                HelpText: {
                                  value: ""
                                },
                                GeneralError: {
                                  value: ""
                                },
                                SpecificError: {
                                  value: ""
                                },
                                apiName: {
                                  id: "742c941c-44ec-4e36-878f-6dc28f99baff",
                                  fieldType: "Droplink",
                                  fieldName: "apiName",
                                  url: "/sitecore/content/fwd/global/settings/list/form-api-fields/consentmsg",
                                  fields: {
                                    value: {
                                      value: "consentMsg"
                                    },
                                    key: {
                                      value: "consentMsg"
                                    }
                                  }
                                },
                                serverValidationErrorText: {
                                  value: ""
                                },
                                serverValidationLoadingText: {
                                  value: ""
                                },
                                enableServerValidation: {
                                  value: false
                                },
                                serverValidationAPI: null,
                                "Label Css Class": {
                                  value: ""
                                },
                                Title: {
                                  value: ""
                                },
                                Required: {
                                  value: true
                                },
                                Validations: [],
                                "Is Tracking Enabled": {
                                  value: true
                                },
                                "Allow Save": {
                                  value: true
                                },
                                "Value Provider Parameters": {
                                  value: ""
                                },
                                "Value Provider": null,
                                "Field Type": {
                                  id: "d86a361a-d4ff-46b2-9e97-a37fc5b1fe1a",
                                  fieldType: "Droptree",
                                  fieldName: "Field Type",
                                  url: "/sitecore/system/settings/forms/field-types/lists/checkbox-list",
                                  fields: {
                                    BackgroundColor: {
                                      value: "Grass"
                                    },
                                    Icon: {
                                      value: "OfficeWhite/32x32/checkbox_group.png"
                                    },
                                    IsDisabled: {
                                      value: false
                                    },
                                    SpritePosition: {
                                      value: ""
                                    },
                                    "Field Template": {
                                      id: "5b672865-55d2-413e-b699-fdfc7e732ccf",
                                      fieldType: "Droptree",
                                      fieldName: "Field Template",
                                      url: "/sitecore/templates/system/forms/fields/list",
                                      fields: {}
                                    },
                                    "Allowed Validations": [],
                                    "Model Type": {
                                      value: "FWD.Foundation.Forms.CustomCheckBoxListViewModel,FWD.Foundation.Forms"
                                    },
                                    "Property Editor": null,
                                    "View Path": {
                                      value: "FieldTemplates/CheckBoxList"
                                    }
                                  }
                                },
                                Conditions: {
                                  value: "{\"fieldConditions\":[]}"
                                },
                                "Field Key": {
                                  value: "00083148546A48528DF2E8BB757A7BEE"
                                },
                                "Collapsed by Default": {
                                  value: false
                                }
                              },
                              items: [
                                {
                                  id: "18325f72-c6ec-42d2-bd3a-5e517e4be22b",
                                  name: "Customer Consent",
                                  displayName: "Privacy Policy",
                                  parentId: "ff7f1763-ffd8-4ddb-837c-af84860253c3",
                                  fields: {
                                    value: {
                                      value: "I give my consent to FWD Takaful to collect and use my personal information to contact me regarding my request.<br />"
                                    }
                                  }
                                }
                              ]
                            }
                          ]
                        },
                        {
                          id: "6c861958-ccb9-44d8-8bf2-a5aceadb45ae",
                          name: "consentSubmitClick",
                          displayName: "Comment Submit",
                          parentId: "c78b0265-a1aa-412b-87d6-8f692ba8e8b8",
                          fields: {
                            "Navigation Step": {
                              value: "0"
                            },
                            emailTemplateLink: {
                              value: "/formslist/general-enquiry-form/general-enquiry-email-template"
                            },
                            "Css Class": {
                              value: "submitButton"
                            },
                            isHidden: {
                              value: false
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: {
                                  value: ""
                                },
                                key: {
                                  value: ""
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Label Css Class": {
                              value: ""
                            },
                            Title: {
                              value: "Submit"
                            },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: {
                                  value: "Eggplant"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/button.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {}
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Button"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "1BCD51427EDA4A908AD768C2D9CA67CF"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: [
                            {
                              id: "0c308cfa-b8ef-4b4c-98c5-5b22cbf04505",
                              name: "Send Email",
                              displayName: "Send Email",
                              parentId: "6c861958-ccb9-44d8-8bf2-a5aceadb45ae",
                              fields: {
                                Description: {
                                  value: ""
                                },
                                Parameters: {
                                  value: ""
                                },
                                "Submit Action": {
                                  id: "2f66e378-be9d-4d9d-b43b-fc6ddc0e3db5",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/custom-action",
                                  fields: {
                                    Editor: null,
                                    "Error Message": {
                                      value: "Saving form data failed!"
                                    },
                                    "Model Type": {
                                      value: "Sitecore.ExperienceForms.Processing.Actions.SaveData"
                                    }
                                  }
                                }
                              },
                              items: []
                            },
                            {
                              id: "a57992a5-3463-4a93-a190-278b1e00a47f",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "6c861958-ccb9-44d8-8bf2-a5aceadb45ae",
                              fields: {
                                Description: {
                                  value: "Thank You - Phone"
                                },
                                Parameters: {
                                  value: "{\"referenceId\":\"{E926A7A2-CB84-4C1D-AB25-B06FB12A5C29}\"}"
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": {
                                      value: "Redirect to page failed!"
                                    },
                                    "Model Type": {
                                      value: "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage"
                                    }
                                  }
                                }
                              },
                              items: []
                            }
                          ]
                        },
                        {
                          id: "00632e6e-5275-48d4-a4f2-67d4f5fc87ab",
                          name: "phoneOptionSubmitClick",
                          displayName: "phoneOptionSubmitClick",
                          parentId: "c78b0265-a1aa-412b-87d6-8f692ba8e8b8",
                          fields: {
                            "Navigation Step": {
                              value: "0"
                            },
                            emailTemplateLink: {
                              value: "/formslist/general-enquiry-form/general-enquiry-phone-template"
                            },
                            "Css Class": {
                              value: "submitButton"
                            },
                            isHidden: {
                              value: false
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: {
                                  value: ""
                                },
                                key: {
                                  value: ""
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Label Css Class": {
                              value: ""
                            },
                            Title: {
                              value: "Submit"
                            },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: {
                                  value: "Eggplant"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/button.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {}
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Button"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "1E22D5F5BFEC418690975C7258187D67"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: [
                            {
                              id: "63c84b8d-12e3-46fb-91a0-7e72c054a124",
                              name: "Send Email",
                              displayName: "Send Email",
                              parentId: "00632e6e-5275-48d4-a4f2-67d4f5fc87ab",
                              fields: {
                                Description: {
                                  value: ""
                                },
                                Parameters: {
                                  value: ""
                                },
                                "Submit Action": {
                                  id: "2f66e378-be9d-4d9d-b43b-fc6ddc0e3db5",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/custom-action",
                                  fields: {
                                    Editor: null,
                                    "Error Message": {
                                      value: "Saving form data failed!"
                                    },
                                    "Model Type": {
                                      value: "Sitecore.ExperienceForms.Processing.Actions.SaveData"
                                    }
                                  }
                                }
                              },
                              items: []
                            },
                            {
                              id: "4380ffb2-6b8f-4dd0-8239-a6b7bd1b23d6",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "00632e6e-5275-48d4-a4f2-67d4f5fc87ab",
                              fields: {
                                Description: {
                                  value: "Thank You"
                                },
                                Parameters: {
                                  value: "{\"referenceId\":\"{E926A7A2-CB84-4C1D-AB25-B06FB12A5C29}\"}"
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": {
                                      value: "Redirect to page failed!"
                                    },
                                    "Model Type": {
                                      value: "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage"
                                    }
                                  }
                                }
                              },
                              items: []
                            }
                          ]
                        }
                      ]
                    },
                    {
                      id: "e926a7a2-cb84-4c1d-ab25-b06fb12a5c29",
                      name: "thankYouPage",
                      displayName: "Thank You",
                      parentId: "a05e9c5b-6c30-4ac6-8db6-698e8e7294f0",
                      fields: {
                        gaLabel: {
                          value: ""
                        },
                        backgroundColor: {
                          id: "b47928d6-98fc-4b29-8d0f-586ab477286e",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/orangewhite",
                          fields: {
                            value: {
                              value: "orange-white"
                            },
                            key: {
                              value: "OrangeWhite"
                            }
                          }
                        },
                        "Css Class": {
                          value: "phoneSubmitPage darkMode conditionPage"
                        },
                        isHidden: {
                          value: false
                        },
                        HelpText: {
                          value: ""
                        },
                        GeneralError: {
                          value: ""
                        },
                        SpecificError: {
                          value: ""
                        },
                        apiName: null,
                        serverValidationErrorText: {
                          value: ""
                        },
                        serverValidationLoadingText: {
                          value: ""
                        },
                        enableServerValidation: {
                          value: false
                        },
                        serverValidationAPI: null,
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: {
                              value: "Eggplant"
                            },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png"
                            },
                            IsDisabled: {
                              value: false
                            },
                            SpritePosition: {
                              value: ""
                            },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {}
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value: "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms"
                            },
                            "Property Editor": null,
                            "View Path": {
                              value: "FieldTemplates/Page"
                            }
                          }
                        },
                        Conditions: {
                          value: "{\"fieldConditions\":[]}"
                        },
                        "Field Key": {
                          value: "F880144362CB4E118C0EE581A4C3D11C"
                        },
                        "Collapsed by Default": {
                          value: false
                        }
                      },
                      items: [
                        {
                          id: "c4a6f91e-953b-4279-9beb-1a3f1daca586",
                          name: "Text",
                          displayName: "Text",
                          parentId: "e926a7a2-cb84-4c1d-ab25-b06fb12a5c29",
                          fields: {
                            "Html Tag": {
                              value: "p"
                            },
                            Text: {
                              value: "Thank you"
                            },
                            "Css Class": {
                              value: ""
                            },
                            isHidden: {
                              value: false
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: {
                                  value: ""
                                },
                                key: {
                                  value: ""
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: {
                                  value: "Sky"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {}
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Text"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "753703DC08564AD893AFA873A6215A42"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: []
                        },
                        {
                          id: "82f5a615-e6fb-4f3a-8e44-5379fa90956b",
                          name: "TextForEmail",
                          displayName: "TextForEmail",
                          parentId: "e926a7a2-cb84-4c1d-ab25-b06fb12a5c29",
                          fields: {
                            "Html Tag": {
                              value: "p"
                            },
                            Text: {
                              value: "A member from our customer service team will contact you as soon as possible."
                            },
                            "Css Class": {
                              value: ""
                            },
                            isHidden: {
                              value: false
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: {
                                  value: ""
                                },
                                key: {
                                  value: ""
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: {
                                  value: "Sky"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {}
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Text"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "98FB8E4051374455BD89F04F5AAA2D77"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: []
                        },
                        {
                          id: "5cef11b7-0a6f-4b25-b6af-432a290b28ac",
                          name: "backToHome",
                          displayName: "Back to Home",
                          parentId: "e926a7a2-cb84-4c1d-ab25-b06fb12a5c29",
                          fields: {
                            "Navigation Step": {
                              value: "1"
                            },
                            emailTemplateLink: {
                              value: ""
                            },
                            "Css Class": {
                              value: "back-to-home"
                            },
                            isHidden: {
                              value: false
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: {
                                  value: ""
                                },
                                key: {
                                  value: ""
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Label Css Class": {
                              value: ""
                            },
                            Title: {
                              value: "Return to previous page"
                            },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: {
                                  value: "Eggplant"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/button.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {}
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Button"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "1B48EED990F64B8DBA5887B6BCFC9DC5"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: []
                        },
                        {
                          id: "04b3c935-1df8-4081-a55b-4c19fa67a10f",
                          name: "MediaSource",
                          displayName: "MediaSource",
                          parentId: "e926a7a2-cb84-4c1d-ab25-b06fb12a5c29",
                          fields: {
                            "Html Tag": {
                              value: "p"
                            },
                            Text: {
                              value: ""
                            },
                            "Css Class": {
                              value: ""
                            },
                            isHidden: {
                              value: true
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "9966e4e3-f61b-48f4-9958-8eedf4aa3665",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/mediasource",
                              fields: {
                                value: {
                                  value: "mediaSource"
                                },
                                key: {
                                  value: "mediaSource"
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: {
                                  value: "Sky"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {}
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Text"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "3DA1A3628894402E9BE4E5BC3B57C06A"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: []
                        },
                        {
                          id: "8de29a0e-cd6b-4458-8012-8e41ee993ce7",
                          name: "consentMsg",
                          displayName: "consentMsg",
                          parentId: "e926a7a2-cb84-4c1d-ab25-b06fb12a5c29",
                          fields: {
                            "Html Tag": {
                              value: "p"
                            },
                            Text: {
                              value: ""
                            },
                            "Css Class": {
                              value: ""
                            },
                            isHidden: {
                              value: true
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "742c941c-44ec-4e36-878f-6dc28f99baff",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/consentmsg",
                              fields: {
                                value: {
                                  value: "consentMsg"
                                },
                                key: {
                                  value: "consentMsg"
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: {
                                  value: "Sky"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {}
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Text"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "060F06DE197645569C2D4DFF110C6F4A"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: []
                        },
                        {
                          id: "e952e425-a9d7-4e95-8599-86018e29fb71",
                          name: "consentVersionCd",
                          displayName: "consentVersionCd",
                          parentId: "e926a7a2-cb84-4c1d-ab25-b06fb12a5c29",
                          fields: {
                            "Html Tag": {
                              value: "p"
                            },
                            Text: {
                              value: ""
                            },
                            "Css Class": {
                              value: ""
                            },
                            isHidden: {
                              value: true
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "10fc0d1b-f2f0-4007-bcd7-9dc3675741bb",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/consentversioncd",
                              fields: {
                                value: {
                                  value: "consentVersionCd"
                                },
                                key: {
                                  value: "ConsentVersionCd"
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: {
                                  value: "Sky"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {}
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Text"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "8DEBE8307E4048FD97CEBBCC69003314"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: []
                        },
                        {
                          id: "27a5c3b5-e51d-4d9c-84a1-6ed7738a3910",
                          name: "dtcCampaignId",
                          displayName: "dtcCampaignId",
                          parentId: "e926a7a2-cb84-4c1d-ab25-b06fb12a5c29",
                          fields: {
                            "Html Tag": {
                              value: "p"
                            },
                            Text: {
                              value: "dtcCampaign12"
                            },
                            "Css Class": {
                              value: ""
                            },
                            isHidden: {
                              value: true
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "cd19cd7e-4435-4ee7-8e7b-522d7384522b",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/dtccampaignid",
                              fields: {
                                value: {
                                  value: "dTCCampaignId"
                                },
                                key: {
                                  value: "dTCCampaignId"
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: {
                                  value: "Sky"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {}
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Text"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "94CF8FCDD9E2408DB9B317F83F0CC039"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: []
                        },
                        {
                          id: "75618cbc-285f-480a-8144-0ab9cd0d092c",
                          name: "partnerName",
                          displayName: "partnerName",
                          parentId: "e926a7a2-cb84-4c1d-ab25-b06fb12a5c29",
                          fields: {
                            "Html Tag": {
                              value: "p"
                            },
                            Text: {
                              value: "NexGen"
                            },
                            "Css Class": {
                              value: ""
                            },
                            isHidden: {
                              value: true
                            },
                            HelpText: {
                              value: ""
                            },
                            GeneralError: {
                              value: ""
                            },
                            SpecificError: {
                              value: ""
                            },
                            apiName: {
                              id: "865d0d1e-9b62-4e35-af48-f3912b20dd0c",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/partnername",
                              fields: {
                                value: {
                                  value: "partnerName"
                                },
                                key: {
                                  value: "PartnerName"
                                }
                              }
                            },
                            serverValidationErrorText: {
                              value: ""
                            },
                            serverValidationLoadingText: {
                              value: ""
                            },
                            enableServerValidation: {
                              value: false
                            },
                            serverValidationAPI: null,
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: {
                                  value: "Sky"
                                },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png"
                                },
                                IsDisabled: {
                                  value: false
                                },
                                SpritePosition: {
                                  value: ""
                                },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {}
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value: "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms"
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Text"
                                }
                              }
                            },
                            Conditions: {
                              value: "{\"fieldConditions\":[]}"
                            },
                            "Field Key": {
                              value: "49685C5ED7494EF9A73C8BEB81B082B7"
                            },
                            "Collapsed by Default": {
                              value: false
                            }
                          },
                          items: []
                        }
                      ]
                    }
                  ]
                }
              }
            ],
            "jss-footer": []
          }
        }
      }
    }
  }

};
